import { coinWithBalance, Transaction } from '@mysten/sui/transactions';
import JSONbig from 'json-bigint';
import { normalizeSuiObjectId, SUI_CLOCK_OBJECT_ID } from '@mysten/sui/utils';
import { SuiGrpcClient } from '@mysten/sui/grpc';
import { HermesClient } from '@pythnetwork/hermes-client';
import { bcs } from '@mysten/sui/bcs';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod2) => function __require2() {
  return mod2 || (0, cb[__getOwnPropNames(cb)[0]])((mod2 = { exports: {} }).exports, mod2), mod2.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod2, isNodeMode, target) => (target = mod2 != null ? __create(__getProtoOf(mod2)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  __defProp(target, "default", { value: mod2, enumerable: true }) ,
  mod2
));

// node_modules/bn.js/lib/bn.js
var require_bn = __commonJS({
  "node_modules/bn.js/lib/bn.js"(exports, module) {
    (function(module2, exports2) {
      function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
      }
      function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {
        };
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      }
      function BN7(number, base, endian) {
        if (BN7.isBN(number)) {
          return number;
        }
        this.negative = 0;
        this.words = null;
        this.length = 0;
        this.red = null;
        if (number !== null) {
          if (base === "le" || base === "be") {
            endian = base;
            base = 10;
          }
          this._init(number || 0, base || 10, endian || "be");
        }
      }
      if (typeof module2 === "object") {
        module2.exports = BN7;
      } else {
        exports2.BN = BN7;
      }
      BN7.BN = BN7;
      BN7.wordSize = 26;
      var Buffer2;
      try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") {
          Buffer2 = window.Buffer;
        } else {
          Buffer2 = __require("buffer").Buffer;
        }
      } catch (e) {
      }
      BN7.isBN = function isBN(num) {
        if (num instanceof BN7) {
          return true;
        }
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN7.wordSize && Array.isArray(num.words);
      };
      BN7.max = function max2(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
      };
      BN7.min = function min2(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
      };
      BN7.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") {
          return this._initNumber(number, base, endian);
        }
        if (typeof number === "object") {
          return this._initArray(number, base, endian);
        }
        if (base === "hex") {
          base = 16;
        }
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
          start++;
          this.negative = 1;
        }
        if (start < number.length) {
          if (base === 16) {
            this._parseHex(number, start, endian);
          } else {
            this._parseBase(number, base, start);
            if (endian === "le") {
              this._initArray(this.toArray(), base, endian);
            }
          }
        }
      };
      BN7.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
          this.negative = 1;
          number = -number;
        }
        if (number < 67108864) {
          this.words = [number & 67108863];
          this.length = 1;
        } else if (number < 4503599627370496) {
          this.words = [
            number & 67108863,
            number / 67108864 & 67108863
          ];
          this.length = 2;
        } else {
          assert(number < 9007199254740992);
          this.words = [
            number & 67108863,
            number / 67108864 & 67108863,
            1
          ];
          this.length = 3;
        }
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
      };
      BN7.prototype._initArray = function _initArray(number, base, endian) {
        assert(typeof number.length === "number");
        if (number.length <= 0) {
          this.words = [0];
          this.length = 1;
          return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          this.words[i] = 0;
        }
        var j, w;
        var off = 0;
        if (endian === "be") {
          for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 67108863;
            this.words[j + 1] = w >>> 26 - off & 67108863;
            off += 24;
            if (off >= 26) {
              off -= 26;
              j++;
            }
          }
        } else if (endian === "le") {
          for (i = 0, j = 0; i < number.length; i += 3) {
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 67108863;
            this.words[j + 1] = w >>> 26 - off & 67108863;
            off += 24;
            if (off >= 26) {
              off -= 26;
              j++;
            }
          }
        }
        return this._strip();
      };
      function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        if (c >= 48 && c <= 57) {
          return c - 48;
        } else if (c >= 65 && c <= 70) {
          return c - 55;
        } else if (c >= 97 && c <= 102) {
          return c - 87;
        } else {
          assert(false, "Invalid character in " + string);
        }
      }
      function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) {
          r |= parseHex4Bits(string, index - 1) << 4;
        }
        return r;
      }
      BN7.prototype._parseHex = function _parseHex(number, start, endian) {
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          this.words[i] = 0;
        }
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") {
          for (i = number.length - 1; i >= start; i -= 2) {
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 67108863;
            if (off >= 18) {
              off -= 18;
              j += 1;
              this.words[j] |= w >>> 26;
            } else {
              off += 8;
            }
          }
        } else {
          var parseLength = number.length - start;
          for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 67108863;
            if (off >= 18) {
              off -= 18;
              j += 1;
              this.words[j] |= w >>> 26;
            } else {
              off += 8;
            }
          }
        }
        this._strip();
      };
      function parseBase(str, start, end, mul2) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for (var i = start; i < len; i++) {
          var c = str.charCodeAt(i) - 48;
          r *= mul2;
          if (c >= 49) {
            b = c - 49 + 10;
          } else if (c >= 17) {
            b = c - 17 + 10;
          } else {
            b = c;
          }
          assert(c >= 0 && b < mul2, "Invalid character");
          r += b;
        }
        return r;
      }
      BN7.prototype._parseBase = function _parseBase(number, base, start) {
        this.words = [0];
        this.length = 1;
        for (var limbLen = 0, limbPow = 1; limbPow <= 67108863; limbPow *= base) {
          limbLen++;
        }
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod2 = total % limbLen;
        var end = Math.min(total, total - mod2) + start;
        var word = 0;
        for (var i = start; i < end; i += limbLen) {
          word = parseBase(number, i, i + limbLen, base);
          this.imuln(limbPow);
          if (this.words[0] + word < 67108864) {
            this.words[0] += word;
          } else {
            this._iaddn(word);
          }
        }
        if (mod2 !== 0) {
          var pow2 = 1;
          word = parseBase(number, i, number.length, base);
          for (i = 0; i < mod2; i++) {
            pow2 *= base;
          }
          this.imuln(pow2);
          if (this.words[0] + word < 67108864) {
            this.words[0] += word;
          } else {
            this._iaddn(word);
          }
        }
        this._strip();
      };
      BN7.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for (var i = 0; i < this.length; i++) {
          dest.words[i] = this.words[i];
        }
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
      };
      function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
      }
      BN7.prototype._move = function _move(dest) {
        move(dest, this);
      };
      BN7.prototype.clone = function clone2() {
        var r = new BN7(null);
        this.copy(r);
        return r;
      };
      BN7.prototype._expand = function _expand(size) {
        while (this.length < size) {
          this.words[this.length++] = 0;
        }
        return this;
      };
      BN7.prototype._strip = function strip() {
        while (this.length > 1 && this.words[this.length - 1] === 0) {
          this.length--;
        }
        return this._normSign();
      };
      BN7.prototype._normSign = function _normSign() {
        if (this.length === 1 && this.words[0] === 0) {
          this.negative = 0;
        }
        return this;
      };
      if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") {
        try {
          BN7.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
        } catch (e) {
          BN7.prototype.inspect = inspect;
        }
      } else {
        BN7.prototype.inspect = inspect;
      }
      function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ];
      var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ];
      var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      BN7.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
          out = "";
          var off = 0;
          var carry = 0;
          for (var i = 0; i < this.length; i++) {
            var w = this.words[i];
            var word = ((w << off | carry) & 16777215).toString(16);
            carry = w >>> 24 - off & 16777215;
            off += 2;
            if (off >= 26) {
              off -= 26;
              i--;
            }
            if (carry !== 0 || i !== this.length - 1) {
              out = zeros[6 - word.length] + word + out;
            } else {
              out = word + out;
            }
          }
          if (carry !== 0) {
            out = carry.toString(16) + out;
          }
          while (out.length % padding !== 0) {
            out = "0" + out;
          }
          if (this.negative !== 0) {
            out = "-" + out;
          }
          return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
          var groupSize = groupSizes[base];
          var groupBase = groupBases[base];
          out = "";
          var c = this.clone();
          c.negative = 0;
          while (!c.isZero()) {
            var r = c.modrn(groupBase).toString(base);
            c = c.idivn(groupBase);
            if (!c.isZero()) {
              out = zeros[groupSize - r.length] + r + out;
            } else {
              out = r + out;
            }
          }
          if (this.isZero()) {
            out = "0" + out;
          }
          while (out.length % padding !== 0) {
            out = "0" + out;
          }
          if (this.negative !== 0) {
            out = "-" + out;
          }
          return out;
        }
        assert(false, "Base should be between 2 and 36");
      };
      BN7.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) {
          ret += this.words[1] * 67108864;
        } else if (this.length === 3 && this.words[2] === 1) {
          ret += 4503599627370496 + this.words[1] * 67108864;
        } else if (this.length > 2) {
          assert(false, "Number can only safely store up to 53 bits");
        }
        return this.negative !== 0 ? -ret : ret;
      };
      BN7.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
      };
      if (Buffer2) {
        BN7.prototype.toBuffer = function toBuffer(endian, length) {
          return this.toArrayLike(Buffer2, endian, length);
        };
      }
      BN7.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
      };
      var allocate = function allocate2(ArrayType, size) {
        if (ArrayType.allocUnsafe) {
          return ArrayType.allocUnsafe(size);
        }
        return new ArrayType(size);
      };
      BN7.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
      };
      BN7.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for (var i = 0, shift = 0; i < this.length; i++) {
          var word = this.words[i] << shift | carry;
          res[position++] = word & 255;
          if (position < res.length) {
            res[position++] = word >> 8 & 255;
          }
          if (position < res.length) {
            res[position++] = word >> 16 & 255;
          }
          if (shift === 6) {
            if (position < res.length) {
              res[position++] = word >> 24 & 255;
            }
            carry = 0;
            shift = 0;
          } else {
            carry = word >>> 24;
            shift += 2;
          }
        }
        if (position < res.length) {
          res[position++] = carry;
          while (position < res.length) {
            res[position++] = 0;
          }
        }
      };
      BN7.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for (var i = 0, shift = 0; i < this.length; i++) {
          var word = this.words[i] << shift | carry;
          res[position--] = word & 255;
          if (position >= 0) {
            res[position--] = word >> 8 & 255;
          }
          if (position >= 0) {
            res[position--] = word >> 16 & 255;
          }
          if (shift === 6) {
            if (position >= 0) {
              res[position--] = word >> 24 & 255;
            }
            carry = 0;
            shift = 0;
          } else {
            carry = word >>> 24;
            shift += 2;
          }
        }
        if (position >= 0) {
          res[position--] = carry;
          while (position >= 0) {
            res[position--] = 0;
          }
        }
      };
      if (Math.clz32) {
        BN7.prototype._countBits = function _countBits(w) {
          return 32 - Math.clz32(w);
        };
      } else {
        BN7.prototype._countBits = function _countBits(w) {
          var t = w;
          var r = 0;
          if (t >= 4096) {
            r += 13;
            t >>>= 13;
          }
          if (t >= 64) {
            r += 7;
            t >>>= 7;
          }
          if (t >= 8) {
            r += 4;
            t >>>= 4;
          }
          if (t >= 2) {
            r += 2;
            t >>>= 2;
          }
          return r + t;
        };
      }
      BN7.prototype._zeroBits = function _zeroBits(w) {
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 8191) === 0) {
          r += 13;
          t >>>= 13;
        }
        if ((t & 127) === 0) {
          r += 7;
          t >>>= 7;
        }
        if ((t & 15) === 0) {
          r += 4;
          t >>>= 4;
        }
        if ((t & 3) === 0) {
          r += 2;
          t >>>= 2;
        }
        if ((t & 1) === 0) {
          r++;
        }
        return r;
      };
      BN7.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
      };
      function toBitArray(num) {
        var w = new Array(num.bitLength());
        for (var bit = 0; bit < w.length; bit++) {
          var off = bit / 26 | 0;
          var wbit = bit % 26;
          w[bit] = num.words[off] >>> wbit & 1;
        }
        return w;
      }
      BN7.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for (var i = 0; i < this.length; i++) {
          var b = this._zeroBits(this.words[i]);
          r += b;
          if (b !== 26) break;
        }
        return r;
      };
      BN7.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
      };
      BN7.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) {
          return this.abs().inotn(width).iaddn(1);
        }
        return this.clone();
      };
      BN7.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) {
          return this.notn(width).iaddn(1).ineg();
        }
        return this.clone();
      };
      BN7.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
      };
      BN7.prototype.neg = function neg() {
        return this.clone().ineg();
      };
      BN7.prototype.ineg = function ineg() {
        if (!this.isZero()) {
          this.negative ^= 1;
        }
        return this;
      };
      BN7.prototype.iuor = function iuor(num) {
        while (this.length < num.length) {
          this.words[this.length++] = 0;
        }
        for (var i = 0; i < num.length; i++) {
          this.words[i] = this.words[i] | num.words[i];
        }
        return this._strip();
      };
      BN7.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
      };
      BN7.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
      };
      BN7.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
      };
      BN7.prototype.iuand = function iuand(num) {
        var b;
        if (this.length > num.length) {
          b = num;
        } else {
          b = this;
        }
        for (var i = 0; i < b.length; i++) {
          this.words[i] = this.words[i] & num.words[i];
        }
        this.length = b.length;
        return this._strip();
      };
      BN7.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
      };
      BN7.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
      };
      BN7.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
      };
      BN7.prototype.iuxor = function iuxor(num) {
        var a;
        var b;
        if (this.length > num.length) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        for (var i = 0; i < b.length; i++) {
          this.words[i] = a.words[i] ^ b.words[i];
        }
        if (this !== a) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        this.length = a.length;
        return this._strip();
      };
      BN7.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
      };
      BN7.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
      };
      BN7.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
      };
      BN7.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        this._expand(bytesNeeded);
        if (bitsLeft > 0) {
          bytesNeeded--;
        }
        for (var i = 0; i < bytesNeeded; i++) {
          this.words[i] = ~this.words[i] & 67108863;
        }
        if (bitsLeft > 0) {
          this.words[i] = ~this.words[i] & 67108863 >> 26 - bitsLeft;
        }
        return this._strip();
      };
      BN7.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
      };
      BN7.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) {
          this.words[off] = this.words[off] | 1 << wbit;
        } else {
          this.words[off] = this.words[off] & ~(1 << wbit);
        }
        return this._strip();
      };
      BN7.prototype.iadd = function iadd(num) {
        var r;
        if (this.negative !== 0 && num.negative === 0) {
          this.negative = 0;
          r = this.isub(num);
          this.negative ^= 1;
          return this._normSign();
        } else if (this.negative === 0 && num.negative !== 0) {
          num.negative = 0;
          r = this.isub(num);
          num.negative = 1;
          return r._normSign();
        }
        var a, b;
        if (this.length > num.length) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        var carry = 0;
        for (var i = 0; i < b.length; i++) {
          r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
          this.words[i] = r & 67108863;
          carry = r >>> 26;
        }
        for (; carry !== 0 && i < a.length; i++) {
          r = (a.words[i] | 0) + carry;
          this.words[i] = r & 67108863;
          carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
          this.words[this.length] = carry;
          this.length++;
        } else if (a !== this) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        return this;
      };
      BN7.prototype.add = function add2(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
          num.negative = 0;
          res = this.sub(num);
          num.negative ^= 1;
          return res;
        } else if (num.negative === 0 && this.negative !== 0) {
          this.negative = 0;
          res = num.sub(this);
          this.negative = 1;
          return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
      };
      BN7.prototype.isub = function isub(num) {
        if (num.negative !== 0) {
          num.negative = 0;
          var r = this.iadd(num);
          num.negative = 1;
          return r._normSign();
        } else if (this.negative !== 0) {
          this.negative = 0;
          this.iadd(num);
          this.negative = 1;
          return this._normSign();
        }
        var cmp2 = this.cmp(num);
        if (cmp2 === 0) {
          this.negative = 0;
          this.length = 1;
          this.words[0] = 0;
          return this;
        }
        var a, b;
        if (cmp2 > 0) {
          a = this;
          b = num;
        } else {
          a = num;
          b = this;
        }
        var carry = 0;
        for (var i = 0; i < b.length; i++) {
          r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
          carry = r >> 26;
          this.words[i] = r & 67108863;
        }
        for (; carry !== 0 && i < a.length; i++) {
          r = (a.words[i] | 0) + carry;
          carry = r >> 26;
          this.words[i] = r & 67108863;
        }
        if (carry === 0 && i < a.length && a !== this) {
          for (; i < a.length; i++) {
            this.words[i] = a.words[i];
          }
        }
        this.length = Math.max(this.length, i);
        if (a !== this) {
          this.negative = 1;
        }
        return this._strip();
      };
      BN7.prototype.sub = function sub2(num) {
        return this.clone().isub(num);
      };
      function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 67108863;
        var carry = r / 67108864 | 0;
        out.words[0] = lo;
        for (var k = 1; k < len; k++) {
          var ncarry = carry >>> 26;
          var rword = carry & 67108863;
          var maxJ = Math.min(k, num.length - 1);
          for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
            var i = k - j | 0;
            a = self.words[i] | 0;
            b = num.words[j] | 0;
            r = a * b + rword;
            ncarry += r / 67108864 | 0;
            rword = r & 67108863;
          }
          out.words[k] = rword | 0;
          carry = ncarry | 0;
        }
        if (carry !== 0) {
          out.words[k] = carry | 0;
        } else {
          out.length--;
        }
        return out._strip();
      }
      var comb10MulTo = function comb10MulTo2(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 8191;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 8191;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 8191;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 8191;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 8191;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 8191;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 8191;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 8191;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 8191;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 8191;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 8191;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 8191;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 8191;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 8191;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 8191;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 8191;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 8191;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 8191;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 8191;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 8191;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 67108863;
        lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 67108863;
        lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 67108863;
        lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 67108863;
        lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 67108863;
        lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 67108863;
        lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 67108863;
        lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 67108863;
        lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 67108863;
        lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 67108863;
        lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 67108863;
        lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 67108863;
        lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 67108863;
        lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 67108863;
        lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 67108863;
        lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 67108863;
        lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 67108863;
        lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 67108863;
        lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 67108863;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
          o[19] = c;
          out.length++;
        }
        return out;
      };
      if (!Math.imul) {
        comb10MulTo = smallMulTo;
      }
      function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for (var k = 0; k < out.length - 1; k++) {
          var ncarry = hncarry;
          hncarry = 0;
          var rword = carry & 67108863;
          var maxJ = Math.min(k, num.length - 1);
          for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
            var i = k - j;
            var a = self.words[i] | 0;
            var b = num.words[j] | 0;
            var r = a * b;
            var lo = r & 67108863;
            ncarry = ncarry + (r / 67108864 | 0) | 0;
            lo = lo + rword | 0;
            rword = lo & 67108863;
            ncarry = ncarry + (lo >>> 26) | 0;
            hncarry += ncarry >>> 26;
            ncarry &= 67108863;
          }
          out.words[k] = rword;
          carry = ncarry;
          ncarry = hncarry;
        }
        if (carry !== 0) {
          out.words[k] = carry;
        } else {
          out.length--;
        }
        return out._strip();
      }
      function jumboMulTo(self, num, out) {
        return bigMulTo(self, num, out);
      }
      BN7.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) {
          res = comb10MulTo(this, num, out);
        } else if (len < 63) {
          res = smallMulTo(this, num, out);
        } else if (len < 1024) {
          res = bigMulTo(this, num, out);
        } else {
          res = jumboMulTo(this, num, out);
        }
        return res;
      };
      BN7.prototype.mul = function mul2(num) {
        var out = new BN7(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
      };
      BN7.prototype.mulf = function mulf(num) {
        var out = new BN7(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
      };
      BN7.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
      };
      BN7.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 67108864);
        var carry = 0;
        for (var i = 0; i < this.length; i++) {
          var w = (this.words[i] | 0) * num;
          var lo = (w & 67108863) + (carry & 67108863);
          carry >>= 26;
          carry += w / 67108864 | 0;
          carry += lo >>> 26;
          this.words[i] = lo & 67108863;
        }
        if (carry !== 0) {
          this.words[i] = carry;
          this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
      };
      BN7.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
      };
      BN7.prototype.sqr = function sqr() {
        return this.mul(this);
      };
      BN7.prototype.isqr = function isqr() {
        return this.imul(this.clone());
      };
      BN7.prototype.pow = function pow2(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN7(1);
        var res = this;
        for (var i = 0; i < w.length; i++, res = res.sqr()) {
          if (w[i] !== 0) break;
        }
        if (++i < w.length) {
          for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
            if (w[i] === 0) continue;
            res = res.mul(q);
          }
        }
        return res;
      };
      BN7.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 67108863 >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
          var carry = 0;
          for (i = 0; i < this.length; i++) {
            var newCarry = this.words[i] & carryMask;
            var c = (this.words[i] | 0) - newCarry << r;
            this.words[i] = c | carry;
            carry = newCarry >>> 26 - r;
          }
          if (carry) {
            this.words[i] = carry;
            this.length++;
          }
        }
        if (s !== 0) {
          for (i = this.length - 1; i >= 0; i--) {
            this.words[i + s] = this.words[i];
          }
          for (i = 0; i < s; i++) {
            this.words[i] = 0;
          }
          this.length += s;
        }
        return this._strip();
      };
      BN7.prototype.ishln = function ishln(bits) {
        assert(this.negative === 0);
        return this.iushln(bits);
      };
      BN7.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) {
          h = (hint - hint % 26) / 26;
        } else {
          h = 0;
        }
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 67108863 ^ 67108863 >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        if (maskedWords) {
          for (var i = 0; i < s; i++) {
            maskedWords.words[i] = this.words[i];
          }
          maskedWords.length = s;
        }
        if (s === 0) ; else if (this.length > s) {
          this.length -= s;
          for (i = 0; i < this.length; i++) {
            this.words[i] = this.words[i + s];
          }
        } else {
          this.words[0] = 0;
          this.length = 1;
        }
        var carry = 0;
        for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
          var word = this.words[i] | 0;
          this.words[i] = carry << 26 - r | word >>> r;
          carry = word & mask;
        }
        if (maskedWords && carry !== 0) {
          maskedWords.words[maskedWords.length++] = carry;
        }
        if (this.length === 0) {
          this.words[0] = 0;
          this.length = 1;
        }
        return this._strip();
      };
      BN7.prototype.ishrn = function ishrn(bits, hint, extended) {
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
      };
      BN7.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
      };
      BN7.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
      };
      BN7.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
      };
      BN7.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
      };
      BN7.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        if (this.length <= s) return false;
        var w = this.words[s];
        return !!(w & q);
      };
      BN7.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) {
          return this;
        }
        if (r !== 0) {
          s++;
        }
        this.length = Math.min(s, this.length);
        if (r !== 0) {
          var mask = 67108863 ^ 67108863 >>> r << r;
          this.words[this.length - 1] &= mask;
        }
        return this._strip();
      };
      BN7.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
      };
      BN7.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 67108864);
        if (num < 0) return this.isubn(-num);
        if (this.negative !== 0) {
          if (this.length === 1 && (this.words[0] | 0) <= num) {
            this.words[0] = num - (this.words[0] | 0);
            this.negative = 0;
            return this;
          }
          this.negative = 0;
          this.isubn(num);
          this.negative = 1;
          return this;
        }
        return this._iaddn(num);
      };
      BN7.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        for (var i = 0; i < this.length && this.words[i] >= 67108864; i++) {
          this.words[i] -= 67108864;
          if (i === this.length - 1) {
            this.words[i + 1] = 1;
          } else {
            this.words[i + 1]++;
          }
        }
        this.length = Math.max(this.length, i + 1);
        return this;
      };
      BN7.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 67108864);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
          this.negative = 0;
          this.iaddn(num);
          this.negative = 1;
          return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
          this.words[0] = -this.words[0];
          this.negative = 1;
        } else {
          for (var i = 0; i < this.length && this.words[i] < 0; i++) {
            this.words[i] += 67108864;
            this.words[i + 1] -= 1;
          }
        }
        return this._strip();
      };
      BN7.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
      };
      BN7.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
      };
      BN7.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
      };
      BN7.prototype.abs = function abs2() {
        return this.clone().iabs();
      };
      BN7.prototype._ishlnsubmul = function _ishlnsubmul(num, mul2, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for (i = 0; i < num.length; i++) {
          w = (this.words[i + shift] | 0) + carry;
          var right = (num.words[i] | 0) * mul2;
          w -= right & 67108863;
          carry = (w >> 26) - (right / 67108864 | 0);
          this.words[i + shift] = w & 67108863;
        }
        for (; i < this.length - shift; i++) {
          w = (this.words[i + shift] | 0) + carry;
          carry = w >> 26;
          this.words[i + shift] = w & 67108863;
        }
        if (carry === 0) return this._strip();
        assert(carry === -1);
        carry = 0;
        for (i = 0; i < this.length; i++) {
          w = -(this.words[i] | 0) + carry;
          carry = w >> 26;
          this.words[i] = w & 67108863;
        }
        this.negative = 1;
        return this._strip();
      };
      BN7.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
          b = b.ushln(shift);
          a.iushln(shift);
          bhi = b.words[b.length - 1] | 0;
        }
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
          q = new BN7(null);
          q.length = m + 1;
          q.words = new Array(q.length);
          for (var i = 0; i < q.length; i++) {
            q.words[i] = 0;
          }
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
          a = diff;
          if (q) {
            q.words[m] = 1;
          }
        }
        for (var j = m - 1; j >= 0; j--) {
          var qj = (a.words[b.length + j] | 0) * 67108864 + (a.words[b.length + j - 1] | 0);
          qj = Math.min(qj / bhi | 0, 67108863);
          a._ishlnsubmul(b, qj, j);
          while (a.negative !== 0) {
            qj--;
            a.negative = 0;
            a._ishlnsubmul(b, 1, j);
            if (!a.isZero()) {
              a.negative ^= 1;
            }
          }
          if (q) {
            q.words[j] = qj;
          }
        }
        if (q) {
          q._strip();
        }
        a._strip();
        if (mode !== "div" && shift !== 0) {
          a.iushrn(shift);
        }
        return {
          div: q || null,
          mod: a
        };
      };
      BN7.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) {
          return {
            div: new BN7(0),
            mod: new BN7(0)
          };
        }
        var div2, mod2, res;
        if (this.negative !== 0 && num.negative === 0) {
          res = this.neg().divmod(num, mode);
          if (mode !== "mod") {
            div2 = res.div.neg();
          }
          if (mode !== "div") {
            mod2 = res.mod.neg();
            if (positive && mod2.negative !== 0) {
              mod2.iadd(num);
            }
          }
          return {
            div: div2,
            mod: mod2
          };
        }
        if (this.negative === 0 && num.negative !== 0) {
          res = this.divmod(num.neg(), mode);
          if (mode !== "mod") {
            div2 = res.div.neg();
          }
          return {
            div: div2,
            mod: res.mod
          };
        }
        if ((this.negative & num.negative) !== 0) {
          res = this.neg().divmod(num.neg(), mode);
          if (mode !== "div") {
            mod2 = res.mod.neg();
            if (positive && mod2.negative !== 0) {
              mod2.isub(num);
            }
          }
          return {
            div: res.div,
            mod: mod2
          };
        }
        if (num.length > this.length || this.cmp(num) < 0) {
          return {
            div: new BN7(0),
            mod: this
          };
        }
        if (num.length === 1) {
          if (mode === "div") {
            return {
              div: this.divn(num.words[0]),
              mod: null
            };
          }
          if (mode === "mod") {
            return {
              div: null,
              mod: new BN7(this.modrn(num.words[0]))
            };
          }
          return {
            div: this.divn(num.words[0]),
            mod: new BN7(this.modrn(num.words[0]))
          };
        }
        return this._wordDiv(num, mode);
      };
      BN7.prototype.div = function div2(num) {
        return this.divmod(num, "div", false).div;
      };
      BN7.prototype.mod = function mod2(num) {
        return this.divmod(num, "mod", false).mod;
      };
      BN7.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
      };
      BN7.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        if (dm.mod.isZero()) return dm.div;
        var mod2 = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp2 = mod2.cmp(half);
        if (cmp2 < 0 || r2 === 1 && cmp2 === 0) return dm.div;
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
      };
      BN7.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 67108863);
        var p = (1 << 26) % num;
        var acc = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          acc = (p * acc + (this.words[i] | 0)) % num;
        }
        return isNegNum ? -acc : acc;
      };
      BN7.prototype.modn = function modn(num) {
        return this.modrn(num);
      };
      BN7.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 67108863);
        var carry = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          var w = (this.words[i] | 0) + carry * 67108864;
          this.words[i] = w / num | 0;
          carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
      };
      BN7.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
      };
      BN7.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) {
          x = x.umod(p);
        } else {
          x = x.clone();
        }
        var A = new BN7(1);
        var B = new BN7(0);
        var C = new BN7(0);
        var D = new BN7(1);
        var g = 0;
        while (x.isEven() && y.isEven()) {
          x.iushrn(1);
          y.iushrn(1);
          ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while (!x.isZero()) {
          for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1) ;
          if (i > 0) {
            x.iushrn(i);
            while (i-- > 0) {
              if (A.isOdd() || B.isOdd()) {
                A.iadd(yp);
                B.isub(xp);
              }
              A.iushrn(1);
              B.iushrn(1);
            }
          }
          for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1) ;
          if (j > 0) {
            y.iushrn(j);
            while (j-- > 0) {
              if (C.isOdd() || D.isOdd()) {
                C.iadd(yp);
                D.isub(xp);
              }
              C.iushrn(1);
              D.iushrn(1);
            }
          }
          if (x.cmp(y) >= 0) {
            x.isub(y);
            A.isub(C);
            B.isub(D);
          } else {
            y.isub(x);
            C.isub(A);
            D.isub(B);
          }
        }
        return {
          a: C,
          b: D,
          gcd: y.iushln(g)
        };
      };
      BN7.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) {
          a = a.umod(p);
        } else {
          a = a.clone();
        }
        var x1 = new BN7(1);
        var x2 = new BN7(0);
        var delta = b.clone();
        while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
          for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1) ;
          if (i > 0) {
            a.iushrn(i);
            while (i-- > 0) {
              if (x1.isOdd()) {
                x1.iadd(delta);
              }
              x1.iushrn(1);
            }
          }
          for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1) ;
          if (j > 0) {
            b.iushrn(j);
            while (j-- > 0) {
              if (x2.isOdd()) {
                x2.iadd(delta);
              }
              x2.iushrn(1);
            }
          }
          if (a.cmp(b) >= 0) {
            a.isub(b);
            x1.isub(x2);
          } else {
            b.isub(a);
            x2.isub(x1);
          }
        }
        var res;
        if (a.cmpn(1) === 0) {
          res = x1;
        } else {
          res = x2;
        }
        if (res.cmpn(0) < 0) {
          res.iadd(p);
        }
        return res;
      };
      BN7.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        for (var shift = 0; a.isEven() && b.isEven(); shift++) {
          a.iushrn(1);
          b.iushrn(1);
        }
        do {
          while (a.isEven()) {
            a.iushrn(1);
          }
          while (b.isEven()) {
            b.iushrn(1);
          }
          var r = a.cmp(b);
          if (r < 0) {
            var t = a;
            a = b;
            b = t;
          } else if (r === 0 || b.cmpn(1) === 0) {
            break;
          }
          a.isub(b);
        } while (true);
        return b.iushln(shift);
      };
      BN7.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
      };
      BN7.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
      };
      BN7.prototype.isOdd = function isOdd2() {
        return (this.words[0] & 1) === 1;
      };
      BN7.prototype.andln = function andln(num) {
        return this.words[0] & num;
      };
      BN7.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        if (this.length <= s) {
          this._expand(s + 1);
          this.words[s] |= q;
          return this;
        }
        var carry = q;
        for (var i = s; carry !== 0 && i < this.length; i++) {
          var w = this.words[i] | 0;
          w += carry;
          carry = w >>> 26;
          w &= 67108863;
          this.words[i] = w;
        }
        if (carry !== 0) {
          this.words[i] = carry;
          this.length++;
        }
        return this;
      };
      BN7.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
      };
      BN7.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) {
          res = 1;
        } else {
          if (negative) {
            num = -num;
          }
          assert(num <= 67108863, "Number is too big");
          var w = this.words[0] | 0;
          res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
      };
      BN7.prototype.cmp = function cmp2(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
      };
      BN7.prototype.ucmp = function ucmp(num) {
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for (var i = this.length - 1; i >= 0; i--) {
          var a = this.words[i] | 0;
          var b = num.words[i] | 0;
          if (a === b) continue;
          if (a < b) {
            res = -1;
          } else if (a > b) {
            res = 1;
          }
          break;
        }
        return res;
      };
      BN7.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
      };
      BN7.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
      };
      BN7.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
      };
      BN7.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
      };
      BN7.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
      };
      BN7.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
      };
      BN7.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
      };
      BN7.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
      };
      BN7.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
      };
      BN7.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
      };
      BN7.red = function red(num) {
        return new Red(num);
      };
      BN7.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
      };
      BN7.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
      };
      BN7.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
      };
      BN7.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
      };
      BN7.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
      };
      BN7.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
      };
      BN7.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
      };
      BN7.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
      };
      BN7.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
      };
      BN7.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
      };
      BN7.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
      };
      BN7.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
      };
      BN7.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
      };
      BN7.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
      };
      BN7.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
      };
      BN7.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
      };
      BN7.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
      };
      var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function MPrime(name, p) {
        this.name = name;
        this.p = new BN7(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN7(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
      }
      MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN7(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
      };
      MPrime.prototype.ireduce = function ireduce(num) {
        var r = num;
        var rlen;
        do {
          this.split(r, this.tmp);
          r = this.imulK(r);
          r = r.iadd(this.tmp);
          rlen = r.bitLength();
        } while (rlen > this.n);
        var cmp2 = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp2 === 0) {
          r.words[0] = 0;
          r.length = 1;
        } else if (cmp2 > 0) {
          r.isub(this.p);
        } else {
          if (r.strip !== void 0) {
            r.strip();
          } else {
            r._strip();
          }
        }
        return r;
      };
      MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
      };
      MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
      };
      function K256() {
        MPrime.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      inherits(K256, MPrime);
      K256.prototype.split = function split(input, output) {
        var mask = 4194303;
        var outLen = Math.min(input.length, 9);
        for (var i = 0; i < outLen; i++) {
          output.words[i] = input.words[i];
        }
        output.length = outLen;
        if (input.length <= 9) {
          input.words[0] = 0;
          input.length = 1;
          return;
        }
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for (i = 10; i < input.length; i++) {
          var next = input.words[i] | 0;
          input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
          prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) {
          input.length -= 10;
        } else {
          input.length -= 9;
        }
      };
      K256.prototype.imulK = function imulK(num) {
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        var lo = 0;
        for (var i = 0; i < num.length; i++) {
          var w = num.words[i] | 0;
          lo += w * 977;
          num.words[i] = lo & 67108863;
          lo = w * 64 + (lo / 67108864 | 0);
        }
        if (num.words[num.length - 1] === 0) {
          num.length--;
          if (num.words[num.length - 1] === 0) {
            num.length--;
          }
        }
        return num;
      };
      function P224() {
        MPrime.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      inherits(P224, MPrime);
      function P192() {
        MPrime.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      inherits(P192, MPrime);
      function P25519() {
        MPrime.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      inherits(P25519, MPrime);
      P25519.prototype.imulK = function imulK(num) {
        var carry = 0;
        for (var i = 0; i < num.length; i++) {
          var hi = (num.words[i] | 0) * 19 + carry;
          var lo = hi & 67108863;
          hi >>>= 26;
          num.words[i] = lo;
          carry = hi;
        }
        if (carry !== 0) {
          num.words[num.length++] = carry;
        }
        return num;
      };
      BN7._prime = function prime(name) {
        if (primes[name]) return primes[name];
        var prime2;
        if (name === "k256") {
          prime2 = new K256();
        } else if (name === "p224") {
          prime2 = new P224();
        } else if (name === "p192") {
          prime2 = new P192();
        } else if (name === "p25519") {
          prime2 = new P25519();
        } else {
          throw new Error("Unknown prime " + name);
        }
        primes[name] = prime2;
        return prime2;
      };
      function Red(m) {
        if (typeof m === "string") {
          var prime = BN7._prime(m);
          this.m = prime.p;
          this.prime = prime;
        } else {
          assert(m.gtn(1), "modulus must be greater than 1");
          this.m = m;
          this.prime = null;
        }
      }
      Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
      };
      Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(
          a.red && a.red === b.red,
          "red works only with red numbers"
        );
      };
      Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
      };
      Red.prototype.neg = function neg(a) {
        if (a.isZero()) {
          return a.clone();
        }
        return this.m.sub(a)._forceRed(this);
      };
      Red.prototype.add = function add2(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) {
          res.isub(this.m);
        }
        return res._forceRed(this);
      };
      Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) {
          res.isub(this.m);
        }
        return res;
      };
      Red.prototype.sub = function sub2(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) {
          res.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) {
          res.iadd(this.m);
        }
        return res;
      };
      Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
      };
      Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
      };
      Red.prototype.mul = function mul2(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
      };
      Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
      };
      Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
      };
      Red.prototype.sqrt = function sqrt2(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        if (mod3 === 3) {
          var pow2 = this.m.add(new BN7(1)).iushrn(2);
          return this.pow(a, pow2);
        }
        var q = this.m.subn(1);
        var s = 0;
        while (!q.isZero() && q.andln(1) === 0) {
          s++;
          q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN7(1).toRed(this);
        var nOne = one.redNeg();
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN7(2 * z * z).toRed(this);
        while (this.pow(z, lpow).cmp(nOne) !== 0) {
          z.redIAdd(nOne);
        }
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while (t.cmp(one) !== 0) {
          var tmp = t;
          for (var i = 0; tmp.cmp(one) !== 0; i++) {
            tmp = tmp.redSqr();
          }
          assert(i < m);
          var b = this.pow(c, new BN7(1).iushln(m - i - 1));
          r = r.redMul(b);
          c = b.redSqr();
          t = t.redMul(c);
          m = i;
        }
        return r;
      };
      Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
          inv.negative = 0;
          return this.imod(inv).redNeg();
        } else {
          return this.imod(inv);
        }
      };
      Red.prototype.pow = function pow2(a, num) {
        if (num.isZero()) return new BN7(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN7(1).toRed(this);
        wnd[1] = a;
        for (var i = 2; i < wnd.length; i++) {
          wnd[i] = this.mul(wnd[i - 1], a);
        }
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) {
          start = 26;
        }
        for (i = num.length - 1; i >= 0; i--) {
          var word = num.words[i];
          for (var j = start - 1; j >= 0; j--) {
            var bit = word >> j & 1;
            if (res !== wnd[0]) {
              res = this.sqr(res);
            }
            if (bit === 0 && current === 0) {
              currentLen = 0;
              continue;
            }
            current <<= 1;
            current |= bit;
            currentLen++;
            if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
            res = this.mul(res, wnd[current]);
            currentLen = 0;
            current = 0;
          }
          start = 26;
        }
        return res;
      };
      Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
      };
      Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
      };
      BN7.mont = function mont(num) {
        return new Mont(num);
      };
      function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) {
          this.shift += 26 - this.shift % 26;
        }
        this.r = new BN7(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
      }
      inherits(Mont, Red);
      Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
      };
      Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
      };
      Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
          a.words[0] = 0;
          a.length = 1;
          return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) {
          res = u.isub(this.m);
        } else if (u.cmpn(0) < 0) {
          res = u.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Mont.prototype.mul = function mul2(a, b) {
        if (a.isZero() || b.isZero()) return new BN7(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) {
          res = u.isub(this.m);
        } else if (u.cmpn(0) < 0) {
          res = u.iadd(this.m);
        }
        return res._forceRed(this);
      };
      Mont.prototype.invm = function invm(a) {
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
      };
    })(typeof module === "undefined" || module, exports);
  }
});

// src/client.ts
var import_bn6 = __toESM(require_bn());

// src/api.ts
var import_bn2 = __toESM(require_bn());

// src/errors.ts
var TypesErrorCode = /* @__PURE__ */ ((TypesErrorCode2) => {
  TypesErrorCode2["InvalidType"] = `InvalidType`;
  return TypesErrorCode2;
})(TypesErrorCode || {});
var ConfigErrorCode = /* @__PURE__ */ ((ConfigErrorCode2) => {
  ConfigErrorCode2["MissAggregatorPackage"] = `MissAggregatorPackage`;
  ConfigErrorCode2["MissGlobalConfig"] = `MissGlobalConfig`;
  ConfigErrorCode2["InvalidWallet"] = `InvalidWallet`;
  ConfigErrorCode2["SimulateError"] = `SimulateError`;
  return ConfigErrorCode2;
})(ConfigErrorCode || {});
var TransactionErrorCode = /* @__PURE__ */ ((TransactionErrorCode2) => {
  TransactionErrorCode2["InsufficientBalance"] = `InsufficientBalance`;
  TransactionErrorCode2["SimulateEventError"] = `simulateEventError`;
  TransactionErrorCode2["CannotGetDecimals"] = `CannotGetDecimals`;
  TransactionErrorCode2["MissCoinA"] = `MissCoinA`;
  TransactionErrorCode2["MissCoinB"] = `MissCoinB`;
  TransactionErrorCode2["MissTurbosFeeType"] = `MissTurbosFeeType`;
  TransactionErrorCode2["MissAftermathLpSupplyType"] = `MissAftermathLpSupplyType`;
  return TransactionErrorCode2;
})(TransactionErrorCode || {});
var AggregatorError = class _AggregatorError extends Error {
  constructor(message, errorCode) {
    super(message);
    this.message = message;
    this.errorCode = errorCode;
  }
  static isAggregatorErrorCode(e, code) {
    return e instanceof _AggregatorError && e.errorCode === code;
  }
};
var AggregatorServerErrorCode = /* @__PURE__ */ ((AggregatorServerErrorCode2) => {
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["NumberTooLarge"] = 1e3] = "NumberTooLarge";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["RateLimitExceeded"] = 1001] = "RateLimitExceeded";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["InsufficientLiquidity"] = 1002] = "InsufficientLiquidity";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["HoneyPot"] = 1003] = "HoneyPot";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["BadRequest"] = 1004] = "BadRequest";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["Forbidden"] = 1005] = "Forbidden";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["InternalServerError"] = 1006] = "InternalServerError";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["NotFoundRoute"] = 1007] = "NotFoundRoute";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["ServiceUnavailable"] = 1008] = "ServiceUnavailable";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["UnsupportedApiVersion"] = 1009] = "UnsupportedApiVersion";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["HoneyPotScam"] = 1010] = "HoneyPotScam";
  AggregatorServerErrorCode2[AggregatorServerErrorCode2["UnknownError"] = 400] = "UnknownError";
  return AggregatorServerErrorCode2;
})(AggregatorServerErrorCode || {});
function getAggregatorServerErrorMessage(code, msg) {
  switch (code) {
    case 1e3 /* NumberTooLarge */:
      return "Number too large" + (msg ? `: ${msg}` : "");
    case 1001 /* RateLimitExceeded */:
      return "Rate limit exceeded" + (msg ? `: ${msg}` : "");
    case 1002 /* InsufficientLiquidity */:
      return "Insufficient liquidity" + (msg ? `: ${msg}` : "");
    case 1003 /* HoneyPot */:
      return "HoneyPot scam detected" + (msg ? `: ${msg}` : "");
    case 1005 /* Forbidden */:
      return "Forbidden" + (msg ? `: ${msg}` : "");
    case 1004 /* BadRequest */:
      return "Bad request" + (msg ? `: ${msg}` : "");
    case 1006 /* InternalServerError */:
      return "Internal server error" + (msg ? `: ${msg}` : "");
    case 1007 /* NotFoundRoute */:
      return "Not found route" + (msg ? `: ${msg}` : "");
    case 1008 /* ServiceUnavailable */:
      return "Service unavailable" + (msg ? `: ${msg}` : "");
    case 1009 /* UnsupportedApiVersion */:
      return "Unsupported API version" + (msg ? `: ${msg}` : "");
    case 1010 /* HoneyPotScam */:
      return "Detected HoneyPot Scam" + (msg ? `: ${msg}` : "");
    case 400 /* UnknownError */:
      return "Unknown error" + (msg ? `: ${msg}` : "");
    default:
      return "Unknown error";
  }
}
var EQUAL = 0;
var LESS_THAN = 1;
var GREATER_THAN = 2;
function cmp(a, b) {
  if (a === b) {
    return EQUAL;
  }
  if (a < b) {
    return LESS_THAN;
  }
  return GREATER_THAN;
}
function compare(symbolX, symbolY) {
  let i = 0;
  const len = symbolX.length <= symbolY.length ? symbolX.length : symbolY.length;
  const lenCmp = cmp(symbolX.length, symbolY.length);
  while (i < len) {
    const elemCmp = cmp(symbolX.charCodeAt(i), symbolY.charCodeAt(i));
    i += 1;
    if (elemCmp !== 0) {
      return elemCmp;
    }
  }
  return lenCmp;
}
function isSortedSymbols(symbolX, symbolY) {
  return compare(symbolX, symbolY) === LESS_THAN;
}
function composeType(address, ...args) {
  const generics = Array.isArray(args[args.length - 1]) ? args.pop() : [];
  const chains = [address, ...args].filter(Boolean);
  let result = chains.join("::");
  if (generics && generics.length) {
    result += `<${generics.join(", ")}>`;
  }
  return result;
}
function extractAddressFromType(type) {
  return type.split("::")[0];
}
function extractStructTagFromType(type) {
  try {
    let _type = type.replace(/\s/g, "");
    const genericsString = _type.match(/(<.+>)$/);
    const generics = genericsString?.[0]?.match(/(\w+::\w+::\w+)(?:<.*?>(?!>))?/g);
    if (generics) {
      _type = _type.slice(0, _type.indexOf("<"));
      const tag2 = extractStructTagFromType(_type);
      const structTag2 = {
        ...tag2,
        type_arguments: generics.map((item) => extractStructTagFromType(item).source_address)
      };
      structTag2.type_arguments = structTag2.type_arguments.map((item) => {
        return CoinUtils.isSuiCoin(item) ? item : extractStructTagFromType(item).source_address;
      });
      structTag2.source_address = composeType(structTag2.full_address, structTag2.type_arguments);
      return structTag2;
    }
    const parts = _type.split("::");
    const isSuiCoin = _type === GAS_TYPE_ARG || _type === GAS_TYPE_ARG_LONG;
    const structTag = {
      full_address: _type,
      address: isSuiCoin ? "0x2" : normalizeSuiObjectId(parts[0]),
      module: parts[1],
      name: parts[2],
      type_arguments: [],
      source_address: ""
    };
    structTag.full_address = `${structTag.address}::${structTag.module}::${structTag.name}`;
    structTag.source_address = composeType(structTag.full_address, structTag.type_arguments);
    return structTag;
  } catch (error) {
    return {
      full_address: type,
      address: "",
      module: "",
      name: "",
      type_arguments: [],
      source_address: type
    };
  }
}
function normalizeCoinType(coinType) {
  return extractStructTagFromType(coinType).source_address;
}
function fixSuiObjectId(value) {
  if (value.toLowerCase().startsWith("0x")) {
    return normalizeSuiObjectId(value);
  }
  return value;
}
function patchFixSuiObjectId(data) {
  for (const key in data) {
    const type = typeof data[key];
    if (type === "object") {
      patchFixSuiObjectId(data[key]);
    } else if (type === "string") {
      const value = data[key];
      data[key] = fixSuiObjectId(value);
    }
  }
}
function createTarget(packageName, moduleName, functionName) {
  return `${packageName}::${moduleName}::${functionName}`;
}

// src/types/CoinAssist.ts
var COIN_TYPE = "0x2::coin::Coin";
var COIN_TYPE_ARG_REGEX = /^0x2::coin::Coin<(.+)>$/;
var DEFAULT_GAS_BUDGET_FOR_SPLIT = 1e3;
var DEFAULT_GAS_BUDGET_FOR_MERGE = 500;
var DEFAULT_GAS_BUDGET_FOR_TRANSFER = 100;
var DEFAULT_GAS_BUDGET_FOR_TRANSFER_SUI = 100;
var DEFAULT_GAS_BUDGET_FOR_STAKE = 1e3;
var GAS_TYPE_ARG = "0x2::sui::SUI";
var GAS_TYPE_ARG_LONG = "0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI";
var GAS_SYMBOL = "SUI";
var DEFAULT_NFT_TRANSFER_GAS_FEE = 450;
var SUI_SYSTEM_STATE_OBJECT_ID = "0x0000000000000000000000000000000000000005";
var CoinUtils = class _CoinUtils {
  /**
   * Get the coin type argument from a SuiMoveObject.
   *
   * @param obj The SuiMoveObject to get the coin type argument from.
   * @returns The coin type argument, or null if it is not found.
   */
  static getCoinTypeArg(obj) {
    const res = obj.type.match(COIN_TYPE_ARG_REGEX);
    return res ? res[1] : null;
  }
  /**
   * Get whether a SuiMoveObject is a SUI coin.
   *
   * @param obj The SuiMoveObject to check.
   * @returns Whether the SuiMoveObject is a SUI coin.
   */
  static isSUI(obj) {
    const arg = _CoinUtils.getCoinTypeArg(obj);
    return arg ? _CoinUtils.getCoinSymbol(arg) === "SUI" : false;
  }
  /**
   * Get the coin symbol from a coin type argument.
   *
   * @param coinTypeArg The coin type argument to get the symbol from.
   * @returns The coin symbol.
   */
  static getCoinSymbol(coinTypeArg) {
    return coinTypeArg.substring(coinTypeArg.lastIndexOf(":") + 1);
  }
  /**
   * Get the balance of a SuiMoveObject.
   *
   * @param obj The SuiMoveObject to get the balance from.
   * @returns The balance of the SuiMoveObject.
   */
  static getBalance(obj) {
    return BigInt(obj.fields.balance);
  }
  /**
   * Get the total balance of a list of CoinAsset objects for a given coin address.
   *
   * @param objs The list of CoinAsset objects to get the total balance for.
   * @param coinAddress The coin address to get the total balance for.
   * @returns The total balance of the CoinAsset objects for the given coin address.
   */
  static totalBalance(objs, coinAddress) {
    let balanceTotal = BigInt(0);
    objs.forEach((obj) => {
      if (coinAddress === obj.coinAddress) {
        balanceTotal += BigInt(obj.balance);
      }
    });
    return balanceTotal;
  }
  /**
   * Get the ID of a SuiMoveObject.
   *
   * @param obj The SuiMoveObject to get the ID from.
   * @returns The ID of the SuiMoveObject.
   */
  static getID(obj) {
    return obj.fields.id.id;
  }
  /**
   * Get the coin type from a coin type argument.
   *
   * @param coinTypeArg The coin type argument to get the coin type from.
   * @returns The coin type.
   */
  static getCoinTypeFromArg(coinTypeArg) {
    return `${COIN_TYPE}<${coinTypeArg}>`;
  }
  /**
   * Get the CoinAsset objects for a given coin type.
   *
   * @param coinType The coin type to get the CoinAsset objects for.
   * @param allSuiObjects The list of all SuiMoveObjects.
   * @returns The CoinAsset objects for the given coin type.
   */
  static getCoinAssets(coinType, allSuiObjects) {
    const coins = [];
    allSuiObjects.forEach((anObj) => {
      if (normalizeCoinType(anObj.coinAddress) === normalizeCoinType(coinType)) {
        coins.push(anObj);
      }
    });
    return coins;
  }
  /**
   * Get whether a coin address is a SUI coin.
   *
   * @param coinAddress The coin address to check.
   * @returns Whether the coin address is a SUI coin.
   */
  static isSuiCoin(coinAddress) {
    return extractStructTagFromType(coinAddress).full_address === GAS_TYPE_ARG;
  }
  /**
   * Select the CoinAsset objects from a list of CoinAsset objects that have a balance greater than or equal to a given amount.
   *
   * @param coins The list of CoinAsset objects to select from.
   * @param amount The amount to select CoinAsset objects with a balance greater than or equal to.
   * @param exclude A list of CoinAsset objects to exclude from the selection.
   * @returns The CoinAsset objects that have a balance greater than or equal to the given amount.
   */
  static selectCoinObjectIdGreaterThanOrEqual(coins, amount, exclude = []) {
    const selectedResult = _CoinUtils.selectCoinAssetGreaterThanOrEqual(coins, amount, exclude);
    const objectArray = selectedResult.selectedCoins.map((item) => item.coinObjectId);
    const remainCoins = selectedResult.remainingCoins;
    const amountArray = selectedResult.selectedCoins.map((item) => item.balance.toString());
    return { objectArray, remainCoins, amountArray };
  }
  /**
   * Select the CoinAsset objects from a list of CoinAsset objects that have a balance greater than or equal to a given amount.
   *
   * @param coins The list of CoinAsset objects to select from.
   * @param amount The amount to select CoinAsset objects with a balance greater than or equal to.
   * @param exclude A list of CoinAsset objects to exclude from the selection.
   * @returns The CoinAsset objects that have a balance greater than or equal to the given amount.
   */
  static selectCoinAssetGreaterThanOrEqual(coins, amount, exclude = []) {
    const sortedCoins = _CoinUtils.sortByBalance(coins.filter((c) => !exclude.includes(c.coinObjectId)));
    const total = _CoinUtils.calculateTotalBalance(sortedCoins);
    if (total < amount) {
      return { selectedCoins: [], remainingCoins: sortedCoins };
    }
    if (total === amount) {
      return { selectedCoins: sortedCoins, remainingCoins: [] };
    }
    let sum2 = BigInt(0);
    const selectedCoins = [];
    const remainingCoins = [...sortedCoins];
    while (sum2 < total) {
      const target = amount - sum2;
      const coinWithSmallestSufficientBalanceIndex = remainingCoins.findIndex((c) => c.balance >= target);
      if (coinWithSmallestSufficientBalanceIndex !== -1) {
        selectedCoins.push(remainingCoins[coinWithSmallestSufficientBalanceIndex]);
        remainingCoins.splice(coinWithSmallestSufficientBalanceIndex, 1);
        break;
      }
      const coinWithLargestBalance = remainingCoins.pop();
      if (coinWithLargestBalance.balance > 0) {
        selectedCoins.push(coinWithLargestBalance);
        sum2 += coinWithLargestBalance.balance;
      }
    }
    return { selectedCoins: _CoinUtils.sortByBalance(selectedCoins), remainingCoins: _CoinUtils.sortByBalance(remainingCoins) };
  }
  /**
   * Sort the CoinAsset objects by their balance.
   *
   * @param coins The CoinAsset objects to sort.
   * @returns The sorted CoinAsset objects.
   */
  static sortByBalance(coins) {
    return coins.sort((a, b) => a.balance < b.balance ? -1 : a.balance > b.balance ? 1 : 0);
  }
  static sortByBalanceDes(coins) {
    return coins.sort((a, b) => a.balance > b.balance ? -1 : a.balance < b.balance ? 0 : 1);
  }
  /**
   * Calculate the total balance of a list of CoinAsset objects.
   *
   * @param coins The list of CoinAsset objects to calculate the total balance for.
   * @returns The total balance of the CoinAsset objects.
   */
  static calculateTotalBalance(coins) {
    return coins.reduce((partialSum, c) => partialSum + c.balance, BigInt(0));
  }
};

// src/utils/coin.ts
function completionCoin(s) {
  const index = s.indexOf("::");
  if (index === -1) {
    return s;
  }
  const prefix = s.substring(0, index);
  const rest = s.substring(index);
  if (!prefix.startsWith("0x")) {
    return s;
  }
  const hexStr = prefix.substring(2);
  if (hexStr.length > 64) {
    return s;
  }
  const paddedHexStr = hexStr.padStart(64, "0");
  return `0x${paddedHexStr}${rest}`;
}
function mintZeroCoin(txb, coinType) {
  return txb.moveCall({
    target: `0x2::coin::zero`,
    typeArguments: [coinType],
    arguments: []
  });
}
function compareCoins(coinA, coinB) {
  coinA = completionCoin(coinA);
  coinB = completionCoin(coinB);
  const minLength = Math.min(coinA.length, coinB.length);
  for (let i = 0; i < minLength; i++) {
    if (coinA[i] > coinB[i]) {
      return true;
    } else if (coinA[i] < coinB[i]) {
      return false;
    }
  }
  return true;
}
function parseTurbosPoolFeeType(typeData) {
  const regex = /,([^,>]*>)/g;
  const matches = [...typeData.matchAll(regex)];
  if (matches.length > 0) {
    const lastMatch = matches[matches.length - 1][1];
    return lastMatch.substring(0, lastMatch.length - 1).trim();
  }
  return null;
}
function parseAftermathFeeType(typeData) {
  const regex = /<([^>]*)>/;
  const matches = typeData.match(regex);
  if (matches) {
    return matches[1];
  }
}
function buildInputCoin(txb, allCoins, amount, coinType) {
  const usedCoinAsests = CoinUtils.getCoinAssets(coinType, allCoins);
  if (amount === BigInt(0)) {
    if (CoinUtils.isSuiCoin(coinType) || usedCoinAsests.length === 0 && !CoinUtils.isSuiCoin(coinType)) {
      const zeroCoin = mintZeroCoin(txb, coinType);
      return {
        targetCoin: zeroCoin,
        isMintZeroCoin: true,
        targetCoinAmount: 0
      };
    } else {
      return {
        targetCoin: txb.object(usedCoinAsests[0].coinObjectId),
        isMintZeroCoin: false,
        targetCoinAmount: Number(usedCoinAsests[0].balance.toString())
      };
    }
  }
  let totalCoinBalance = CoinUtils.calculateTotalBalance(usedCoinAsests);
  if (totalCoinBalance < amount) {
    throw new AggregatorError(
      "Insufficient balance when build merge coin, coinType: " + coinType,
      "InsufficientBalance" /* InsufficientBalance */ + coinType
    );
  }
  if (CoinUtils.isSuiCoin(coinType)) {
    const resultCoin = txb.splitCoins(txb.gas, [
      txb.pure.u64(amount.toString())
    ]);
    return {
      targetCoin: resultCoin,
      isMintZeroCoin: true,
      targetCoinAmount: Number(amount.toString())
    };
  }
  let sortCoinAssets = CoinUtils.sortByBalance(usedCoinAsests);
  let totalThreeCoinBalance = sortCoinAssets.slice(0, 3).reduce((acc, coin) => acc + coin.balance, BigInt(0));
  if (totalThreeCoinBalance < BigInt(amount)) {
    sortCoinAssets = CoinUtils.sortByBalanceDes(usedCoinAsests);
  }
  let selectedCoinResult = CoinUtils.selectCoinObjectIdGreaterThanOrEqual(
    sortCoinAssets,
    amount
  );
  const [masterCoin, ...mergedCoin] = selectedCoinResult.objectArray;
  if (mergedCoin.length > 0) {
    txb.mergeCoins(
      masterCoin,
      mergedCoin.map((coin) => txb.object(coin))
    );
  }
  const targetCoin = txb.splitCoins(txb.object(masterCoin), [
    txb.pure.u64(amount.toString())
  ]);
  return {
    targetCoin,
    isMintZeroCoin: false,
    targetCoinAmount: Number(amount.toString())
  };
}

// src/const.ts
var import_bn = __toESM(require_bn());
var ZERO = new import_bn.default(0);
var ONE = new import_bn.default(1);
var TWO = new import_bn.default(2);
var U128 = TWO.pow(new import_bn.default(128));
var U64_MAX_BN = new import_bn.default("18446744073709551615");
var U64_MAX = "18446744073709551615";
var TEN_POW_NINE = 1e9;
var AGGREGATOR = "aggregator";
var CETUS_DEX = "CETUS";
var DEEPBOOK_DEX = "DEEPBOOK";
var KRIYA_DEX = "KRIYA";
var FLOWX_AMM = "FLOWX";
var TURBOS_DEX = "TURBOS";
var AFTERMATH_AMM = "AFTERMATH";
var INTEGRATE = "integrate";
var CETUS_MODULE = "cetus";
var DEEPBOOK_MODULE = "deepbook";
var KRIYA_MODULE = "kriya";
var UTILS_MODULE = "utils";
var POOL_MODULT = "pool";
var PAY_MODULE = "pay";
var FLOWX_AMM_MODULE = "flowx_amm";
var TURBOS_MODULE = "turbos";
var AFTERMATH_MODULE = "aftermath";
var DEEPBOOK_CUSTODIAN_V2_MODULE = "custodian_v2";
var DEEPBOOK_CLOB_V2_MODULE = "clob_v2";
var FlashSwapFunc = "flash_swap";
var FlashSwapWithPartnerFunc = "flash_swap_with_partner";
var RepayFalshSwapFunc = "repay_flash_swap";
var RepayFlashSwapWithPartnerFunc = "repay_flash_swap_with_partner";
var FlashSwapA2BFunc = "flash_swap_a2b";
var FlashSwapB2AFunc = "flash_swap_b2a";
var FlashSwapWithPartnerA2BFunc = "flash_swap_with_partner_a2b";
var FlashSwapWithPartnerB2AFunc = "flash_swap_with_partner_b2a";
var REPAY_FLASH_SWAP_A2B_FUNC = "repay_flash_swap_a2b";
var REPAY_FLASH_SWAP_B2A_FUNC = "repay_flash_swap_b2a";
var REPAY_FLASH_SWAP_WITH_PARTNER_A2B_FUNC = "repay_flash_swap_with_partner_a2b";
var REPAY_FLASH_SWAP_WITH_PARTNER_B2A_FUNC = "repay_flash_swap_with_partner_b2a";
var SWAP_A2B_FUNC = "swap_a2b";
var SWAP_B2A_FUNC = "swap_b2a";
var TRANSFER_OR_DESTORY_COIN_FUNC = "transfer_or_destroy_coin";
var CHECK_COINS_THRESHOLD_FUNC = "check_coins_threshold";
var JOIN_FUNC = "join_vec";
var TRANSFER_ACCOUNT_CAP = "transfer_account_cap";
var CLOCK_ADDRESS = "0x0000000000000000000000000000000000000000000000000000000000000006";
var CoinInfoAddress = "0x1::coin::CoinInfo";
var CoinStoreAddress = "0x1::coin::CoinStore";
var SuiZeroCoinFn = "0x2::coin::zero";
var DEEPBOOK_PACKAGE_ID = "0x000000000000000000000000000000000000000000000000000000000000dee9";
var DEEPBOOK_PUBLISHED_AT = "0x000000000000000000000000000000000000000000000000000000000000dee9";
var CETUS_PUBLISHED_AT = "0x70968826ad1b4ba895753f634b0aea68d0672908ca1075a2abdf0fc9e0b2fc6a";
var MAINNET_CETUS_V3_PUBLISHED_AT = "0xd7b0cfc33a3b46c0ae0e2584c44028385da11724d4c94ec5b21a78117c5c1ab9";
var TESTNET_CETUS_V3_PUBLISHED_AT = "0x7a82ed4b00a8c68d751b6c0cbd4e989691daa4716a1cf4f875c2f9b28fb72f3a";
var MAINNET_FLOWX_AMM_CONTAINER_ID = "0xb65dcbf63fd3ad5d0ebfbf334780dc9f785eff38a4459e37ab08fa79576ee511";
var TESTNET_FLOWX_AMM_CONTAINER_ID = "";
var TURBOS_VERSIONED = "0xf1cf0e81048df168ebeb1b8030fad24b3e0b53ae827c25053fff0779c1445b6f";
var MAINNET_AFTERMATH_REGISTRY_ID = "0xfcc774493db2c45c79f688f88d28023a3e7d98e4ee9f48bbf5c7990f651577ae";
var TESTNET_AFTERMATH_REGISTRY_ID = "";
var MAINNET_AFTERMATH_PROTOCOL_FEE_VAULT_ID = "0xf194d9b1bcad972e45a7dd67dd49b3ee1e3357a00a50850c52cd51bb450e13b4";
var TESTNET_AFTERMATH_PROTOCOL_FEE_VAULT_ID = "";
var MAINNET_AFTERMATH_TREASURY_ID = "0x28e499dff5e864a2eafe476269a4f5035f1c16f338da7be18b103499abf271ce";
var TESTNET_AFTERMATH_TREASURY_ID = "";
var MAINNET_AFTERMATH_INSURANCE_FUND_ID = "0xf0c40d67b078000e18032334c3325c47b9ec9f3d9ae4128be820d54663d14e3b";
var TESTNET_AFTERMATH_INSURANCE_FUND_ID = "";
var MAINNET_AFTERMATH_REFERRAL_VAULT_ID = "0x35d35b0e5b177593d8c3a801462485572fc30861e6ce96a55af6dc4730709278";
var TESTNET_AFTERMATH_REFERRAL_VAULT_ID = "";
var PACKAGE_NAMES = {
  AGGREGATOR_V3: "aggregator_v3"
};
var DEFAULT_AGG_V3_ENDPOINT = "https://api-sui.cetus.zone/router_v3";
var DEFAULT_AGG_V2_ENDPOINT = "https://api-sui.cetus.zone/router_v2";
var PYTH_CONFIG = {
  Testnet: {
    wormholeStateId: "0x31358d198147da50db32eda2562951d53973a0c0ad5ed738e9b17d88b213d790",
    pythStateId: "0x243759059f4c3111179da5878c12f68d612c21a8d54d85edc86164bb18be1c7c"
  },
  Mainnet: {
    wormholeStateId: "0xaeab97f96cf9877fee2883315d459552b2b921edc16d7ceac6eab944dd88919c",
    pythStateId: "0x1f9310238ee9298fb703c3419030b35b22bb1cc37113e3bb5007c99aec79e5b8"
  }
};
var PUBLISHED_ADDRESSES = {
  // Include cetus、deepbookv2、flowxv2 & v3、kriyav2 & v3、turbos、aftermath、haedal、afsui、volo、bluemove
  V2: {
    Mainnet: "0x8ae871505a80d8bf6bf9c05906cda6edfeea460c85bebe2e26a4313f5e67874a",
    // version 12
    Testnet: "0x52eae33adeb44de55cfb3f281d4cc9e02d976181c0952f5323648b5717b33934"
  },
  // Include deepbookv3, scallop, bluefin
  V2_EXTEND: {
    Mainnet: "0x8a2f7a5b20665eeccc79de3aa37c3b6c473eca233ada1e1cd4678ec07d4d4073",
    // version 17
    Testnet: "0xabb6a81c8a216828e317719e06125de5bb2cb0fe8f9916ff8c023ca5be224c78"
  },
  V2_EXTEND2: {
    Mainnet: "0x5cb7499fc49c2642310e24a4ecffdbee00133f97e80e2b45bca90c64d55de880",
    // version 8
    Testnet: "0x0"
  }
};
var DEEPBOOK_V3_DEEP_FEE_TYPES = {
  Mainnet: "0xdeeb7a4662eec9f2f3def03fb937a663dddaa2e215b8078a284d026b7946c270::deep::DEEP",
  Testnet: "0x36dbef866a1d62bf7328989a10fb2f07d769f4ee587c0de4a0a256e57e0a58a8::deep::DEEP"
};
var CLIENT_CONFIG = {
  DEFAULT_PYTH_URL: "https://hermes.pyth.network",
  PYTH_TIMEOUT: 3e3,
  MAX_OVERLAY_FEE_RATE: 0.1,
  MAX_OVERLAY_FEE_RATE_NUMERATOR: 1e5,
  FEE_RATE_MULTIPLIER: 1e6,
  DEFAULT_OVERLAY_FEE_RECEIVER: "0x0",
  // Error Messages
  ERRORS: {
    SIGNER_REQUIRED: "Signer is required, but not provided.",
    INVALID_OVERLAY_FEE_RATE: "Overlay fee rate must be between 0 and 0.1",
    INVALID_SLIPPAGE: "Invalid slippage value. Must be between 0 and 1 (e.g., 0.01 represents 1% slippage)",
    NO_ROUTER_FOUND: "No router found",
    EMPTY_PATH: "Empty path",
    UNSUPPORTED_DEX: "Unsupported dex",
    PYTH_UNAVAILABLE: "All Pyth price nodes are unavailable. Cannot fetch price data. Please switch to or add new available Pyth nodes",
    QUOTE_ID_REQUIRED: "Quote ID is required",
    AGGREGATOR_V3_PACKAGE_REQUIRED: "Aggregator V3 package is required",
    PACKAGES_REQUIRED: "Packages are required",
    OVERLAY_FEE_RECEIVER_REQUIRED: "Overlay fee rate is set, but overlay fee receiver is not set"
  }
};
var AGGREGATOR_V3_CONFIG = {
  FEE_DENOMINATOR: 1e6,
  MAX_FEE_RATE: 1e5,
  // 10%
  MAX_AMOUNT_IN: U64_MAX,
  DEFAULT_PUBLISHED_AT: {
    Mainnet: "0xde5d696a79714ca5cb910b9aed99d41f67353abb00715ceaeb0663d57ee39640",
    Testnet: "0x61da681cf2af95cb214a71596b49e662290065536984ed7e06b47e701ef547e3"
  }
};

// src/api.ts
var SDK_VERSION = 1010408;
function parseRouterResponse(data, byAmountIn) {
  let packages = /* @__PURE__ */ new Map();
  if (data.packages) {
    if (data.packages instanceof Map) {
      packages = data.packages;
    } else if (typeof data.packages === "object") {
      Object.entries(data.packages).forEach(([key, value]) => {
        packages.set(key, value);
      });
    }
  }
  return {
    quoteID: data.request_id || "",
    amountIn: new import_bn2.default(data.amount_in.toString()),
    amountOut: new import_bn2.default(data.amount_out.toString()),
    byAmountIn,
    insufficientLiquidity: false,
    deviationRatio: data.deviation_ratio,
    packages,
    paths: data.paths.map((path) => ({
      id: path.id,
      direction: path.direction,
      provider: path.provider,
      from: path.from,
      target: path.target,
      feeRate: path.fee_rate,
      amountIn: path.amount_in.toString(),
      amountOut: path.amount_out.toString(),
      version: path.version,
      publishedAt: path.published_at,
      extendedDetails: path.extended_details
    }))
  };
}
function parseMergeSwapResponse(data) {
  let packages = /* @__PURE__ */ new Map();
  if (data.packages) {
    if (data.packages instanceof Map) {
      packages = data.packages;
    } else if (typeof data.packages === "object") {
      Object.entries(data.packages).forEach(([key, value]) => {
        packages.set(key, value);
      });
    }
  }
  const allRoutes = [];
  if (data.all_routes) {
    for (const route of data.all_routes) {
      const mergeRoute = {
        amountIn: new import_bn2.default(route.amount_in.toString()),
        amountOut: new import_bn2.default(route.amount_out.toString()),
        deviationRatio: route.deviation_ratio,
        paths: route.paths.map((path) => ({
          id: path.id,
          direction: path.direction,
          provider: path.provider,
          from: path.from,
          target: path.target,
          feeRate: path.fee_rate,
          amountIn: path.amount_in.toString(),
          amountOut: path.amount_out.toString(),
          version: path.version,
          publishedAt: path.published_at,
          extendedDetails: path.extended_details
        }))
      };
      allRoutes.push(mergeRoute);
    }
  }
  return {
    quoteID: data.request_id || "",
    totalAmountOut: new import_bn2.default(data.total_amount_out?.toString() || "0"),
    allRoutes,
    packages,
    gas: data.gas
  };
}
async function getRouterResult(endpoint, apiKey, params, overlayFee, overlayFeeReceiver) {
  let response;
  if (params.liquidityChanges && params.liquidityChanges.length > 0) {
    response = await postRouterWithLiquidityChanges(endpoint, params);
  } else {
    response = await getRouter(endpoint, apiKey, params);
  }
  if (!response) {
    return null;
  }
  if (!response.ok) {
    let errorCode = 1004 /* BadRequest */;
    if (response.status === 429) {
      errorCode = 1001 /* RateLimitExceeded */;
    }
    return {
      quoteID: "",
      amountIn: ZERO,
      amountOut: ZERO,
      paths: [],
      byAmountIn: params.byAmountIn,
      insufficientLiquidity: false,
      deviationRatio: 0,
      error: {
        code: errorCode,
        msg: getAggregatorServerErrorMessage(errorCode)
      }
    };
  }
  const data = JSONbig.parse(await response.text());
  if (data.data != null) {
    const res = parseRouterResponse(data.data, params.byAmountIn);
    if (overlayFee > 0 && overlayFeeReceiver !== "0x0") {
      if (params.byAmountIn) {
        const overlayFeeAmount = res.amountOut.mul(new import_bn2.default(overlayFee)).div(new import_bn2.default(1e6));
        res.overlayFee = Number(overlayFeeAmount.toString());
        res.amountOut = res.amountOut.sub(overlayFeeAmount);
      } else {
        const overlayFeeAmount = res.amountIn.mul(new import_bn2.default(overlayFee)).div(new import_bn2.default(1e6));
        res.overlayFee = Number(overlayFeeAmount.toString());
        res.amountIn = res.amountIn.add(overlayFeeAmount);
      }
    }
    if (!res.packages) {
      res.packages = /* @__PURE__ */ new Map();
    }
    if (!res.packages.has("aggregator_v3")) {
      res.packages.set(
        "aggregator_v3",
        "0x3864c7c59a4889fec05d1aae4bc9dba5a0e0940594b424fbed44cb3f6ac4c032"
      );
    }
    return res;
  }
  const code = processErrorStatusCode(data.code);
  const msg = getAggregatorServerErrorMessage(code, data.msg);
  const insufficientLiquidity = msg.includes("Insufficient liquidity");
  return {
    quoteID: "",
    amountIn: ZERO,
    amountOut: ZERO,
    paths: [],
    insufficientLiquidity,
    byAmountIn: params.byAmountIn,
    deviationRatio: 0,
    error: {
      code,
      msg
    }
  };
}
async function getRouter(endpoint, apiKey, params) {
  try {
    const {
      from,
      target,
      amount,
      byAmountIn,
      depth,
      splitAlgorithm,
      splitFactor,
      splitCount,
      providers
    } = params;
    const fromCoin = completionCoin(from);
    const targetCoin = completionCoin(target);
    let url = `${endpoint}/find_routes?from=${fromCoin}&target=${targetCoin}&amount=${amount.toString()}&by_amount_in=${byAmountIn}`;
    if (depth) {
      url += `&depth=${depth}`;
    }
    if (splitAlgorithm) {
      url += `&split_algorithm=${splitAlgorithm}`;
    }
    if (splitFactor) {
      url += `&split_factor=${splitFactor}`;
    }
    if (splitCount) {
      url += `&split_count=${splitCount}`;
    }
    if (providers) {
      if (providers.length > 0) {
        url += `&providers=${providers.join(",")}`;
      }
    }
    if (apiKey.length > 0) {
      url += `&apiKey=${apiKey}`;
    }
    url += `&v=${SDK_VERSION}`;
    const response = await fetch(url);
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}
async function postRouterWithLiquidityChanges(endpoint, params) {
  const {
    from,
    target,
    amount,
    byAmountIn,
    depth,
    splitAlgorithm,
    splitFactor,
    splitCount,
    providers,
    liquidityChanges
  } = params;
  const fromCoin = completionCoin(from);
  const targetCoin = completionCoin(target);
  const url = `${endpoint}/find_routes`;
  const providersStr = providers?.join(",");
  const requestData = {
    from: fromCoin,
    target: targetCoin,
    amount: Number(amount.toString()),
    by_amount_in: byAmountIn,
    depth,
    split_algorithm: splitAlgorithm,
    split_factor: splitFactor,
    split_count: splitCount,
    providers: providersStr,
    liquidity_changes: liquidityChanges.map((change) => ({
      pool: change.poolID,
      tick_lower: change.ticklower,
      tick_upper: change.tickUpper,
      delta_liquidity: change.deltaLiquidity
    })),
    v: SDK_VERSION
  };
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestData)
    });
    return response;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}
async function getMergeSwapRouter(endpoint, apiKey, params) {
  try {
    const { target, byAmountIn, depth, providers, froms } = params;
    const targetCoin = completionCoin(target);
    let url = `${endpoint}/multi_find_routes?target=${targetCoin}&by_amount_in=${byAmountIn}`;
    if (depth) {
      url += `&depth=${depth}`;
    }
    if (providers && providers.length > 0) {
      url += `&providers=${providers.join(",")}`;
    }
    if (apiKey.length > 0) {
      url += `&apiKey=${apiKey}`;
    }
    url += `&v=${SDK_VERSION}`;
    const fromsData = froms.map((from) => ({
      coin_type: completionCoin(from.coinType),
      amount: Number(from.amount.toString())
    }));
    url += `&froms=${encodeURIComponent(JSON.stringify(fromsData))}`;
    const response = await fetch(url);
    console.log("response", response);
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}
async function getMergeSwapResult(endpoint, apiKey, params, overlayFee, overlayFeeReceiver) {
  const response = await getMergeSwapRouter(endpoint, apiKey, params);
  if (!response) {
    return null;
  }
  if (!response.ok) {
    let errorCode = 1004 /* BadRequest */;
    if (response.status === 429) {
      errorCode = 1001 /* RateLimitExceeded */;
    }
    return {
      quoteID: "",
      totalAmountOut: ZERO,
      allRoutes: [],
      error: {
        code: errorCode,
        msg: getAggregatorServerErrorMessage(errorCode)
      }
    };
  }
  if (!response.ok) {
    const code2 = processErrorStatusCode(response.status);
    const responseText2 = await response.text();
    const data2 = JSONbig.parse(responseText2);
    const msg2 = getAggregatorServerErrorMessage(code2, data2.msg);
    return {
      quoteID: "",
      totalAmountOut: ZERO,
      allRoutes: [],
      error: {
        code: code2,
        msg: msg2
      }
    };
  }
  const responseText = await response.text();
  const data = JSONbig.parse(responseText);
  if (data.data != null) {
    console.log("data.data not null", data.data);
    const res = parseMergeSwapResponse(data.data);
    if (overlayFee > 0 && overlayFeeReceiver !== "0x0" && params.byAmountIn) {
      const overlayFeeAmount = res.totalAmountOut.mul(new import_bn2.default(overlayFee)).div(new import_bn2.default(1e6));
      res.totalAmountOut = res.totalAmountOut.sub(overlayFeeAmount);
      for (const route of res.allRoutes) {
        const routeFee = route.amountOut.mul(new import_bn2.default(overlayFee)).div(new import_bn2.default(1e6));
        route.amountOut = route.amountOut.sub(routeFee);
      }
    }
    if (!res.packages) {
      res.packages = /* @__PURE__ */ new Map();
    }
    return res;
  }
  const code = processErrorStatusCode(data.code);
  const msg = getAggregatorServerErrorMessage(code, data.msg);
  return {
    quoteID: "",
    totalAmountOut: ZERO,
    allRoutes: [],
    error: {
      code,
      msg
    }
  };
}
async function getDeepbookV3Config(endpoint) {
  const url = `${endpoint}/deepbookv3_config`;
  try {
    const response = await fetch(url);
    return response.json();
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}
function processFlattenRoutes(routerData) {
  const paths = routerData.paths;
  const fromCoinType = paths[0].from;
  const targetCoinType = paths[paths.length - 1].target;
  const flattenedPaths = [];
  for (const path of paths) {
    flattenedPaths.push({
      path,
      isLastUseOfIntermediateToken: false
    });
  }
  const seenTokens = /* @__PURE__ */ new Map();
  for (let i = flattenedPaths.length - 1; i >= 0; i--) {
    const { from } = flattenedPaths[i].path;
    if (!seenTokens.has(from)) {
      seenTokens.set(from, true);
      flattenedPaths[i].isLastUseOfIntermediateToken = true;
    }
  }
  return {
    quoteID: routerData.quoteID || "",
    amountIn: routerData.amountIn,
    amountOut: routerData.amountOut,
    byAmountIn: routerData.byAmountIn,
    flattenedPaths,
    fromCoinType,
    targetCoinType,
    packages: routerData.packages,
    totalDeepFee: routerData.totalDeepFee,
    error: routerData.error,
    overlayFee: routerData.overlayFee
  };
}
function processErrorStatusCode(status) {
  switch (status) {
    case 400:
      return 1004 /* BadRequest */;
    case 403:
      return 1005 /* Forbidden */;
    case 429:
      return 1001 /* RateLimitExceeded */;
    case 4e3:
      return 1004 /* BadRequest */;
    case 4030:
      return 1005 /* Forbidden */;
    case 4040:
      return 1010 /* HoneyPotScam */;
    case 5e3:
      return 1002 /* InsufficientLiquidity */;
    case 5001:
    case 5010:
      return 1007 /* NotFoundRoute */;
    case 5030:
      return 1008 /* ServiceUnavailable */;
    case 5040:
      return 1009 /* UnsupportedApiVersion */;
    default:
      return 400 /* UnknownError */;
  }
}

// src/config.ts
var Env = /* @__PURE__ */ ((Env2) => {
  Env2[Env2["Mainnet"] = 0] = "Mainnet";
  Env2[Env2["Testnet"] = 1] = "Testnet";
  return Env2;
})(Env || {});
var AggregatorConfig = class {
  constructor(endpoint, fullNodeUrl, signer, env) {
    this.endpoint = endpoint;
    this.fullNodeUrl = fullNodeUrl;
    this.signer = signer;
    this.env = env;
  }
  getAggregatorUrl() {
    return this.endpoint;
  }
  getFullNodeUrl() {
    return this.fullNodeUrl;
  }
  getWallet() {
    return this.signer;
  }
  getENV() {
    return this.env;
  }
};

// src/math.ts
var import_bn3 = __toESM(require_bn());

// node_modules/decimal.js/decimal.mjs
var EXP_LIMIT = 9e15;
var MAX_DIGITS = 1e9;
var NUMERALS = "0123456789abcdef";
var LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058";
var PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789";
var DEFAULTS = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -EXP_LIMIT,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: EXP_LIMIT,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: false
  // true/false
};
var inexact;
var quadrant;
var external = true;
var decimalError = "[DecimalError] ";
var invalidArgument = decimalError + "Invalid argument: ";
var precisionLimitExceeded = decimalError + "Precision limit exceeded";
var cryptoUnavailable = decimalError + "crypto unavailable";
var tag = "[object Decimal]";
var mathfloor = Math.floor;
var mathpow = Math.pow;
var isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i;
var isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i;
var isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i;
var isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
var BASE = 1e7;
var LOG_BASE = 7;
var MAX_SAFE_INTEGER = 9007199254740991;
var LN10_PRECISION = LN10.length - 1;
var PI_PRECISION = PI.length - 1;
var P = { toStringTag: tag };
P.absoluteValue = P.abs = function() {
  var x = new this.constructor(this);
  if (x.s < 0) x.s = 1;
  return finalise(x);
};
P.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
};
P.clampedTo = P.clamp = function(min2, max2) {
  var k, x = this, Ctor = x.constructor;
  min2 = new Ctor(min2);
  max2 = new Ctor(max2);
  if (!min2.s || !max2.s) return new Ctor(NaN);
  if (min2.gt(max2)) throw Error(invalidArgument + max2);
  k = x.cmp(min2);
  return k < 0 ? min2 : x.cmp(max2) > 0 ? max2 : new Ctor(x);
};
P.comparedTo = P.cmp = function(y) {
  var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
  if (!xd || !yd) {
    return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
  }
  if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
  if (xs !== ys) return xs;
  if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
  xdL = xd.length;
  ydL = yd.length;
  for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
    if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
  }
  return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
};
P.cosine = P.cos = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.d) return new Ctor(NaN);
  if (!x.d[0]) return new Ctor(1);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
  Ctor.rounding = 1;
  x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
};
P.cubeRoot = P.cbrt = function() {
  var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
  if (!x.isFinite() || x.isZero()) return new Ctor(x);
  external = false;
  s = x.s * mathpow(x.s * x, 1 / 3);
  if (!s || Math.abs(s) == 1 / 0) {
    n = digitsToString(x.d);
    e = x.e;
    if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
    s = mathpow(n, 1 / 3);
    e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
    if (s == 1 / 0) {
      n = "5e" + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf("e") + 1) + e;
    }
    r = new Ctor(n);
    r.s = x.s;
  } else {
    r = new Ctor(s.toString());
  }
  sd = (e = Ctor.precision) + 3;
  for (; ; ) {
    t = r;
    t3 = t.times(t).times(t);
    t3plusx = t3.plus(x);
    r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
    if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
      n = n.slice(sd - 3, sd + 1);
      if (n == "9999" || !rep && n == "4999") {
        if (!rep) {
          finalise(t, e + 1, 0);
          if (t.times(t).times(t).eq(x)) {
            r = t;
            break;
          }
        }
        sd += 4;
        rep = 1;
      } else {
        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
          finalise(r, e + 1, 1);
          m = !r.times(r).times(r).eq(x);
        }
        break;
      }
    }
  }
  external = true;
  return finalise(r, e, Ctor.rounding, m);
};
P.decimalPlaces = P.dp = function() {
  var w, d = this.d, n = NaN;
  if (d) {
    w = d.length - 1;
    n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
    w = d[w];
    if (w) for (; w % 10 == 0; w /= 10) n--;
    if (n < 0) n = 0;
  }
  return n;
};
P.dividedBy = P.div = function(y) {
  return divide(this, new this.constructor(y));
};
P.dividedToIntegerBy = P.divToInt = function(y) {
  var x = this, Ctor = x.constructor;
  return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
};
P.equals = P.eq = function(y) {
  return this.cmp(y) === 0;
};
P.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
};
P.greaterThan = P.gt = function(y) {
  return this.cmp(y) > 0;
};
P.greaterThanOrEqualTo = P.gte = function(y) {
  var k = this.cmp(y);
  return k == 1 || k === 0;
};
P.hyperbolicCosine = P.cosh = function() {
  var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
  if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
  if (x.isZero()) return one;
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
  Ctor.rounding = 1;
  len = x.d.length;
  if (len < 32) {
    k = Math.ceil(len / 3);
    n = (1 / tinyPow(4, k)).toString();
  } else {
    k = 16;
    n = "2.3283064365386962890625e-10";
  }
  x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
  var cosh2_x, i = k, d8 = new Ctor(8);
  for (; i--; ) {
    cosh2_x = x.times(x);
    x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
  }
  return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
};
P.hyperbolicSine = P.sinh = function() {
  var k, pr, rm, len, x = this, Ctor = x.constructor;
  if (!x.isFinite() || x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
  Ctor.rounding = 1;
  len = x.d.length;
  if (len < 3) {
    x = taylorSeries(Ctor, 2, x, x, true);
  } else {
    k = 1.4 * Math.sqrt(len);
    k = k > 16 ? 16 : k | 0;
    x = x.times(1 / tinyPow(5, k));
    x = taylorSeries(Ctor, 2, x, x, true);
    var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
    for (; k--; ) {
      sinh2_x = x.times(x);
      x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
    }
  }
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return finalise(x, pr, rm, true);
};
P.hyperbolicTangent = P.tanh = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.isFinite()) return new Ctor(x.s);
  if (x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 7;
  Ctor.rounding = 1;
  return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
};
P.inverseCosine = P.acos = function() {
  var x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
  if (k !== -1) {
    return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
  }
  if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
  Ctor.precision = pr + 6;
  Ctor.rounding = 1;
  x = new Ctor(1).minus(x).div(x.plus(1)).sqrt().atan();
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.times(2);
};
P.inverseHyperbolicCosine = P.acosh = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
  if (!x.isFinite()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
  Ctor.rounding = 1;
  external = false;
  x = x.times(x).minus(1).sqrt().plus(x);
  external = true;
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.ln();
};
P.inverseHyperbolicSine = P.asinh = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.isFinite() || x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
  Ctor.rounding = 1;
  external = false;
  x = x.times(x).plus(1).sqrt().plus(x);
  external = true;
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.ln();
};
P.inverseHyperbolicTangent = P.atanh = function() {
  var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
  if (!x.isFinite()) return new Ctor(NaN);
  if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  xsd = x.sd();
  if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
  Ctor.precision = wpr = xsd - x.e;
  x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
  Ctor.precision = pr + 4;
  Ctor.rounding = 1;
  x = x.ln();
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.times(0.5);
};
P.inverseSine = P.asin = function() {
  var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
  if (x.isZero()) return new Ctor(x);
  k = x.abs().cmp(1);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  if (k !== -1) {
    if (k === 0) {
      halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
      halfPi.s = x.s;
      return halfPi;
    }
    return new Ctor(NaN);
  }
  Ctor.precision = pr + 6;
  Ctor.rounding = 1;
  x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return x.times(2);
};
P.inverseTangent = P.atan = function() {
  var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
  if (!x.isFinite()) {
    if (!x.s) return new Ctor(NaN);
    if (pr + 4 <= PI_PRECISION) {
      r = getPi(Ctor, pr + 4, rm).times(0.5);
      r.s = x.s;
      return r;
    }
  } else if (x.isZero()) {
    return new Ctor(x);
  } else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
    r = getPi(Ctor, pr + 4, rm).times(0.25);
    r.s = x.s;
    return r;
  }
  Ctor.precision = wpr = pr + 10;
  Ctor.rounding = 1;
  k = Math.min(28, wpr / LOG_BASE + 2 | 0);
  for (i = k; i; --i) x = x.div(x.times(x).plus(1).sqrt().plus(1));
  external = false;
  j = Math.ceil(wpr / LOG_BASE);
  n = 1;
  x2 = x.times(x);
  r = new Ctor(x);
  px = x;
  for (; i !== -1; ) {
    px = px.times(x2);
    t = r.minus(px.div(n += 2));
    px = px.times(x2);
    r = t.plus(px.div(n += 2));
    if (r.d[j] !== void 0) for (i = j; r.d[i] === t.d[i] && i--; ) ;
  }
  if (k) r = r.times(2 << k - 1);
  external = true;
  return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
};
P.isFinite = function() {
  return !!this.d;
};
P.isInteger = P.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
};
P.isNaN = function() {
  return !this.s;
};
P.isNegative = P.isNeg = function() {
  return this.s < 0;
};
P.isPositive = P.isPos = function() {
  return this.s > 0;
};
P.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
P.lessThan = P.lt = function(y) {
  return this.cmp(y) < 0;
};
P.lessThanOrEqualTo = P.lte = function(y) {
  return this.cmp(y) < 1;
};
P.logarithm = P.log = function(base) {
  var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
  if (base == null) {
    base = new Ctor(10);
    isBase10 = true;
  } else {
    base = new Ctor(base);
    d = base.d;
    if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
    isBase10 = base.eq(10);
  }
  d = arg.d;
  if (arg.s < 0 || !d || !d[0] || arg.eq(1)) {
    return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
  }
  if (isBase10) {
    if (d.length > 1) {
      inf = true;
    } else {
      for (k = d[0]; k % 10 === 0; ) k /= 10;
      inf = k !== 1;
    }
  }
  external = false;
  sd = pr + guard;
  num = naturalLogarithm(arg, sd);
  denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
  r = divide(num, denominator, sd, 1);
  if (checkRoundingDigits(r.d, k = pr, rm)) {
    do {
      sd += 10;
      num = naturalLogarithm(arg, sd);
      denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
      r = divide(num, denominator, sd, 1);
      if (!inf) {
        if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) {
          r = finalise(r, pr + 1, 0);
        }
        break;
      }
    } while (checkRoundingDigits(r.d, k += 10, rm));
  }
  external = true;
  return finalise(r, pr, rm);
};
P.minus = P.sub = function(y) {
  var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
  y = new Ctor(y);
  if (!x.d || !y.d) {
    if (!x.s || !y.s) y = new Ctor(NaN);
    else if (x.d) y.s = -y.s;
    else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
    return y;
  }
  if (x.s != y.s) {
    y.s = -y.s;
    return x.plus(y);
  }
  xd = x.d;
  yd = y.d;
  pr = Ctor.precision;
  rm = Ctor.rounding;
  if (!xd[0] || !yd[0]) {
    if (yd[0]) y.s = -y.s;
    else if (xd[0]) y = new Ctor(x);
    else return new Ctor(rm === 3 ? -0 : 0);
    return external ? finalise(y, pr, rm) : y;
  }
  e = mathfloor(y.e / LOG_BASE);
  xe = mathfloor(x.e / LOG_BASE);
  xd = xd.slice();
  k = xe - e;
  if (k) {
    xLTy = k < 0;
    if (xLTy) {
      d = xd;
      k = -k;
      len = yd.length;
    } else {
      d = yd;
      e = xe;
      len = xd.length;
    }
    i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
    if (k > i) {
      k = i;
      d.length = 1;
    }
    d.reverse();
    for (i = k; i--; ) d.push(0);
    d.reverse();
  } else {
    i = xd.length;
    len = yd.length;
    xLTy = i < len;
    if (xLTy) len = i;
    for (i = 0; i < len; i++) {
      if (xd[i] != yd[i]) {
        xLTy = xd[i] < yd[i];
        break;
      }
    }
    k = 0;
  }
  if (xLTy) {
    d = xd;
    xd = yd;
    yd = d;
    y.s = -y.s;
  }
  len = xd.length;
  for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
  for (i = yd.length; i > k; ) {
    if (xd[--i] < yd[i]) {
      for (j = i; j && xd[--j] === 0; ) xd[j] = BASE - 1;
      --xd[j];
      xd[i] += BASE;
    }
    xd[i] -= yd[i];
  }
  for (; xd[--len] === 0; ) xd.pop();
  for (; xd[0] === 0; xd.shift()) --e;
  if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
  y.d = xd;
  y.e = getBase10Exponent(xd, e);
  return external ? finalise(y, pr, rm) : y;
};
P.modulo = P.mod = function(y) {
  var q, x = this, Ctor = x.constructor;
  y = new Ctor(y);
  if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
  if (!y.d || x.d && !x.d[0]) {
    return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
  }
  external = false;
  if (Ctor.modulo == 9) {
    q = divide(x, y.abs(), 0, 3, 1);
    q.s *= y.s;
  } else {
    q = divide(x, y, 0, Ctor.modulo, 1);
  }
  q = q.times(y);
  external = true;
  return x.minus(q);
};
P.naturalExponential = P.exp = function() {
  return naturalExponential(this);
};
P.naturalLogarithm = P.ln = function() {
  return naturalLogarithm(this);
};
P.negated = P.neg = function() {
  var x = new this.constructor(this);
  x.s = -x.s;
  return finalise(x);
};
P.plus = P.add = function(y) {
  var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
  y = new Ctor(y);
  if (!x.d || !y.d) {
    if (!x.s || !y.s) y = new Ctor(NaN);
    else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
    return y;
  }
  if (x.s != y.s) {
    y.s = -y.s;
    return x.minus(y);
  }
  xd = x.d;
  yd = y.d;
  pr = Ctor.precision;
  rm = Ctor.rounding;
  if (!xd[0] || !yd[0]) {
    if (!yd[0]) y = new Ctor(x);
    return external ? finalise(y, pr, rm) : y;
  }
  k = mathfloor(x.e / LOG_BASE);
  e = mathfloor(y.e / LOG_BASE);
  xd = xd.slice();
  i = k - e;
  if (i) {
    if (i < 0) {
      d = xd;
      i = -i;
      len = yd.length;
    } else {
      d = yd;
      e = k;
      len = xd.length;
    }
    k = Math.ceil(pr / LOG_BASE);
    len = k > len ? k + 1 : len + 1;
    if (i > len) {
      i = len;
      d.length = 1;
    }
    d.reverse();
    for (; i--; ) d.push(0);
    d.reverse();
  }
  len = xd.length;
  i = yd.length;
  if (len - i < 0) {
    i = len;
    d = yd;
    yd = xd;
    xd = d;
  }
  for (carry = 0; i; ) {
    carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
    xd[i] %= BASE;
  }
  if (carry) {
    xd.unshift(carry);
    ++e;
  }
  for (len = xd.length; xd[--len] == 0; ) xd.pop();
  y.d = xd;
  y.e = getBase10Exponent(xd, e);
  return external ? finalise(y, pr, rm) : y;
};
P.precision = P.sd = function(z) {
  var k, x = this;
  if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
  if (x.d) {
    k = getPrecision(x.d);
    if (z && x.e + 1 > k) k = x.e + 1;
  } else {
    k = NaN;
  }
  return k;
};
P.round = function() {
  var x = this, Ctor = x.constructor;
  return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
};
P.sine = P.sin = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.isFinite()) return new Ctor(NaN);
  if (x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
  Ctor.rounding = 1;
  x = sine(Ctor, toLessThanHalfPi(Ctor, x));
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
};
P.squareRoot = P.sqrt = function() {
  var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
  if (s !== 1 || !d || !d[0]) {
    return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
  }
  external = false;
  s = Math.sqrt(+x);
  if (s == 0 || s == 1 / 0) {
    n = digitsToString(d);
    if ((n.length + e) % 2 == 0) n += "0";
    s = Math.sqrt(n);
    e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
    if (s == 1 / 0) {
      n = "5e" + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf("e") + 1) + e;
    }
    r = new Ctor(n);
  } else {
    r = new Ctor(s.toString());
  }
  sd = (e = Ctor.precision) + 3;
  for (; ; ) {
    t = r;
    r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
    if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
      n = n.slice(sd - 3, sd + 1);
      if (n == "9999" || !rep && n == "4999") {
        if (!rep) {
          finalise(t, e + 1, 0);
          if (t.times(t).eq(x)) {
            r = t;
            break;
          }
        }
        sd += 4;
        rep = 1;
      } else {
        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
          finalise(r, e + 1, 1);
          m = !r.times(r).eq(x);
        }
        break;
      }
    }
  }
  external = true;
  return finalise(r, e, Ctor.rounding, m);
};
P.tangent = P.tan = function() {
  var pr, rm, x = this, Ctor = x.constructor;
  if (!x.isFinite()) return new Ctor(NaN);
  if (x.isZero()) return new Ctor(x);
  pr = Ctor.precision;
  rm = Ctor.rounding;
  Ctor.precision = pr + 10;
  Ctor.rounding = 1;
  x = x.sin();
  x.s = 1;
  x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
  Ctor.precision = pr;
  Ctor.rounding = rm;
  return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
};
P.times = P.mul = function(y) {
  var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
  y.s *= x.s;
  if (!xd || !xd[0] || !yd || !yd[0]) {
    return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
  }
  e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
  xdL = xd.length;
  ydL = yd.length;
  if (xdL < ydL) {
    r = xd;
    xd = yd;
    yd = r;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }
  r = [];
  rL = xdL + ydL;
  for (i = rL; i--; ) r.push(0);
  for (i = ydL; --i >= 0; ) {
    carry = 0;
    for (k = xdL + i; k > i; ) {
      t = r[k] + yd[i] * xd[k - i - 1] + carry;
      r[k--] = t % BASE | 0;
      carry = t / BASE | 0;
    }
    r[k] = (r[k] + carry) % BASE | 0;
  }
  for (; !r[--rL]; ) r.pop();
  if (carry) ++e;
  else r.shift();
  y.d = r;
  y.e = getBase10Exponent(r, e);
  return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
};
P.toBinary = function(sd, rm) {
  return toStringBinary(this, 2, sd, rm);
};
P.toDecimalPlaces = P.toDP = function(dp, rm) {
  var x = this, Ctor = x.constructor;
  x = new Ctor(x);
  if (dp === void 0) return x;
  checkInt32(dp, 0, MAX_DIGITS);
  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);
  return finalise(x, dp + x.e + 1, rm);
};
P.toExponential = function(dp, rm) {
  var str, x = this, Ctor = x.constructor;
  if (dp === void 0) {
    str = finiteToString(x, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    x = finalise(new Ctor(x), dp + 1, rm);
    str = finiteToString(x, true, dp + 1);
  }
  return x.isNeg() && !x.isZero() ? "-" + str : str;
};
P.toFixed = function(dp, rm) {
  var str, y, x = this, Ctor = x.constructor;
  if (dp === void 0) {
    str = finiteToString(x);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    y = finalise(new Ctor(x), dp + x.e + 1, rm);
    str = finiteToString(y, false, dp + y.e + 1);
  }
  return x.isNeg() && !x.isZero() ? "-" + str : str;
};
P.toFraction = function(maxD) {
  var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
  if (!xd) return new Ctor(x);
  n1 = d0 = new Ctor(1);
  d1 = n0 = new Ctor(0);
  d = new Ctor(d1);
  e = d.e = getPrecision(xd) - x.e - 1;
  k = e % LOG_BASE;
  d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
  if (maxD == null) {
    maxD = e > 0 ? d : n1;
  } else {
    n = new Ctor(maxD);
    if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
    maxD = n.gt(d) ? e > 0 ? d : n1 : n;
  }
  external = false;
  n = new Ctor(digitsToString(xd));
  pr = Ctor.precision;
  Ctor.precision = e = xd.length * LOG_BASE * 2;
  for (; ; ) {
    q = divide(n, d, 0, 1, 1);
    d2 = d0.plus(q.times(d1));
    if (d2.cmp(maxD) == 1) break;
    d0 = d1;
    d1 = d2;
    d2 = n1;
    n1 = n0.plus(q.times(d2));
    n0 = d2;
    d2 = d;
    d = n.minus(q.times(d2));
    n = d2;
  }
  d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
  n0 = n0.plus(d2.times(n1));
  d0 = d0.plus(d2.times(d1));
  n0.s = n1.s = x.s;
  r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [n1, d1] : [n0, d0];
  Ctor.precision = pr;
  external = true;
  return r;
};
P.toHexadecimal = P.toHex = function(sd, rm) {
  return toStringBinary(this, 16, sd, rm);
};
P.toNearest = function(y, rm) {
  var x = this, Ctor = x.constructor;
  x = new Ctor(x);
  if (y == null) {
    if (!x.d) return x;
    y = new Ctor(1);
    rm = Ctor.rounding;
  } else {
    y = new Ctor(y);
    if (rm === void 0) {
      rm = Ctor.rounding;
    } else {
      checkInt32(rm, 0, 8);
    }
    if (!x.d) return y.s ? x : y;
    if (!y.d) {
      if (y.s) y.s = x.s;
      return y;
    }
  }
  if (y.d[0]) {
    external = false;
    x = divide(x, y, 0, rm, 1).times(y);
    external = true;
    finalise(x);
  } else {
    y.s = x.s;
    x = y;
  }
  return x;
};
P.toNumber = function() {
  return +this;
};
P.toOctal = function(sd, rm) {
  return toStringBinary(this, 8, sd, rm);
};
P.toPower = P.pow = function(y) {
  var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
  if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
  x = new Ctor(x);
  if (x.eq(1)) return x;
  pr = Ctor.precision;
  rm = Ctor.rounding;
  if (y.eq(1)) return finalise(x, pr, rm);
  e = mathfloor(y.e / LOG_BASE);
  if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
    r = intPow(Ctor, x, k, pr);
    return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
  }
  s = x.s;
  if (s < 0) {
    if (e < y.d.length - 1) return new Ctor(NaN);
    if ((y.d[e] & 1) == 0) s = 1;
    if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
      x.s = s;
      return x;
    }
  }
  k = mathpow(+x, yn);
  e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
  if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
  external = false;
  Ctor.rounding = x.s = 1;
  k = Math.min(12, (e + "").length);
  r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
  if (r.d) {
    r = finalise(r, pr + 5, 1);
    if (checkRoundingDigits(r.d, pr, rm)) {
      e = pr + 10;
      r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
      if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
        r = finalise(r, pr + 1, 0);
      }
    }
  }
  r.s = s;
  external = true;
  Ctor.rounding = rm;
  return finalise(r, pr, rm);
};
P.toPrecision = function(sd, rm) {
  var str, x = this, Ctor = x.constructor;
  if (sd === void 0) {
    str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
    x = finalise(new Ctor(x), sd, rm);
    str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
  }
  return x.isNeg() && !x.isZero() ? "-" + str : str;
};
P.toSignificantDigits = P.toSD = function(sd, rm) {
  var x = this, Ctor = x.constructor;
  if (sd === void 0) {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  }
  return finalise(new Ctor(x), sd, rm);
};
P.toString = function() {
  var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
  return x.isNeg() && !x.isZero() ? "-" + str : str;
};
P.truncated = P.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
};
P.valueOf = P.toJSON = function() {
  var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
  return x.isNeg() ? "-" + str : str;
};
function digitsToString(d) {
  var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
  if (indexOfLastWord > 0) {
    str += w;
    for (i = 1; i < indexOfLastWord; i++) {
      ws = d[i] + "";
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
      str += ws;
    }
    w = d[i];
    ws = w + "";
    k = LOG_BASE - ws.length;
    if (k) str += getZeroString(k);
  } else if (w === 0) {
    return "0";
  }
  for (; w % 10 === 0; ) w /= 10;
  return str + w;
}
function checkInt32(i, min2, max2) {
  if (i !== ~~i || i < min2 || i > max2) {
    throw Error(invalidArgument + i);
  }
}
function checkRoundingDigits(d, i, rm, repeating) {
  var di, k, r, rd;
  for (k = d[0]; k >= 10; k /= 10) --i;
  if (--i < 0) {
    i += LOG_BASE;
    di = 0;
  } else {
    di = Math.ceil((i + 1) / LOG_BASE);
    i %= LOG_BASE;
  }
  k = mathpow(10, LOG_BASE - i);
  rd = d[di] % k | 0;
  if (repeating == null) {
    if (i < 3) {
      if (i == 0) rd = rd / 100 | 0;
      else if (i == 1) rd = rd / 10 | 0;
      r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 5e4 || rd == 0;
    } else {
      r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
    }
  } else {
    if (i < 4) {
      if (i == 0) rd = rd / 1e3 | 0;
      else if (i == 1) rd = rd / 100 | 0;
      else if (i == 2) rd = rd / 10 | 0;
      r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
    } else {
      r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1e3 | 0) == mathpow(10, i - 3) - 1;
    }
  }
  return r;
}
function convertBase(str, baseIn, baseOut) {
  var j, arr = [0], arrL, i = 0, strL = str.length;
  for (; i < strL; ) {
    for (arrL = arr.length; arrL--; ) arr[arrL] *= baseIn;
    arr[0] += NUMERALS.indexOf(str.charAt(i++));
    for (j = 0; j < arr.length; j++) {
      if (arr[j] > baseOut - 1) {
        if (arr[j + 1] === void 0) arr[j + 1] = 0;
        arr[j + 1] += arr[j] / baseOut | 0;
        arr[j] %= baseOut;
      }
    }
  }
  return arr.reverse();
}
function cosine(Ctor, x) {
  var k, len, y;
  if (x.isZero()) return x;
  len = x.d.length;
  if (len < 32) {
    k = Math.ceil(len / 3);
    y = (1 / tinyPow(4, k)).toString();
  } else {
    k = 16;
    y = "2.3283064365386962890625e-10";
  }
  Ctor.precision += k;
  x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
  for (var i = k; i--; ) {
    var cos2x = x.times(x);
    x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
  }
  Ctor.precision -= k;
  return x;
}
var divide = /* @__PURE__ */ (function() {
  function multiplyInteger(x, k, base) {
    var temp, carry = 0, i = x.length;
    for (x = x.slice(); i--; ) {
      temp = x[i] * k + carry;
      x[i] = temp % base | 0;
      carry = temp / base | 0;
    }
    if (carry) x.unshift(carry);
    return x;
  }
  function compare2(a, b, aL, bL) {
    var i, r;
    if (aL != bL) {
      r = aL > bL ? 1 : -1;
    } else {
      for (i = r = 0; i < aL; i++) {
        if (a[i] != b[i]) {
          r = a[i] > b[i] ? 1 : -1;
          break;
        }
      }
    }
    return r;
  }
  function subtract(a, b, aL, base) {
    var i = 0;
    for (; aL--; ) {
      a[aL] -= i;
      i = a[aL] < b[aL] ? 1 : 0;
      a[aL] = i * base + a[aL] - b[aL];
    }
    for (; !a[0] && a.length > 1; ) a.shift();
  }
  return function(x, y, pr, rm, dp, base) {
    var cmp2, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign2 = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
    if (!xd || !xd[0] || !yd || !yd[0]) {
      return new Ctor(
        // Return NaN if either NaN, or both Infinity or 0.
        !x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          xd && xd[0] == 0 || !yd ? sign2 * 0 : sign2 / 0
        )
      );
    }
    if (base) {
      logBase = 1;
      e = x.e - y.e;
    } else {
      base = BASE;
      logBase = LOG_BASE;
      e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
    }
    yL = yd.length;
    xL = xd.length;
    q = new Ctor(sign2);
    qd = q.d = [];
    for (i = 0; yd[i] == (xd[i] || 0); i++) ;
    if (yd[i] > (xd[i] || 0)) e--;
    if (pr == null) {
      sd = pr = Ctor.precision;
      rm = Ctor.rounding;
    } else if (dp) {
      sd = pr + (x.e - y.e) + 1;
    } else {
      sd = pr;
    }
    if (sd < 0) {
      qd.push(1);
      more = true;
    } else {
      sd = sd / logBase + 2 | 0;
      i = 0;
      if (yL == 1) {
        k = 0;
        yd = yd[0];
        sd++;
        for (; (i < xL || k) && sd--; i++) {
          t = k * base + (xd[i] || 0);
          qd[i] = t / yd | 0;
          k = t % yd | 0;
        }
        more = k || i < xL;
      } else {
        k = base / (yd[0] + 1) | 0;
        if (k > 1) {
          yd = multiplyInteger(yd, k, base);
          xd = multiplyInteger(xd, k, base);
          yL = yd.length;
          xL = xd.length;
        }
        xi = yL;
        rem = xd.slice(0, yL);
        remL = rem.length;
        for (; remL < yL; ) rem[remL++] = 0;
        yz = yd.slice();
        yz.unshift(0);
        yd0 = yd[0];
        if (yd[1] >= base / 2) ++yd0;
        do {
          k = 0;
          cmp2 = compare2(yd, rem, yL, remL);
          if (cmp2 < 0) {
            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
            k = rem0 / yd0 | 0;
            if (k > 1) {
              if (k >= base) k = base - 1;
              prod = multiplyInteger(yd, k, base);
              prodL = prod.length;
              remL = rem.length;
              cmp2 = compare2(prod, rem, prodL, remL);
              if (cmp2 == 1) {
                k--;
                subtract(prod, yL < prodL ? yz : yd, prodL, base);
              }
            } else {
              if (k == 0) cmp2 = k = 1;
              prod = yd.slice();
            }
            prodL = prod.length;
            if (prodL < remL) prod.unshift(0);
            subtract(rem, prod, remL, base);
            if (cmp2 == -1) {
              remL = rem.length;
              cmp2 = compare2(yd, rem, yL, remL);
              if (cmp2 < 1) {
                k++;
                subtract(rem, yL < remL ? yz : yd, remL, base);
              }
            }
            remL = rem.length;
          } else if (cmp2 === 0) {
            k++;
            rem = [0];
          }
          qd[i++] = k;
          if (cmp2 && rem[0]) {
            rem[remL++] = xd[xi] || 0;
          } else {
            rem = [xd[xi]];
            remL = 1;
          }
        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
        more = rem[0] !== void 0;
      }
      if (!qd[0]) qd.shift();
    }
    if (logBase == 1) {
      q.e = e;
      inexact = more;
    } else {
      for (i = 1, k = qd[0]; k >= 10; k /= 10) i++;
      q.e = i + e * logBase - 1;
      finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
    }
    return q;
  };
})();
function finalise(x, sd, rm, isTruncated) {
  var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
  out: if (sd != null) {
    xd = x.d;
    if (!xd) return x;
    for (digits = 1, k = xd[0]; k >= 10; k /= 10) digits++;
    i = sd - digits;
    if (i < 0) {
      i += LOG_BASE;
      j = sd;
      w = xd[xdi = 0];
      rd = w / mathpow(10, digits - j - 1) % 10 | 0;
    } else {
      xdi = Math.ceil((i + 1) / LOG_BASE);
      k = xd.length;
      if (xdi >= k) {
        if (isTruncated) {
          for (; k++ <= xdi; ) xd.push(0);
          w = rd = 0;
          digits = 1;
          i %= LOG_BASE;
          j = i - LOG_BASE + 1;
        } else {
          break out;
        }
      } else {
        w = k = xd[xdi];
        for (digits = 1; k >= 10; k /= 10) digits++;
        i %= LOG_BASE;
        j = i - LOG_BASE + digits;
        rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
      }
    }
    isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
    roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
    if (sd < 1 || !xd[0]) {
      xd.length = 0;
      if (roundUp) {
        sd -= x.e + 1;
        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
        x.e = -sd || 0;
      } else {
        xd[0] = x.e = 0;
      }
      return x;
    }
    if (i == 0) {
      xd.length = xdi;
      k = 1;
      xdi--;
    } else {
      xd.length = xdi + 1;
      k = mathpow(10, LOG_BASE - i);
      xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
    }
    if (roundUp) {
      for (; ; ) {
        if (xdi == 0) {
          for (i = 1, j = xd[0]; j >= 10; j /= 10) i++;
          j = xd[0] += k;
          for (k = 1; j >= 10; j /= 10) k++;
          if (i != k) {
            x.e++;
            if (xd[0] == BASE) xd[0] = 1;
          }
          break;
        } else {
          xd[xdi] += k;
          if (xd[xdi] != BASE) break;
          xd[xdi--] = 0;
          k = 1;
        }
      }
    }
    for (i = xd.length; xd[--i] === 0; ) xd.pop();
  }
  if (external) {
    if (x.e > Ctor.maxE) {
      x.d = null;
      x.e = NaN;
    } else if (x.e < Ctor.minE) {
      x.e = 0;
      x.d = [0];
    }
  }
  return x;
}
function finiteToString(x, isExp, sd) {
  if (!x.isFinite()) return nonFiniteToString(x);
  var k, e = x.e, str = digitsToString(x.d), len = str.length;
  if (isExp) {
    if (sd && (k = sd - len) > 0) {
      str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
    } else if (len > 1) {
      str = str.charAt(0) + "." + str.slice(1);
    }
    str = str + (x.e < 0 ? "e" : "e+") + x.e;
  } else if (e < 0) {
    str = "0." + getZeroString(-e - 1) + str;
    if (sd && (k = sd - len) > 0) str += getZeroString(k);
  } else if (e >= len) {
    str += getZeroString(e + 1 - len);
    if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
  } else {
    if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
    if (sd && (k = sd - len) > 0) {
      if (e + 1 === len) str += ".";
      str += getZeroString(k);
    }
  }
  return str;
}
function getBase10Exponent(digits, e) {
  var w = digits[0];
  for (e *= LOG_BASE; w >= 10; w /= 10) e++;
  return e;
}
function getLn10(Ctor, sd, pr) {
  if (sd > LN10_PRECISION) {
    external = true;
    if (pr) Ctor.precision = pr;
    throw Error(precisionLimitExceeded);
  }
  return finalise(new Ctor(LN10), sd, 1, true);
}
function getPi(Ctor, sd, rm) {
  if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
  return finalise(new Ctor(PI), sd, rm, true);
}
function getPrecision(digits) {
  var w = digits.length - 1, len = w * LOG_BASE + 1;
  w = digits[w];
  if (w) {
    for (; w % 10 == 0; w /= 10) len--;
    for (w = digits[0]; w >= 10; w /= 10) len++;
  }
  return len;
}
function getZeroString(k) {
  var zs = "";
  for (; k--; ) zs += "0";
  return zs;
}
function intPow(Ctor, x, n, pr) {
  var isTruncated, r = new Ctor(1), k = Math.ceil(pr / LOG_BASE + 4);
  external = false;
  for (; ; ) {
    if (n % 2) {
      r = r.times(x);
      if (truncate(r.d, k)) isTruncated = true;
    }
    n = mathfloor(n / 2);
    if (n === 0) {
      n = r.d.length - 1;
      if (isTruncated && r.d[n] === 0) ++r.d[n];
      break;
    }
    x = x.times(x);
    truncate(x.d, k);
  }
  external = true;
  return r;
}
function isOdd(n) {
  return n.d[n.d.length - 1] & 1;
}
function maxOrMin(Ctor, args, n) {
  var k, y, x = new Ctor(args[0]), i = 0;
  for (; ++i < args.length; ) {
    y = new Ctor(args[i]);
    if (!y.s) {
      x = y;
      break;
    }
    k = x.cmp(y);
    if (k === n || k === 0 && x.s === n) {
      x = y;
    }
  }
  return x;
}
function naturalExponential(x, sd) {
  var denominator, guard, j, pow2, sum2, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
  if (!x.d || !x.d[0] || x.e > 17) {
    return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
  }
  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }
  t = new Ctor(0.03125);
  while (x.e > -2) {
    x = x.times(t);
    k += 5;
  }
  guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
  wpr += guard;
  denominator = pow2 = sum2 = new Ctor(1);
  Ctor.precision = wpr;
  for (; ; ) {
    pow2 = finalise(pow2.times(x), wpr, 1);
    denominator = denominator.times(++i);
    t = sum2.plus(divide(pow2, denominator, wpr, 1));
    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      j = k;
      while (j--) sum2 = finalise(sum2.times(sum2), wpr, 1);
      if (sd == null) {
        if (rep < 3 && checkRoundingDigits(sum2.d, wpr - guard, rm, rep)) {
          Ctor.precision = wpr += 10;
          denominator = pow2 = t = new Ctor(1);
          i = 0;
          rep++;
        } else {
          return finalise(sum2, Ctor.precision = pr, rm, external = true);
        }
      } else {
        Ctor.precision = pr;
        return sum2;
      }
    }
    sum2 = t;
  }
}
function naturalLogarithm(y, sd) {
  var c, c0, denominator, e, numerator, rep, sum2, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
  if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) {
    return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
  }
  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }
  Ctor.precision = wpr += guard;
  c = digitsToString(xd);
  c0 = c.charAt(0);
  if (Math.abs(e = x.e) < 15e14) {
    while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
      x = x.times(y);
      c = digitsToString(x.d);
      c0 = c.charAt(0);
      n++;
    }
    e = x.e;
    if (c0 > 1) {
      x = new Ctor("0." + c);
      e++;
    } else {
      x = new Ctor(c0 + "." + c.slice(1));
    }
  } else {
    t = getLn10(Ctor, wpr + 2, pr).times(e + "");
    x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
    Ctor.precision = pr;
    return sd == null ? finalise(x, pr, rm, external = true) : x;
  }
  x1 = x;
  sum2 = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
  x2 = finalise(x.times(x), wpr, 1);
  denominator = 3;
  for (; ; ) {
    numerator = finalise(numerator.times(x2), wpr, 1);
    t = sum2.plus(divide(numerator, new Ctor(denominator), wpr, 1));
    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
      sum2 = sum2.times(2);
      if (e !== 0) sum2 = sum2.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
      sum2 = divide(sum2, new Ctor(n), wpr, 1);
      if (sd == null) {
        if (checkRoundingDigits(sum2.d, wpr - guard, rm, rep)) {
          Ctor.precision = wpr += guard;
          t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
          x2 = finalise(x.times(x), wpr, 1);
          denominator = rep = 1;
        } else {
          return finalise(sum2, Ctor.precision = pr, rm, external = true);
        }
      } else {
        Ctor.precision = pr;
        return sum2;
      }
    }
    sum2 = t;
    denominator += 2;
  }
}
function nonFiniteToString(x) {
  return String(x.s * x.s / 0);
}
function parseDecimal(x, str) {
  var e, i, len;
  if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
  if ((i = str.search(/e/i)) > 0) {
    if (e < 0) e = i;
    e += +str.slice(i + 1);
    str = str.substring(0, i);
  } else if (e < 0) {
    e = str.length;
  }
  for (i = 0; str.charCodeAt(i) === 48; i++) ;
  for (len = str.length; str.charCodeAt(len - 1) === 48; --len) ;
  str = str.slice(i, len);
  if (str) {
    len -= i;
    x.e = e = e - i - 1;
    x.d = [];
    i = (e + 1) % LOG_BASE;
    if (e < 0) i += LOG_BASE;
    if (i < len) {
      if (i) x.d.push(+str.slice(0, i));
      for (len -= LOG_BASE; i < len; ) x.d.push(+str.slice(i, i += LOG_BASE));
      str = str.slice(i);
      i = LOG_BASE - str.length;
    } else {
      i -= len;
    }
    for (; i--; ) str += "0";
    x.d.push(+str);
    if (external) {
      if (x.e > x.constructor.maxE) {
        x.d = null;
        x.e = NaN;
      } else if (x.e < x.constructor.minE) {
        x.e = 0;
        x.d = [0];
      }
    }
  } else {
    x.e = 0;
    x.d = [0];
  }
  return x;
}
function parseOther(x, str) {
  var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
  if (str.indexOf("_") > -1) {
    str = str.replace(/(\d)_(?=\d)/g, "$1");
    if (isDecimal.test(str)) return parseDecimal(x, str);
  } else if (str === "Infinity" || str === "NaN") {
    if (!+str) x.s = NaN;
    x.e = NaN;
    x.d = null;
    return x;
  }
  if (isHex.test(str)) {
    base = 16;
    str = str.toLowerCase();
  } else if (isBinary.test(str)) {
    base = 2;
  } else if (isOctal.test(str)) {
    base = 8;
  } else {
    throw Error(invalidArgument + str);
  }
  i = str.search(/p/i);
  if (i > 0) {
    p = +str.slice(i + 1);
    str = str.substring(2, i);
  } else {
    str = str.slice(2);
  }
  i = str.indexOf(".");
  isFloat = i >= 0;
  Ctor = x.constructor;
  if (isFloat) {
    str = str.replace(".", "");
    len = str.length;
    i = len - i;
    divisor = intPow(Ctor, new Ctor(base), i, i * 2);
  }
  xd = convertBase(str, base, BASE);
  xe = xd.length - 1;
  for (i = xe; xd[i] === 0; --i) xd.pop();
  if (i < 0) return new Ctor(x.s * 0);
  x.e = getBase10Exponent(xd, xe);
  x.d = xd;
  external = false;
  if (isFloat) x = divide(x, divisor, len * 4);
  if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
  external = true;
  return x;
}
function sine(Ctor, x) {
  var k, len = x.d.length;
  if (len < 3) {
    return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
  }
  k = 1.4 * Math.sqrt(len);
  k = k > 16 ? 16 : k | 0;
  x = x.times(1 / tinyPow(5, k));
  x = taylorSeries(Ctor, 2, x, x);
  var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
  for (; k--; ) {
    sin2_x = x.times(x);
    x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
  }
  return x;
}
function taylorSeries(Ctor, n, x, y, isHyperbolic) {
  var j, t, u, x2, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
  external = false;
  x2 = x.times(x);
  u = new Ctor(y);
  for (; ; ) {
    t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
    u = isHyperbolic ? y.plus(t) : y.minus(t);
    y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
    t = u.plus(y);
    if (t.d[k] !== void 0) {
      for (j = k; t.d[j] === u.d[j] && j--; ) ;
      if (j == -1) break;
    }
    j = u;
    u = y;
    y = t;
    t = j;
  }
  external = true;
  t.d.length = k + 1;
  return t;
}
function tinyPow(b, e) {
  var n = b;
  while (--e) n *= b;
  return n;
}
function toLessThanHalfPi(Ctor, x) {
  var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
  x = x.abs();
  if (x.lte(halfPi)) {
    quadrant = isNeg ? 4 : 1;
    return x;
  }
  t = x.divToInt(pi);
  if (t.isZero()) {
    quadrant = isNeg ? 3 : 2;
  } else {
    x = x.minus(t.times(pi));
    if (x.lte(halfPi)) {
      quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
      return x;
    }
    quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
  }
  return x.minus(pi).abs();
}
function toStringBinary(x, baseOut, sd, rm) {
  var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
  if (isExp) {
    checkInt32(sd, 1, MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  } else {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  }
  if (!x.isFinite()) {
    str = nonFiniteToString(x);
  } else {
    str = finiteToString(x);
    i = str.indexOf(".");
    if (isExp) {
      base = 2;
      if (baseOut == 16) {
        sd = sd * 4 - 3;
      } else if (baseOut == 8) {
        sd = sd * 3 - 2;
      }
    } else {
      base = baseOut;
    }
    if (i >= 0) {
      str = str.replace(".", "");
      y = new Ctor(1);
      y.e = str.length - i;
      y.d = convertBase(finiteToString(y), 10, base);
      y.e = y.d.length;
    }
    xd = convertBase(str, 10, base);
    e = len = xd.length;
    for (; xd[--len] == 0; ) xd.pop();
    if (!xd[0]) {
      str = isExp ? "0p+0" : "0";
    } else {
      if (i < 0) {
        e--;
      } else {
        x = new Ctor(x);
        x.d = xd;
        x.e = e;
        x = divide(x, y, sd, rm, 0, base);
        xd = x.d;
        e = x.e;
        roundUp = inexact;
      }
      i = xd[sd];
      k = base / 2;
      roundUp = roundUp || xd[sd + 1] !== void 0;
      roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
      xd.length = sd;
      if (roundUp) {
        for (; ++xd[--sd] > base - 1; ) {
          xd[sd] = 0;
          if (!sd) {
            ++e;
            xd.unshift(1);
          }
        }
      }
      for (len = xd.length; !xd[len - 1]; --len) ;
      for (i = 0, str = ""; i < len; i++) str += NUMERALS.charAt(xd[i]);
      if (isExp) {
        if (len > 1) {
          if (baseOut == 16 || baseOut == 8) {
            i = baseOut == 16 ? 4 : 3;
            for (--len; len % i; len++) str += "0";
            xd = convertBase(str, base, baseOut);
            for (len = xd.length; !xd[len - 1]; --len) ;
            for (i = 1, str = "1."; i < len; i++) str += NUMERALS.charAt(xd[i]);
          } else {
            str = str.charAt(0) + "." + str.slice(1);
          }
        }
        str = str + (e < 0 ? "p" : "p+") + e;
      } else if (e < 0) {
        for (; ++e; ) str = "0" + str;
        str = "0." + str;
      } else {
        if (++e > len) for (e -= len; e--; ) str += "0";
        else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
      }
    }
    str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
  }
  return x.s < 0 ? "-" + str : str;
}
function truncate(arr, len) {
  if (arr.length > len) {
    arr.length = len;
    return true;
  }
}
function abs(x) {
  return new this(x).abs();
}
function acos(x) {
  return new this(x).acos();
}
function acosh(x) {
  return new this(x).acosh();
}
function add(x, y) {
  return new this(x).plus(y);
}
function asin(x) {
  return new this(x).asin();
}
function asinh(x) {
  return new this(x).asinh();
}
function atan(x) {
  return new this(x).atan();
}
function atanh(x) {
  return new this(x).atanh();
}
function atan2(y, x) {
  y = new this(y);
  x = new this(x);
  var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
  if (!y.s || !x.s) {
    r = new this(NaN);
  } else if (!y.d && !x.d) {
    r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
    r.s = y.s;
  } else if (!x.d || y.isZero()) {
    r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
    r.s = y.s;
  } else if (!y.d || x.isZero()) {
    r = getPi(this, wpr, 1).times(0.5);
    r.s = y.s;
  } else if (x.s < 0) {
    this.precision = wpr;
    this.rounding = 1;
    r = this.atan(divide(y, x, wpr, 1));
    x = getPi(this, wpr, 1);
    this.precision = pr;
    this.rounding = rm;
    r = y.s < 0 ? r.minus(x) : r.plus(x);
  } else {
    r = this.atan(divide(y, x, wpr, 1));
  }
  return r;
}
function cbrt(x) {
  return new this(x).cbrt();
}
function ceil(x) {
  return finalise(x = new this(x), x.e + 1, 2);
}
function clamp(x, min2, max2) {
  return new this(x).clamp(min2, max2);
}
function config(obj) {
  if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
  var i, p, v, useDefaults = obj.defaults === true, ps = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -EXP_LIMIT,
    0,
    "toExpPos",
    0,
    EXP_LIMIT,
    "maxE",
    0,
    EXP_LIMIT,
    "minE",
    -EXP_LIMIT,
    0,
    "modulo",
    0,
    9
  ];
  for (i = 0; i < ps.length; i += 3) {
    if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
    if ((v = obj[p]) !== void 0) {
      if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
      else throw Error(invalidArgument + p + ": " + v);
    }
  }
  if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
  if ((v = obj[p]) !== void 0) {
    if (v === true || v === false || v === 0 || v === 1) {
      if (v) {
        if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) {
          this[p] = true;
        } else {
          throw Error(cryptoUnavailable);
        }
      } else {
        this[p] = false;
      }
    } else {
      throw Error(invalidArgument + p + ": " + v);
    }
  }
  return this;
}
function cos(x) {
  return new this(x).cos();
}
function cosh(x) {
  return new this(x).cosh();
}
function clone(obj) {
  var i, p, ps;
  function Decimal2(v) {
    var e, i2, t, x = this;
    if (!(x instanceof Decimal2)) return new Decimal2(v);
    x.constructor = Decimal2;
    if (isDecimalInstance(v)) {
      x.s = v.s;
      if (external) {
        if (!v.d || v.e > Decimal2.maxE) {
          x.e = NaN;
          x.d = null;
        } else if (v.e < Decimal2.minE) {
          x.e = 0;
          x.d = [0];
        } else {
          x.e = v.e;
          x.d = v.d.slice();
        }
      } else {
        x.e = v.e;
        x.d = v.d ? v.d.slice() : v.d;
      }
      return;
    }
    t = typeof v;
    if (t === "number") {
      if (v === 0) {
        x.s = 1 / v < 0 ? -1 : 1;
        x.e = 0;
        x.d = [0];
        return;
      }
      if (v < 0) {
        v = -v;
        x.s = -1;
      } else {
        x.s = 1;
      }
      if (v === ~~v && v < 1e7) {
        for (e = 0, i2 = v; i2 >= 10; i2 /= 10) e++;
        if (external) {
          if (e > Decimal2.maxE) {
            x.e = NaN;
            x.d = null;
          } else if (e < Decimal2.minE) {
            x.e = 0;
            x.d = [0];
          } else {
            x.e = e;
            x.d = [v];
          }
        } else {
          x.e = e;
          x.d = [v];
        }
        return;
      }
      if (v * 0 !== 0) {
        if (!v) x.s = NaN;
        x.e = NaN;
        x.d = null;
        return;
      }
      return parseDecimal(x, v.toString());
    }
    if (t === "string") {
      if ((i2 = v.charCodeAt(0)) === 45) {
        v = v.slice(1);
        x.s = -1;
      } else {
        if (i2 === 43) v = v.slice(1);
        x.s = 1;
      }
      return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
    }
    if (t === "bigint") {
      if (v < 0) {
        v = -v;
        x.s = -1;
      } else {
        x.s = 1;
      }
      return parseDecimal(x, v.toString());
    }
    throw Error(invalidArgument + v);
  }
  Decimal2.prototype = P;
  Decimal2.ROUND_UP = 0;
  Decimal2.ROUND_DOWN = 1;
  Decimal2.ROUND_CEIL = 2;
  Decimal2.ROUND_FLOOR = 3;
  Decimal2.ROUND_HALF_UP = 4;
  Decimal2.ROUND_HALF_DOWN = 5;
  Decimal2.ROUND_HALF_EVEN = 6;
  Decimal2.ROUND_HALF_CEIL = 7;
  Decimal2.ROUND_HALF_FLOOR = 8;
  Decimal2.EUCLID = 9;
  Decimal2.config = Decimal2.set = config;
  Decimal2.clone = clone;
  Decimal2.isDecimal = isDecimalInstance;
  Decimal2.abs = abs;
  Decimal2.acos = acos;
  Decimal2.acosh = acosh;
  Decimal2.add = add;
  Decimal2.asin = asin;
  Decimal2.asinh = asinh;
  Decimal2.atan = atan;
  Decimal2.atanh = atanh;
  Decimal2.atan2 = atan2;
  Decimal2.cbrt = cbrt;
  Decimal2.ceil = ceil;
  Decimal2.clamp = clamp;
  Decimal2.cos = cos;
  Decimal2.cosh = cosh;
  Decimal2.div = div;
  Decimal2.exp = exp;
  Decimal2.floor = floor;
  Decimal2.hypot = hypot;
  Decimal2.ln = ln;
  Decimal2.log = log;
  Decimal2.log10 = log10;
  Decimal2.log2 = log2;
  Decimal2.max = max;
  Decimal2.min = min;
  Decimal2.mod = mod;
  Decimal2.mul = mul;
  Decimal2.pow = pow;
  Decimal2.random = random;
  Decimal2.round = round;
  Decimal2.sign = sign;
  Decimal2.sin = sin;
  Decimal2.sinh = sinh;
  Decimal2.sqrt = sqrt;
  Decimal2.sub = sub;
  Decimal2.sum = sum;
  Decimal2.tan = tan;
  Decimal2.tanh = tanh;
  Decimal2.trunc = trunc;
  if (obj === void 0) obj = {};
  if (obj) {
    if (obj.defaults !== true) {
      ps = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"];
      for (i = 0; i < ps.length; ) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }
  }
  Decimal2.config(obj);
  return Decimal2;
}
function div(x, y) {
  return new this(x).div(y);
}
function exp(x) {
  return new this(x).exp();
}
function floor(x) {
  return finalise(x = new this(x), x.e + 1, 3);
}
function hypot() {
  var i, n, t = new this(0);
  external = false;
  for (i = 0; i < arguments.length; ) {
    n = new this(arguments[i++]);
    if (!n.d) {
      if (n.s) {
        external = true;
        return new this(1 / 0);
      }
      t = n;
    } else if (t.d) {
      t = t.plus(n.times(n));
    }
  }
  external = true;
  return t.sqrt();
}
function isDecimalInstance(obj) {
  return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
}
function ln(x) {
  return new this(x).ln();
}
function log(x, y) {
  return new this(x).log(y);
}
function log2(x) {
  return new this(x).log(2);
}
function log10(x) {
  return new this(x).log(10);
}
function max() {
  return maxOrMin(this, arguments, -1);
}
function min() {
  return maxOrMin(this, arguments, 1);
}
function mod(x, y) {
  return new this(x).mod(y);
}
function mul(x, y) {
  return new this(x).mul(y);
}
function pow(x, y) {
  return new this(x).pow(y);
}
function random(sd) {
  var d, e, k, n, i = 0, r = new this(1), rd = [];
  if (sd === void 0) sd = this.precision;
  else checkInt32(sd, 1, MAX_DIGITS);
  k = Math.ceil(sd / LOG_BASE);
  if (!this.crypto) {
    for (; i < k; ) rd[i++] = Math.random() * 1e7 | 0;
  } else if (crypto.getRandomValues) {
    d = crypto.getRandomValues(new Uint32Array(k));
    for (; i < k; ) {
      n = d[i];
      if (n >= 429e7) {
        d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
      } else {
        rd[i++] = n % 1e7;
      }
    }
  } else if (crypto.randomBytes) {
    d = crypto.randomBytes(k *= 4);
    for (; i < k; ) {
      n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 127) << 24);
      if (n >= 214e7) {
        crypto.randomBytes(4).copy(d, i);
      } else {
        rd.push(n % 1e7);
        i += 4;
      }
    }
    i = k / 4;
  } else {
    throw Error(cryptoUnavailable);
  }
  k = rd[--i];
  sd %= LOG_BASE;
  if (k && sd) {
    n = mathpow(10, LOG_BASE - sd);
    rd[i] = (k / n | 0) * n;
  }
  for (; rd[i] === 0; i--) rd.pop();
  if (i < 0) {
    e = 0;
    rd = [0];
  } else {
    e = -1;
    for (; rd[0] === 0; e -= LOG_BASE) rd.shift();
    for (k = 1, n = rd[0]; n >= 10; n /= 10) k++;
    if (k < LOG_BASE) e -= LOG_BASE - k;
  }
  r.e = e;
  r.d = rd;
  return r;
}
function round(x) {
  return finalise(x = new this(x), x.e + 1, this.rounding);
}
function sign(x) {
  x = new this(x);
  return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
}
function sin(x) {
  return new this(x).sin();
}
function sinh(x) {
  return new this(x).sinh();
}
function sqrt(x) {
  return new this(x).sqrt();
}
function sub(x, y) {
  return new this(x).sub(y);
}
function sum() {
  var i = 0, args = arguments, x = new this(args[i]);
  external = false;
  for (; x.s && ++i < args.length; ) x = x.plus(args[i]);
  external = true;
  return finalise(x, this.precision, this.rounding);
}
function tan(x) {
  return new this(x).tan();
}
function tanh(x) {
  return new this(x).tanh();
}
function trunc(x) {
  return finalise(x = new this(x), x.e + 1, 1);
}
P[Symbol.for("nodejs.util.inspect.custom")] = P.toString;
P[Symbol.toStringTag] = "Decimal";
var Decimal = P.constructor = clone(DEFAULTS);
LN10 = new Decimal(LN10);
PI = new Decimal(PI);
var decimal_default = Decimal;

// src/math.ts
function CalculateAmountLimit(expectAmount, byAmountIn, slippage) {
  return Number(
    CalculateAmountLimitByDecimal(
      new decimal_default(expectAmount.toString()),
      byAmountIn,
      slippage
    ).toFixed(0)
  );
}
function CalculateAmountLimitBN(expectAmount, byAmountIn, slippage) {
  const amountLimit = CalculateAmountLimitByDecimal(
    new decimal_default(expectAmount.toString()),
    byAmountIn,
    slippage
  );
  return new import_bn3.default(amountLimit.toFixed(0));
}
function CalculateAmountLimitByDecimal(expectAmount, byAmountIn, slippage) {
  if (byAmountIn) {
    return expectAmount.mul(1 - slippage);
  } else {
    return expectAmount.mul(1 + slippage);
  }
}
var CetusRouter = class {
  constructor(env, partner) {
    this.globalConfig = env === 0 /* Mainnet */ ? "0xdaa46292632c3c4d8f31f23ea0f9b36a28ff3677e9684980e4438403a67a3d8f" : "0xc6273f844b4bc258952c4e477697aa12c918c8e08106fac6b934811298c9820a";
    this.partner = partner ?? (env === 0 /* Mainnet */ ? "0x639b5e433da31739e800cd085f356e64cae222966d0f1b11bd9dc76b322ff58b" : "0xfdc30896f88f74544fd507722d3bf52e46b06412ba8241ba0e854cbc65f8d85f");
  }
  // By amount in
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Cetus not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(swapData.poolId),
      txb.object(this.partner),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::cetus::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
  // By amount out
  flashSwapFixedOutput(txb, path, amountOut, swapContext) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(path.id),
      txb.object(this.partner),
      amountOut,
      txb.pure.bool(path.direction),
      txb.pure.bool(false),
      // isExactIn
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const [flashReceipt, repayAmount] = txb.moveCall({
      target: `${path.publishedAt}::cetus::flash_swap_fixed_output`,
      typeArguments: [coinAType, coinBType],
      arguments: args
    });
    const res = {
      flashReceipt,
      repayAmount
    };
    return res;
  }
  repayFlashSwapFixedOutput(txb, path, swapContext, receipt) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(path.id),
      txb.object(this.partner),
      txb.pure.bool(path.direction),
      receipt
    ];
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    txb.moveCall({
      target: `${path.publishedAt}::cetus::repay_flash_swap_fixed_output`,
      typeArguments: [coinAType, coinBType],
      arguments: args
    });
  }
  add(txb, x, y, publishedAt) {
    const args = [x, y];
    const res = txb.moveCall({
      target: `${publishedAt}::cetus::add`,
      typeArguments: [],
      arguments: args
    });
    return res;
  }
  sub(txb, x, y, publishedAt) {
    const args = [x, y];
    const res = txb.moveCall({
      target: `${publishedAt}::cetus::sub`,
      typeArguments: [],
      arguments: args
    });
    return res;
  }
};
var KriyaV3Router = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Kriya V3 only supported on mainnet");
    }
    this.version = "0xf5145a7ac345ca8736cf8c76047d00d6d378f30e81be6f6eb557184d9de93c78";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Kriya V3 not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object(this.version),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::kriya_clmm::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var FlowxV3Router = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("FlowX V3 only supported on mainnet");
    }
    this.poolRegistry = "0x27565d24a4cd51127ac90e4074a841bbe356cca7bf5759ddc14a975be1632abc";
    this.versioned = "0x67624a1533b5aff5d0dfcf5e598684350efd38134d2d245f475524c03a64e656";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("FlowX V3 not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    const feeRate = path.feeRate * 1e6;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      feeRate
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.poolRegistry),
      txb.object(this.versioned),
      txb.pure.u64(swapData.feeRate),
      txb.pure.u64(swapData.amountIn),
      txb.pure.bool(swapData.direction),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::flowx_clmm::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var TurbosRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Turbos only supported on mainnet");
    }
    this.versioned = "0xf1cf0e81048df168ebeb1b8030fad24b3e0b53ae827c25053fff0779c1445b6f";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Turbos not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    if (path.extendedDetails == null) {
      throw new Error("Extended details not supported");
    } else {
      if (path.extendedDetails.turbos_fee_type == null) {
        throw new Error("Turbos fee type not supported");
      }
    }
    const feeType = path.extendedDetails.turbos_fee_type;
    return {
      coinAType,
      coinBType,
      feeType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object(this.versioned),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::turbos::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType, swapData.feeType],
      arguments: args
    });
  }
};
var BluefinRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Bluefin only supported on mainnet");
    }
    this.globalConfig = "0x03db251ba509a8d5d8777b6338836082335d93eecbdd09a11e190a1cff51c352";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Bluefin not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(swapData.poolId),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::bluefin::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var MomentumRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Momentum only supported on mainnet");
    }
    this.version = "0x2375a0b1ec12010aaea3b2545acfa2ad34cfbba03ce4b59f4c39e1e25eed1b2a";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Momentum not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(this.version),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::momentum::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var MagmaRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Magma only supported on mainnet");
    }
    this.globalConfig = "0x4c4e1402401f72c7d8533d0ed8d5f8949da363c7a3319ccef261ffe153d32f8a";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Magma not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(swapData.poolId),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::magma::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};

// src/movecall/kriya_v2.ts
var KriyaV2Router = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Kriya V2 only supported on mainnet");
    }
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Kriya V2 not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::kriya_amm::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};

// src/movecall/flowx_v2.ts
var FlowxV2Router = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("FlowX V2 only supported on mainnet");
    }
    this.container = "0xb65dcbf63fd3ad5d0ebfbf334780dc9f785eff38a4459e37ab08fa79576ee511";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("FlowX V2 not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.container),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::flowx_amm::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};

// src/movecall/bluemove.ts
var BluemoveRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("BlueMove only supported on mainnet");
    }
    this.dexInfo = "0x3f2d9f724f4a1ce5e71676448dc452be9a6243dac9c5b975a588c8c867066e92";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("BlueMove not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.dexInfo),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::bluemove::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var DeepbookV3Router = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("DeepBook V3 only supported on mainnet");
    }
    this.env = env;
    this.globalConfig = "0x699d455ab8c5e02075b4345ea1f91be55bf46064ae6026cc2528e701ce3ac135";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    if (swapData.needAddDeepPricePoint) {
      this.addDeepPricePoint(txb, swapData);
    }
    this.executeSwapContract(txb, swapData, swapContext, _extends);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("DeepBook V3 not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    const needAddDeepPricePoint = path.extendedDetails?.deepbookv3_need_add_deep_price_point ?? false;
    const referencePoolId = path.extendedDetails?.deepbookv3_reference_pool_id;
    const referencePoolBaseType = path.extendedDetails?.deepbookv3_reference_pool_base_type;
    const referencePoolQuoteType = path.extendedDetails?.deepbookv3_reference_pool_quote_type;
    if (needAddDeepPricePoint) {
      if (!referencePoolId) {
        throw new Error(
          "DeepBook V3: deepbookv3_reference_pool_id is required when deepbookv3_need_add_deep_price_point is true"
        );
      }
      if (!referencePoolBaseType) {
        throw new Error(
          "DeepBook V3: reference_pool_base_type is required when deepbookv3_need_add_deep_price_point is true"
        );
      }
      if (!referencePoolQuoteType) {
        throw new Error(
          "DeepBook V3: reference_pool_quote_type is required when deepbookv3_need_add_deep_price_point is true"
        );
      }
    }
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      needAddDeepPricePoint,
      referencePoolId,
      referencePoolBaseType,
      referencePoolQuoteType
    };
  }
  addDeepPricePoint(txb, swapData) {
    txb.moveCall({
      target: `${swapData.publishedAt}::deepbookv3::add_deep_price_point_v2`,
      typeArguments: [
        swapData.coinAType,
        swapData.coinBType,
        swapData.referencePoolBaseType,
        swapData.referencePoolQuoteType
      ],
      arguments: [
        txb.object(swapData.poolId),
        txb.object(swapData.referencePoolId),
        txb.object(SUI_CLOCK_OBJECT_ID)
      ]
    });
  }
  executeSwapContract(txb, swapData, swapContext, _extends) {
    const deepCoin = _extends?.deepbookv3DeepFee || txb.moveCall({
      target: "0x2::coin::zero",
      typeArguments: [this.getDeepFeeType()]
    });
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(swapData.poolId),
      txb.pure.u64(swapData.amountIn),
      txb.pure.bool(swapData.direction),
      deepCoin,
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::deepbookv3::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
  getDeepFeeType() {
    return this.env === 0 /* Mainnet */ ? DEEPBOOK_V3_DEEP_FEE_TYPES.Mainnet : DEEPBOOK_V3_DEEP_FEE_TYPES.Testnet;
  }
};

// src/movecall/aftermath.ts
var AftermathRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Aftermath only supported on mainnet");
    }
    this.poolRegistry = "0xfcc774493db2c45c79f688f88d28023a3e7d98e4ee9f48bbf5c7990f651577ae";
    this.protocolFeeVault = "0xf194d9b1bcad972e45a7dd67dd49b3ee1e3357a00a50850c52cd51bb450e13b4";
    this.treasury = "0x28e499dff5e864a2eafe476269a4f5035f1c16f338da7be18b103499abf271ce";
    this.insuranceFund = "0xf0c40d67b078000e18032334c3325c47b9ec9f3d9ae4128be820d54663d14e3b";
    this.referralVault = "0x35d35b0e5b177593d8c3a801462485572fc30861e6ce96a55af6dc4730709278";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Aftermath not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? "18446744073709551615" : path.amountIn;
    return {
      coinAType,
      coinBType,
      feeType: path.extendedDetails?.aftermath_lp_supply_type || path.extendedDetails?.aftermath_lp_supply_type || "0x2::sui::SUI",
      // Use LP supply type from path (handle both camelCase and snake_case)
      direction: path.direction,
      amountIn,
      expectAmountOut: path.amountOut,
      // For amount-in swaps, expect_amount_out is 0
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      // swap_ctx
      txb.object(swapData.poolId),
      // pool
      txb.object(this.poolRegistry),
      // pool_registry
      txb.object(this.protocolFeeVault),
      // vault
      txb.object(this.treasury),
      // treasury
      txb.object(this.insuranceFund),
      // insurance_fund
      txb.object(this.referralVault),
      // referral_vault
      txb.pure.bool(swapData.direction),
      // a2b
      txb.pure.u64(swapData.amountIn),
      // amount_in
      txb.pure.u64(swapData.expectAmountOut)
      // expect_amount_out
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::aftermath::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType, swapData.feeType],
      arguments: args
    });
  }
};
var SteammCPMMRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Steamm CPMM only supported on mainnet");
    }
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  validateExtendedDetails(extendedDetails) {
    const requiredFields = [
      "steamm_bank_a",
      "steamm_bank_b",
      "steamm_lending_market",
      "steamm_lending_market_type",
      "steamm_btoken_a_type",
      "steamm_btoken_b_type",
      "steamm_lp_token_type"
    ];
    for (const field of requiredFields) {
      if (extendedDetails[field] == null) {
        throw new Error(`Steamm CPMM ${field} not supported`);
      }
    }
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Steamm CPMM not set publishedAt");
    }
    if (!path.extendedDetails) {
      throw new Error("Extended details not found for Steamm CPMM");
    }
    this.validateExtendedDetails(path.extendedDetails);
    const { direction, from, target } = path;
    const [coinAType, coinBType] = direction ? [from, target] : [target, from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      extendedDetails: path.extendedDetails
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object(swapData.extendedDetails.steamm_bank_a),
      txb.object(swapData.extendedDetails.steamm_bank_b),
      txb.object(swapData.extendedDetails.steamm_lending_market),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::steamm_cpmm::swap`,
      typeArguments: [
        swapData.extendedDetails.steamm_lending_market_type,
        swapData.coinAType,
        swapData.coinBType,
        swapData.extendedDetails.steamm_btoken_a_type,
        swapData.extendedDetails.steamm_btoken_b_type,
        swapData.extendedDetails.steamm_lp_token_type
      ],
      arguments: args
    });
  }
};
var ScallopRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Scallop only supported on mainnet");
    }
    this.version = "0x07871c4b3c847a0f674510d4978d5cf6f960452795e8ff6f189fd2088a3f6ac7";
    this.marketData = "0xa757975255146dc9686aa823b7838b507f315d704f428cbadad2f4ea061939d9";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Scallop not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.from, path.target];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    if (path.extendedDetails == null) {
      throw new Error("Extended details not supported");
    }
    const scallopScoinTreasury = path.extendedDetails.scallop_scoin_treasury;
    if (scallopScoinTreasury == null) {
      throw new Error("Scallop scoin treasury not supported");
    }
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      scallopScoinTreasury
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.version),
      txb.object(this.marketData),
      txb.object(swapData.scallopScoinTreasury),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    const func = swapData.direction ? "swap_a2b" : "swap_b2a";
    txb.moveCall({
      target: `${swapData.publishedAt}::scallop::${func}`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};

// src/movecall/springsui.ts
var SpringsuiRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Springsui only supported on mainnet");
    }
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Springsui not set publishedAt");
    }
    const springSUICoinType = path.direction ? path.target : path.from;
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      springSUICoinType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object("0x5"),
      txb.pure.u64(swapData.amountIn),
      txb.pure.bool(swapData.direction)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::springsui::swap`,
      typeArguments: [swapData.springSUICoinType],
      arguments: args
    });
  }
};
var HaedalPmmRouter = class {
  constructor(env, pythPriceIDs) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Haedal PMM only supported on mainnet");
    }
    this.pythPriceIDs = pythPriceIDs;
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const path = flattenedPath.path;
    if (!path.extendedDetails) {
      throw new Error("Extended details not found for Haedal PMM");
    }
    this.validateExtendedDetails(path.extendedDetails);
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  validateExtendedDetails(extendedDetails) {
    if (!extendedDetails.haedal_pmm_base_price_seed) {
      throw new Error("Haedal PMM base price seed not supported");
    }
    if (!extendedDetails.haedal_pmm_quote_price_seed) {
      throw new Error("Haedal PMM quote price seed not supported");
    }
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Haedal PMM not set publishedAt");
    }
    const extendedDetails = path.extendedDetails;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    const basePriceSeed = extendedDetails.haedal_pmm_base_price_seed;
    const quotePriceSeed = extendedDetails.haedal_pmm_quote_price_seed;
    const basePriceId = this.pythPriceIDs.get(basePriceSeed);
    const quotePriceId = this.pythPriceIDs.get(quotePriceSeed);
    if (!basePriceId || !quotePriceId) {
      throw new Error("Haedal HMM requires oracle price IDs for both coins");
    }
    return {
      coinAType,
      coinBType,
      basePriceId,
      quotePriceId,
      a2b: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      // swap_ctx
      txb.object(swapData.poolId),
      // pool
      txb.object(swapData.basePriceId),
      // base_price_pair_obj
      txb.object(swapData.quotePriceId),
      // quote_price_pair_obj
      txb.pure.u64(swapData.amountIn),
      // amount_in
      txb.pure.bool(swapData.a2b),
      // a2b
      txb.object(SUI_CLOCK_OBJECT_ID)
      // clock
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::haedal_hmm::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var ObricRouter = class {
  constructor(env, pythPriceIDs) {
    if (env === 1 /* Testnet */) {
      throw new Error("Obric is not supported on testnet");
    }
    this.pythStateObjectId = "0x1f9310238ee9298fb703c3419030b35b22bb1cc37113e3bb5007c99aec79e5b8";
    this.pythPriceIDs = pythPriceIDs;
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Obric not set publishedAt");
    }
    if (!path.extendedDetails) {
      throw new Error("Extended details not supported in obric");
    }
    const { direction, from, target } = path;
    const [coinAType, coinBType] = direction ? [from, target] : [target, from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    let coinAPriceInfoObjectId;
    let coinBPriceInfoObjectId;
    if (path.extendedDetails.obric_coin_a_price_seed && path.extendedDetails.obric_coin_b_price_seed) {
      coinAPriceInfoObjectId = this.pythPriceIDs.get(
        path.extendedDetails.obric_coin_a_price_seed
      );
      coinBPriceInfoObjectId = this.pythPriceIDs.get(
        path.extendedDetails.obric_coin_b_price_seed
      );
    } else if (path.extendedDetails.obric_coin_a_price_id && path.extendedDetails.obric_coin_b_price_id) {
      coinAPriceInfoObjectId = path.extendedDetails.obric_coin_a_price_id;
      coinBPriceInfoObjectId = path.extendedDetails.obric_coin_b_price_id;
    } else {
      throw new Error("Base price id or quote price id not supported");
    }
    return {
      coinAType,
      coinBType,
      coinAPriceInfoObjectId,
      coinBPriceInfoObjectId,
      direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      extendedDetails: path.extendedDetails
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    if (!swapData.coinAPriceInfoObjectId || !swapData.coinBPriceInfoObjectId) {
      throw new Error(
        "Base price info object id or quote price info object id not found"
      );
    }
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.pure.u64(swapData.amountIn),
      txb.pure.bool(swapData.direction),
      txb.object(this.pythStateObjectId),
      txb.object(swapData.coinAPriceInfoObjectId),
      txb.object(swapData.coinBPriceInfoObjectId),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::obric::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var SevenkRouter = class {
  constructor(env, pythPriceIDs) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Sevenk only supported on mainnet");
    }
    this.oraclePublishedAt = "0x8c36ea167c5e6da8c3d60b4fc897416105dcb986471bd81cfbfd38720a4487c0";
    this.pythPriceIDs = pythPriceIDs;
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext, _extends);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Sevenk not set publishedAt");
    }
    if (!path.extendedDetails) {
      throw new Error("Extended details not found for Sevenk");
    }
    const { direction, from, target } = path;
    const [func, coinAType, coinBType] = direction ? ["swap_a2b", from, target] : ["swap_b2a", target, from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    const extDetails = path.extendedDetails;
    if (!extDetails.sevenk_coin_a_price_seed || !extDetails.sevenk_coin_b_price_seed || !extDetails.sevenk_oracle_config_a || !extDetails.sevenk_oracle_config_b || !extDetails.sevenk_lp_cap_type) {
      throw new Error("Required Sevenk extended details not found");
    }
    const coinAPriceSeed = extDetails.sevenk_coin_a_price_seed;
    const coinBPriceSeed = extDetails.sevenk_coin_b_price_seed;
    const coinAOracleId = extDetails.sevenk_oracle_config_a;
    const coinBOracleId = extDetails.sevenk_oracle_config_b;
    const lpCapType = extDetails.sevenk_lp_cap_type;
    const coinAPriceId = this.pythPriceIDs.get(coinAPriceSeed);
    const coinBPriceId = this.pythPriceIDs.get(coinBPriceSeed);
    if (!coinAPriceId || !coinBPriceId) {
      throw new Error("Sevenk price info object IDs not found");
    }
    return {
      func,
      coinAType,
      coinBType,
      coinAPriceId,
      coinBPriceId,
      coinAOracleId,
      coinBOracleId,
      lpCapType,
      direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      extendedDetails: path.extendedDetails
    };
  }
  executeSwapContract(txb, swapData, swapContext, _extends) {
    const holder = txb.moveCall({
      target: `${this.oraclePublishedAt}::oracle::new_holder`,
      typeArguments: [],
      arguments: []
    });
    txb.moveCall({
      target: `${this.oraclePublishedAt}::pyth::get_price`,
      typeArguments: [],
      arguments: [
        txb.object(swapData.coinAOracleId),
        holder,
        txb.object(swapData.coinAPriceId),
        txb.object(SUI_CLOCK_OBJECT_ID)
      ]
    });
    txb.moveCall({
      target: `${this.oraclePublishedAt}::pyth::get_price`,
      typeArguments: [],
      arguments: [
        txb.object(swapData.coinBOracleId),
        holder,
        txb.object(swapData.coinBPriceId),
        txb.object(SUI_CLOCK_OBJECT_ID)
      ]
    });
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      holder,
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::sevenk::${swapData.func}`,
      typeArguments: [swapData.coinAType, swapData.coinBType, swapData.lpCapType],
      arguments: args
    });
  }
};
var SteammOmmRouter = class {
  constructor(env, pythPriceIDs) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Steamm OMM only supported on mainnet");
    }
    this.pythPriceIDs = pythPriceIDs;
    this.oraclePackageId = "0xe84b649199654d18c38e727212f5d8dacfc3cf78d60d0a7fc85fd589f280eb2b";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const path = flattenedPath.path;
    if (!path.extendedDetails) {
      throw new Error("Extended details not found for Steamm OMM");
    }
    this.validateExtendedDetails(path.extendedDetails);
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  validateExtendedDetails(extendedDetails) {
    const requiredFields = [
      "steamm_bank_a",
      "steamm_bank_b",
      "steamm_lending_market",
      "steamm_lending_market_type",
      "steamm_btoken_a_type",
      "steamm_btoken_b_type",
      "steamm_lp_token_type",
      "steammOracleRegistryId",
      "steammOracleIndexA",
      "steammOracleIndexB",
      "steammOraclePythPriceSeedA",
      "steammOraclePythPriceSeedB"
    ];
    for (const field of requiredFields) {
      if (extendedDetails[field] == null) {
        throw new Error(`Steamm ${field} not supported`);
      }
    }
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Steamm OMM not set publishedAt");
    }
    const extendedDetails = path.extendedDetails;
    const { direction, from, target } = path;
    const [func, coinAType, coinBType] = direction ? ["swap_a2b_v2", from, target] : ["swap_b2a_v2", target, from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    const priceSeedA = extendedDetails.steamm_oracle_pyth_price_seed_a;
    const priceSeedB = extendedDetails.steamm_oracle_pyth_price_seed_b;
    if (!priceSeedA || !priceSeedB) {
      throw new Error("Steamm oracle price seeds not found");
    }
    const priceInfoObjectIdA = this.pythPriceIDs.get(priceSeedA);
    const priceInfoObjectIdB = this.pythPriceIDs.get(priceSeedB);
    if (!priceInfoObjectIdA || !priceInfoObjectIdB) {
      throw new Error(
        "Base price info object id or quote price info object id not found"
      );
    }
    return {
      func,
      coinAType,
      coinBType,
      direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      extendedDetails,
      priceInfoObjectIdA,
      priceInfoObjectIdB
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const extendedDetails = swapData.extendedDetails;
    const oraclePriceUpdateA = txb.moveCall({
      target: `${this.oraclePackageId}::oracles::get_pyth_price`,
      typeArguments: [],
      arguments: [
        txb.object(extendedDetails.steammOracleRegistryId),
        txb.object(swapData.priceInfoObjectIdA),
        txb.pure.u64(extendedDetails.steammOracleIndexA),
        txb.object(SUI_CLOCK_OBJECT_ID)
      ]
    });
    const oraclePriceUpdateB = txb.moveCall({
      target: `${this.oraclePackageId}::oracles::get_pyth_price`,
      typeArguments: [],
      arguments: [
        txb.object(extendedDetails.steammOracleRegistryId),
        txb.object(swapData.priceInfoObjectIdB),
        txb.pure.u64(extendedDetails.steammOracleIndexB),
        txb.object(SUI_CLOCK_OBJECT_ID)
      ]
    });
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object(extendedDetails.steamm_bank_a),
      txb.object(extendedDetails.steamm_bank_b),
      txb.object(extendedDetails.steamm_lending_market),
      oraclePriceUpdateA,
      oraclePriceUpdateB,
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::steamm_omm::${swapData.func}`,
      typeArguments: [
        extendedDetails.steamm_lending_market_type,
        swapData.coinAType,
        swapData.coinBType,
        extendedDetails.steamm_btoken_a_type,
        extendedDetails.steamm_btoken_b_type,
        extendedDetails.steamm_lp_token_type
      ],
      arguments: args
    });
  }
};
var SteammOmmV2Router = class {
  constructor(env, pythPriceIDs) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Steamm OMM V2 only supported on mainnet");
    }
    this.pythPriceIDs = pythPriceIDs;
    this.oraclePackageId = "0xe84b649199654d18c38e727212f5d8dacfc3cf78d60d0a7fc85fd589f280eb2b";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const path = flattenedPath.path;
    if (!path.extendedDetails) {
      throw new Error("Extended details not found for Steamm OMM V2");
    }
    this.validateExtendedDetails(path.extendedDetails);
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  validateExtendedDetails(extendedDetails) {
    const requiredFields = [
      "steamm_bank_a",
      "steamm_bank_b",
      "steamm_lending_market",
      "steamm_lending_market_type",
      "steamm_btoken_a_type",
      "steamm_btoken_b_type",
      "steamm_lp_token_type",
      "steamm_oracle_registry_id",
      "steamm_oracle_index_a",
      "steamm_oracle_index_b",
      "steamm_oracle_pyth_price_seed_a",
      "steamm_oracle_pyth_price_seed_b"
    ];
    for (const field of requiredFields) {
      if (extendedDetails[field] == null) {
        throw new Error(`Steamm OMM V2 ${field} not supported`);
      }
    }
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Steamm OMM V2 not set publishedAt");
    }
    const extendedDetails = path.extendedDetails;
    const { direction, from, target } = path;
    const [coinAType, coinBType] = direction ? [from, target] : [target, from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    const priceSeedA = extendedDetails.steamm_oracle_pyth_price_seed_a;
    const priceSeedB = extendedDetails.steamm_oracle_pyth_price_seed_b;
    if (!priceSeedA || !priceSeedB) {
      throw new Error("Steamm OMM V2 oracle price seeds not found");
    }
    const priceInfoObjectIdA = this.pythPriceIDs.get(priceSeedA);
    const priceInfoObjectIdB = this.pythPriceIDs.get(priceSeedB);
    if (!priceInfoObjectIdA || !priceInfoObjectIdB) {
      throw new Error(
        "Base price info object id or quote price info object id not found"
      );
    }
    return {
      coinAType,
      coinBType,
      direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      extendedDetails,
      priceInfoObjectIdA,
      priceInfoObjectIdB
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const extendedDetails = swapData.extendedDetails;
    const oraclePriceUpdateA = txb.moveCall({
      target: `${this.oraclePackageId}::oracles::get_pyth_price`,
      typeArguments: [],
      arguments: [
        txb.object(extendedDetails.steamm_oracle_registry_id),
        txb.object(swapData.priceInfoObjectIdA),
        txb.pure.u64(extendedDetails.steamm_oracle_index_a),
        txb.object(SUI_CLOCK_OBJECT_ID)
      ]
    });
    const oraclePriceUpdateB = txb.moveCall({
      target: `${this.oraclePackageId}::oracles::get_pyth_price`,
      typeArguments: [],
      arguments: [
        txb.object(extendedDetails.steamm_oracle_registry_id),
        txb.object(swapData.priceInfoObjectIdB),
        txb.pure.u64(extendedDetails.steamm_oracle_index_b),
        txb.object(SUI_CLOCK_OBJECT_ID)
      ]
    });
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object(extendedDetails.steamm_bank_a),
      txb.object(extendedDetails.steamm_bank_b),
      txb.object(extendedDetails.steamm_lending_market),
      oraclePriceUpdateA,
      oraclePriceUpdateB,
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::steamm_omm_v2::swap`,
      typeArguments: [
        extendedDetails.steamm_lending_market_type,
        swapData.coinAType,
        swapData.coinBType,
        extendedDetails.steamm_btoken_a_type,
        extendedDetails.steamm_btoken_b_type,
        extendedDetails.steamm_lp_token_type
      ],
      arguments: args
    });
  }
};
var SUPER_SUI_TYPE = "0x790f258062909e3a0ffc78b3c53ac2f62d7084c3bab95644bdeb05add7250001::super_sui::SUPER_SUI";
var MUSD_TYPE = "0xe44df51c0b21a27ab915fa1fe2ca610cd3eaa6d9666fe5e62b988bf7f0bd8722::musd::MUSD";
var METH_TYPE = "0xccd628c2334c5ed33e6c47d6c21bb664f8b6307b2ac32c2462a61f69a31ebcee::meth::METH";
var MetastableRouter = class {
  constructor(env, pythPriceIDs) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Metastable only supported on mainnet");
    }
    this.versionID = "0x4696559327b35ff2ab26904e7426a1646312e9c836d5c6cff6709a5ccc30915c";
    this.pythPriceIDs = pythPriceIDs;
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    const depositCap = this.createDepositCap(txb, swapData);
    this.executeSwapContract(txb, swapData, swapContext, depositCap);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Metastable not set publishedAt");
    }
    if (!path.extendedDetails) {
      throw new Error("Extended details not found for Metastable");
    }
    const { direction, from, target } = path;
    const [coinType, metaCoinType] = direction ? [from, target] : [target, from];
    const [func, createCapFunc] = direction ? ["swap_a2b", "create_deposit_cap"] : ["swap_b2a", "create_withdraw_cap"];
    if (!path.extendedDetails.metastable_create_cap_pkg_id || !path.extendedDetails.metastable_create_cap_module || !path.extendedDetails.metastable_whitelisted_app_id) {
      throw new Error(
        "CreateCapPkgId or CreateCapModule or WhitelistedAppId not found in extended details"
      );
    }
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinType,
      metaCoinType,
      func,
      createCapFunc,
      direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id,
      extendedDetails: path.extendedDetails
    };
  }
  createDepositCap(txb, swapData) {
    const createDepositCapTypeArgs = [swapData.metaCoinType];
    if (swapData.extendedDetails.metastable_create_cap_all_type_params) {
      createDepositCapTypeArgs.push(swapData.coinType);
    }
    const depositArgs = [
      txb.object(swapData.extendedDetails.metastable_whitelisted_app_id),
      txb.object(swapData.poolId)
    ];
    switch (swapData.metaCoinType) {
      case SUPER_SUI_TYPE: {
        if (!swapData.extendedDetails.metastable_registry_id) {
          throw new Error("Not found registry id for super sui");
        }
        depositArgs.push(
          txb.object(swapData.extendedDetails.metastable_registry_id)
        );
        break;
      }
      case MUSD_TYPE:
      case METH_TYPE: {
        if (swapData.extendedDetails.metastable_price_seed != null) {
          const priceId = this.pythPriceIDs.get(
            swapData.extendedDetails.metastable_price_seed
          );
          if (priceId == null) {
            throw new Error(
              "Invalid Pyth price feed: " + swapData.extendedDetails.metastable_price_seed
            );
          }
          depositArgs.push(txb.object(priceId));
        }
        if (swapData.extendedDetails.metastable_eth_price_seed != null) {
          const priceId = this.pythPriceIDs.get(
            swapData.extendedDetails.metastable_eth_price_seed
          );
          if (priceId == null) {
            throw new Error(
              "Invalid Pyth price feed: " + swapData.extendedDetails.metastable_eth_price_seed
            );
          }
          depositArgs.push(txb.object(priceId));
        }
        depositArgs.push(txb.object(SUI_CLOCK_OBJECT_ID));
        break;
      }
      default:
        throw new Error("Invalid Metacoin: " + swapData.metaCoinType);
    }
    return txb.moveCall({
      target: `${swapData.extendedDetails.metastable_create_cap_pkg_id}::${swapData.extendedDetails.metastable_create_cap_module}::${swapData.createCapFunc}`,
      typeArguments: createDepositCapTypeArgs,
      arguments: depositArgs
    });
  }
  executeSwapContract(txb, swapData, swapContext, depositCap) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object(this.versionID),
      depositCap,
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::metastable::${swapData.func}`,
      typeArguments: [swapData.coinType, swapData.metaCoinType],
      arguments: args
    });
  }
};

// src/movecall/alphafi.ts
var AlphafiRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Alphafi only supported on mainnet");
    }
    this.suiSystemState = "0x0000000000000000000000000000000000000000000000000000000000000005";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Alphafi not set publishedAt");
    }
    const path = flattenedPath.path;
    const [stSui, stSuiType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType: stSui,
      coinBType: stSuiType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object(this.suiSystemState),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::alphafi::swap`,
      typeArguments: [swapData.coinBType],
      arguments: args
    });
  }
};

// src/movecall/volo.ts
var VoloRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Volo only supported on mainnet");
    }
    this.stakePool = "0x2d914e23d82fedef1b5f56a32d5c64bdcc3087ccfea2b4d6ea51a71f587840e5";
    this.metadata = "0x680cd26af32b2bde8d3361e804c53ec1d1cfe24c7f039eb7f549e8dfde389a60";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Volo not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.stakePool),
      txb.object(this.metadata),
      txb.object("0x5"),
      // SuiSystemState
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::volo::swap`,
      typeArguments: [],
      arguments: args
    });
  }
};

// src/movecall/afsui.ts
var AfsuiRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("afSUI only supported on mainnet");
    }
    this.stakedSuiVault = "0x2f8f6d5da7f13ea37daa397724280483ed062769813b6f31e9788e59cc88994d";
    this.safe = "0xeb685899830dd5837b47007809c76d91a098d52aabbf61e8ac467c59e5cc4610";
    this.referVault = "0x4ce9a19b594599536c53edb25d22532f82f18038dc8ef618afd00fbbfb9845ef";
    this.validator = "0xd30018ec3f5ff1a3c75656abf927a87d7f0529e6dc89c7ddd1bd27ecb05e3db2";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("AFSUI not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    if (!swapData.direction) {
      throw new Error("AFSUI not support b2a swap");
    }
    const args = [
      swapContext,
      txb.object(this.stakedSuiVault),
      txb.object(this.safe),
      txb.object("0x5"),
      // SuiSystemState
      txb.object(this.referVault),
      txb.pure.address(this.validator),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::afsui::swap`,
      typeArguments: [],
      arguments: args
    });
  }
};

// src/movecall/haedal.ts
var HaedalRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Haedal only supported on mainnet");
    }
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Haedal not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(swapData.poolId),
      txb.object("0x5"),
      // SuiSystemState
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::hasui::swap`,
      typeArguments: [],
      arguments: args
    });
  }
};

// src/movecall/hawal.ts
var HawalRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Hawal only supported on mainnet");
    }
    this.staking = "0x10b9d30c28448939ce6c4d6c6e0ffce4a7f8a4ada8248bdad09ef8b70e4a3904";
    this.validator = "0x7b3ba6de2ae58283f60d5b8dc04bb9e90e4796b3b2e0dea75569f491275242e7";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Hawal not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.staking),
      txb.object(swapData.poolId),
      txb.pure.address(this.validator),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::hawal::swap`,
      typeArguments: [],
      arguments: args
    });
  }
};

// src/movecall/router.ts
var defaultAggregatorV3PublishedAt = AGGREGATOR_V3_CONFIG.DEFAULT_PUBLISHED_AT.Mainnet;
function getAggregatorPublishedAt(packages, aggregatorPublishedAt) {
  if (packages && packages.has(PACKAGE_NAMES.AGGREGATOR_V3)) {
    return packages.get(PACKAGE_NAMES.AGGREGATOR_V3);
  }
  return aggregatorPublishedAt || defaultAggregatorV3PublishedAt;
}
function newSwapContext(params, txb) {
  const {
    quoteID,
    fromCoinType,
    targetCoinType,
    expectAmountOut,
    amountOutLimit,
    inputCoin,
    feeRate,
    feeRecipient,
    aggregatorPublishedAt,
    packages
  } = params;
  const publishedAt = getAggregatorPublishedAt(packages, aggregatorPublishedAt);
  const args = [
    txb.pure.string(quoteID),
    txb.pure.u64(expectAmountOut.toString()),
    txb.pure.u64(amountOutLimit.toString()),
    inputCoin,
    txb.pure.u32(Number(feeRate.toString())),
    txb.pure.address(feeRecipient)
  ];
  const swap_context = txb.moveCall({
    target: `${publishedAt}::router::new_swap_context`,
    typeArguments: [fromCoinType, targetCoinType],
    arguments: args
  });
  return swap_context;
}
function newSwapContextV2(params, txb) {
  const {
    quoteID,
    fromCoinType,
    targetCoinType,
    maxAmountIn,
    expectAmountOut,
    amountOutLimit,
    inputCoin,
    feeRate,
    feeRecipient,
    aggregatorPublishedAt,
    packages
  } = params;
  const publishedAt = getAggregatorPublishedAt(packages, aggregatorPublishedAt);
  const args = [
    txb.pure.string(quoteID),
    txb.pure.u64(maxAmountIn.toString()),
    txb.pure.u64(expectAmountOut.toString()),
    txb.pure.u64(amountOutLimit.toString()),
    inputCoin,
    txb.pure.u32(Number(feeRate.toString())),
    txb.pure.address(feeRecipient)
  ];
  const swap_context = txb.moveCall({
    target: `${publishedAt}::router::new_swap_context_v2`,
    typeArguments: [fromCoinType, targetCoinType],
    arguments: args
  });
  return swap_context;
}
function confirmSwap(params, txb) {
  const { swapContext, targetCoinType, aggregatorPublishedAt, packages } = params;
  const publishedAt = getAggregatorPublishedAt(packages, aggregatorPublishedAt);
  const targetCoin = txb.moveCall({
    target: `${publishedAt}::router::confirm_swap`,
    typeArguments: [targetCoinType],
    arguments: [swapContext]
  });
  return targetCoin;
}
function takeBalance(params, txb) {
  const { coinType, amount, swapCtx, aggregatorPublishedAt, packages } = params;
  const publishedAt = getAggregatorPublishedAt(packages, aggregatorPublishedAt);
  const args = [swapCtx, txb.pure.u64(amount.toString())];
  const targetCoin = txb.moveCall({
    target: `${publishedAt}::router::take_balance`,
    typeArguments: [coinType],
    arguments: args
  });
  return targetCoin;
}
function transferBalance(params, txb) {
  const { balance, coinType, recipient, aggregatorPublishedAt, packages } = params;
  const publishedAt = getAggregatorPublishedAt(packages, aggregatorPublishedAt);
  const args = [balance, txb.pure.address(recipient)];
  txb.moveCall({
    target: `${publishedAt}::router::transfer_balance`,
    typeArguments: [coinType],
    arguments: args
  });
}
function transferOrDestroyCoin(params, txb) {
  const { coin, coinType, aggregatorPublishedAt, packages } = params;
  const publishedAt = getAggregatorPublishedAt(packages, aggregatorPublishedAt);
  txb.moveCall({
    target: `${publishedAt}::router::transfer_or_destroy_coin`,
    typeArguments: [coinType],
    arguments: [coin]
  });
}
var MAX_ARGUMENT_SIZE = 16 * 1024;
var PythAdapter = class {
  constructor(client, pythStateId, wormholeStateId, hermesUrls) {
    this.priceFeedObjectIdCache = /* @__PURE__ */ new Map();
    this.client = client;
    this.pythStateId = pythStateId;
    this.wormholeStateId = wormholeStateId;
    const urls = [...hermesUrls];
    if (!urls.includes("https://hermes.pyth.network")) {
      urls.push("https://hermes.pyth.network");
    }
    this.hermesClients = urls.map(
      (url) => new HermesClient(url, { timeout: 3e3 })
    );
  }
  async getPriceFeedsUpdateData(priceIDs) {
    let lastError = null;
    for (const hermes of this.hermesClients) {
      try {
        const response = await hermes.getLatestPriceUpdates(priceIDs, {
          encoding: "hex"
        });
        return response.binary.data.map((hex) => Buffer.from(hex, "hex"));
      } catch (e) {
        lastError = e;
        continue;
      }
    }
    throw new Error(
      `All Pyth Hermes endpoints are unavailable. Detailed error: ${lastError?.message}`
    );
  }
  async getBaseUpdateFee() {
    if (this.baseUpdateFee !== void 0) {
      return this.baseUpdateFee;
    }
    const { object } = await this.client.getObject({
      objectId: this.pythStateId,
      include: { json: true }
    });
    const json = object.json;
    if (!json) {
      throw new Error("Unable to fetch pyth state object");
    }
    this.baseUpdateFee = Number(json.base_update_fee);
    return this.baseUpdateFee;
  }
  async getPackageId(objectId) {
    const { object } = await this.client.getObject({
      objectId,
      include: { json: true }
    });
    const json = object.json;
    if (!json) {
      throw new Error(`Cannot fetch package id for object ${objectId}`);
    }
    if ("upgrade_cap" in json) {
      return json.upgrade_cap.package;
    }
    throw new Error("upgrade_cap not found");
  }
  async getWormholePackageId() {
    if (!this.wormholePackageId) {
      this.wormholePackageId = await this.getPackageId(this.wormholeStateId);
    }
    return this.wormholePackageId;
  }
  async getPythPackageId() {
    if (!this.pythPackageId) {
      this.pythPackageId = await this.getPackageId(this.pythStateId);
    }
    return this.pythPackageId;
  }
  async getPriceFeedObjectId(feedId) {
    const normalizedFeedId = feedId.replace("0x", "");
    if (this.priceFeedObjectIdCache.has(normalizedFeedId)) {
      return this.priceFeedObjectIdCache.get(normalizedFeedId);
    }
    const { id: tableId, fieldType } = await this.getPriceTableInfo();
    const feedIdBytes = Buffer.from(normalizedFeedId, "hex");
    try {
      const PriceIdentifier = bcs.struct("PriceIdentifier", {
        bytes: bcs.vector(bcs.u8())
      });
      const bcsBytes = PriceIdentifier.serialize({ bytes: Array.from(feedIdBytes) }).toBytes();
      const result = await this.client.getDynamicField({
        parentId: tableId,
        name: {
          type: fieldType,
          bcs: bcsBytes
        }
      });
      const valueBcs = result.dynamicField.value.bcs;
      const valueBytes = valueBcs instanceof Uint8Array ? valueBcs : new Uint8Array(Object.values(valueBcs));
      const objectId = "0x" + Array.from(valueBytes).map((b) => b.toString(16).padStart(2, "0")).join("");
      this.priceFeedObjectIdCache.set(normalizedFeedId, objectId);
      return objectId;
    } catch {
      return void 0;
    }
  }
  async getPriceTableInfo() {
    if (this.priceTableInfo !== void 0) {
      return this.priceTableInfo;
    }
    let cursor = null;
    let hasNextPage = true;
    while (hasNextPage) {
      const dynamicFields = await this.client.listDynamicFields({
        parentId: this.pythStateId,
        cursor
      });
      for (const field of dynamicFields.dynamicFields) {
        if (field.name.type === "vector<u8>") {
          const objectId = field.$kind === "DynamicObject" && field.childId ? field.childId : field.fieldId;
          const fieldObj = await this.client.getObject({
            objectId,
            include: { json: true }
          });
          const type = fieldObj.object.type;
          if (type.includes("table::Table")) {
            const innerTypes = type.replace(/.*table::Table</, "").replace(/>$/, "");
            const fieldType = innerTypes.split(",")[0].trim();
            this.priceTableInfo = { id: fieldObj.object.objectId, fieldType };
            return this.priceTableInfo;
          }
        }
      }
      hasNextPage = dynamicFields.hasNextPage;
      cursor = dynamicFields.cursor;
    }
    throw new Error(
      "Price Table not found, contract may not be initialized"
    );
  }
  extractVaaBytesFromAccumulatorMessage(accumulatorMessage) {
    const trailingPayloadSize = accumulatorMessage.readUint8(6);
    const vaaSizeOffset = 7 + trailingPayloadSize + 1;
    const vaaSize = accumulatorMessage.readUint16BE(vaaSizeOffset);
    const vaaOffset = vaaSizeOffset + 2;
    return accumulatorMessage.subarray(vaaOffset, vaaOffset + vaaSize);
  }
  async verifyVaas(vaas, tx) {
    const wormholePackageId = await this.getWormholePackageId();
    const verifiedVaas = [];
    for (const vaa of vaas) {
      const [verifiedVaa] = tx.moveCall({
        target: `${wormholePackageId}::vaa::parse_and_verify`,
        arguments: [
          tx.object(this.wormholeStateId),
          tx.pure(
            bcs.vector(bcs.u8()).serialize(Array.from(vaa), { maxSize: MAX_ARGUMENT_SIZE }).toBytes()
          ),
          tx.object(SUI_CLOCK_OBJECT_ID)
        ]
      });
      verifiedVaas.push(verifiedVaa);
    }
    return verifiedVaas;
  }
  async verifyVaasAndGetHotPotato(tx, updates, packageId) {
    if (updates.length > 1) {
      throw new Error(
        "SDK does not support sending multiple accumulator messages in a single transaction"
      );
    }
    const vaa = this.extractVaaBytesFromAccumulatorMessage(updates[0]);
    const verifiedVaas = await this.verifyVaas([vaa], tx);
    const [priceUpdatesHotPotato] = tx.moveCall({
      target: `${packageId}::pyth::create_authenticated_price_infos_using_accumulator`,
      arguments: [
        tx.object(this.pythStateId),
        tx.pure(
          bcs.vector(bcs.u8()).serialize(Array.from(updates[0]), { maxSize: MAX_ARGUMENT_SIZE }).toBytes()
        ),
        verifiedVaas[0],
        tx.object(SUI_CLOCK_OBJECT_ID)
      ]
    });
    return priceUpdatesHotPotato;
  }
  async updatePriceFeeds(tx, updates, feedIds) {
    const packageId = await this.getPythPackageId();
    let priceUpdatesHotPotato = await this.verifyVaasAndGetHotPotato(
      tx,
      updates,
      packageId
    );
    const baseUpdateFee = await this.getBaseUpdateFee();
    const coins = tx.splitCoins(
      tx.gas,
      feedIds.map(() => tx.pure.u64(baseUpdateFee))
    );
    const priceInfoObjects = [];
    let coinId = 0;
    for (const feedId of feedIds) {
      const priceInfoObjectId = await this.getPriceFeedObjectId(feedId);
      if (!priceInfoObjectId) {
        throw new Error(
          `Price feed ${feedId} not found, please create it first`
        );
      }
      priceInfoObjects.push(priceInfoObjectId);
      [priceUpdatesHotPotato] = tx.moveCall({
        target: `${packageId}::pyth::update_single_price_feed`,
        arguments: [
          tx.object(this.pythStateId),
          priceUpdatesHotPotato,
          tx.object(priceInfoObjectId),
          coins[coinId],
          tx.object(SUI_CLOCK_OBJECT_ID)
        ]
      });
      coinId++;
    }
    tx.moveCall({
      target: `${packageId}::hot_potato_vector::destroy`,
      arguments: [priceUpdatesHotPotato],
      typeArguments: [`${packageId}::price_info::PriceInfo`]
    });
    return priceInfoObjects;
  }
};

// src/utils/uuid.ts
function generateDowngradeUuid6() {
  const timestamp = Date.now();
  const timestampHex = timestamp.toString(16).padStart(12, "0");
  const timeHigh = timestampHex.substring(0, 8);
  const timeMid = timestampHex.substring(8, 12);
  const clockSeq = Math.floor(Math.random() * 16383).toString(16).padStart(4, "0");
  const node = Math.floor(Math.random() * 281474976710655).toString(16).padStart(12, "0");
  const versionedTimeHigh = parseInt(timeHigh, 16) & 268435455 | 1610612736;
  const versionedTimeHighHex = versionedTimeHigh.toString(16).padStart(8, "0");
  const variantClockSeq = parseInt(clockSeq, 16) & 16383 | 32768;
  const variantClockSeqHex = variantClockSeq.toString(16).padStart(4, "0");
  const uuid6 = [
    versionedTimeHighHex,
    timeMid,
    "6" + Math.floor(Math.random() * 4095).toString(16).padStart(3, "0"),
    // Version 6 + random
    variantClockSeqHex,
    node
  ].join("-");
  return `downgrade_${uuid6}`;
}
function generateSimpleDowngradeUuid6() {
  const timestamp = Date.now();
  const randomPart = Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0");
  const timestampHex = timestamp.toString(16);
  return `downgrade_${timestampHex}_${randomPart}`;
}
function isValidDowngradeUuid6(uuid) {
  if (!uuid.startsWith("downgrade_")) {
    return false;
  }
  const uuidPart = uuid.substring(10);
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-6[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const simpleRegex = /^[0-9a-f]+_[0-9a-f]{6}$/i;
  return uuidRegex.test(uuidPart) || simpleRegex.test(uuidPart);
}
function extractTimestampFromDowngradeUuid6(uuid) {
  if (!isValidDowngradeUuid6(uuid)) {
    return null;
  }
  const uuidPart = uuid.substring(10);
  if (uuidPart.includes("_")) {
    const parts2 = uuidPart.split("_");
    if (parts2.length === 2) {
      const timestamp = parseInt(parts2[0], 16);
      return isNaN(timestamp) ? null : timestamp;
    }
  }
  const parts = uuidPart.split("-");
  if (parts.length === 5) {
    try {
      const timeHigh = (parseInt(parts[0], 16) & 268435455).toString(16).padStart(8, "0");
      const timeMid = parts[1];
      const timestampHex = timeHigh + timeMid;
      const timestamp = parseInt(timestampHex, 16);
      return isNaN(timestamp) ? null : timestamp;
    } catch {
      return null;
    }
  }
  return null;
}

// src/utils/api.ts
function processEndpoint(endpoint) {
  if (endpoint.endsWith("/find_routes")) {
    return endpoint.replace("/find_routes", "");
  }
  return endpoint;
}

// src/utils/account_cap.ts
async function getOrCreateAccountCap(txb, client, owner) {
  let accountCapStr = await getAccountCap(client, owner);
  if (accountCapStr !== null) {
    return {
      accountCap: txb.object(accountCapStr),
      isCreate: false
    };
  }
  const accountCap = txb.moveCall({
    target: `${DEEPBOOK_PUBLISHED_AT}::${DEEPBOOK_CLOB_V2_MODULE}::create_account`,
    typeArguments: [],
    arguments: []
  });
  return {
    accountCap,
    isCreate: true
  };
}
async function getAccountCap(client, owner) {
  const limit = 50;
  let cursor = null;
  while (true) {
    const ownedObjects = await client.listOwnedObjects({
      owner,
      cursor,
      limit,
      type: `${DEEPBOOK_PACKAGE_ID}::${DEEPBOOK_CUSTODIAN_V2_MODULE}::AccountCap`
    });
    if (ownedObjects.objects.length !== 0) {
      return ownedObjects.objects[0].objectId;
    }
    if (!ownedObjects.hasNextPage) {
      break;
    }
    cursor = ownedObjects.cursor;
  }
  return null;
}

// src/utils/config.ts
function getAggregatorV2PublishedAt(publishedAt, packages) {
  if (packages?.has("aggregator_v2")) {
    return packages.get("aggregator_v2");
  }
  return publishedAt || PUBLISHED_ADDRESSES.V2.Mainnet;
}
function getAggregatorV2ExtendPublishedAt(publishedAt, packages) {
  if (packages?.has("aggregator_v2_extend")) {
    return packages.get("aggregator_v2_extend");
  }
  return publishedAt || PUBLISHED_ADDRESSES.V2_EXTEND.Mainnet;
}
function getAggregatorV2Extend2PublishedAt(publishedAt, packages) {
  if (packages?.has("aggregator_v2_extend2")) {
    return packages.get("aggregator_v2_extend2");
  }
  return publishedAt || PUBLISHED_ADDRESSES.V2_EXTEND2.Mainnet;
}

// src/utils/gas.ts
var import_bn4 = __toESM(require_bn());
function extractGasMetrics(result) {
  const txResult = result.Transaction ?? result.FailedTransaction;
  const effects = txResult?.effects;
  if (!effects || !effects.status.success) {
    const errorMsg = effects?.status.success === false ? effects.status.error.message : "Unknown error";
    return {
      computationCost: "0",
      storageCost: "0",
      storageRebate: "0",
      nonRefundableStorageFee: "0",
      totalGasCost: "0",
      gasUsed: "0",
      gasPrice: "0",
      success: false,
      error: errorMsg
    };
  }
  const gasUsed = effects.gasUsed;
  return {
    computationCost: gasUsed.computationCost,
    storageCost: gasUsed.storageCost,
    storageRebate: gasUsed.storageRebate,
    nonRefundableStorageFee: gasUsed.nonRefundableStorageFee,
    totalGasCost: calculateTotalGasCost(gasUsed),
    gasUsed: gasUsed.computationCost,
    gasPrice: "1000",
    // Standard Sui gas price in MIST
    success: true
  };
}
function calculateTotalGasCost(gasUsed) {
  const computation = new import_bn4.default(gasUsed.computationCost);
  const storage = new import_bn4.default(gasUsed.storageCost);
  const rebate = new import_bn4.default(gasUsed.storageRebate);
  const nonRefundable = new import_bn4.default(gasUsed.nonRefundableStorageFee);
  return computation.add(storage).sub(rebate).add(nonRefundable).toString();
}
function calculateGasEfficiency(amountOut, totalGasCost) {
  const gasCost = new import_bn4.default(totalGasCost);
  if (gasCost.isZero()) return 0;
  return amountOut.div(gasCost).toNumber();
}
function calculatePriceImpact(amountIn, amountOut, expectedRate = 1) {
  const expectedOut = amountIn.mul(new import_bn4.default(Math.floor(expectedRate * 1e6))).div(new import_bn4.default(1e6));
  if (expectedOut.isZero()) return 0;
  const impact = expectedOut.sub(amountOut).mul(new import_bn4.default(1e4)).div(expectedOut);
  return impact.toNumber() / 100;
}
function compareGasMetrics(v2Analysis, v3Analysis) {
  const v2SuccessfulTests = v2Analysis.filter((a) => a.gasMetrics.success);
  const v3SuccessfulTests = v3Analysis.filter((a) => a.gasMetrics.success);
  const v2AverageGas = calculateAverageGas(v2SuccessfulTests);
  const v3AverageGas = calculateAverageGas(v3SuccessfulTests);
  const gasSavingsPercent = v2AverageGas.isZero() ? 0 : v2AverageGas.sub(v3AverageGas).mul(new import_bn4.default(1e4)).div(v2AverageGas).toNumber() / 100;
  return {
    v2: v2Analysis,
    v3: v3Analysis,
    summary: {
      v2AverageGas: v2AverageGas.toString(),
      v3AverageGas: v3AverageGas.toString(),
      gasSavingsPercent,
      v2SuccessRate: v2SuccessfulTests.length / v2Analysis.length * 100,
      v3SuccessRate: v3SuccessfulTests.length / v3Analysis.length * 100,
      totalTests: v2Analysis.length + v3Analysis.length
    }
  };
}
function calculateAverageGas(analyses) {
  if (analyses.length === 0) return new import_bn4.default(0);
  const totalGas = analyses.reduce((sum2, analysis) => {
    return sum2.add(new import_bn4.default(analysis.gasMetrics.totalGasCost));
  }, new import_bn4.default(0));
  return totalGas.div(new import_bn4.default(analyses.length));
}
function formatGasMetrics(metrics, isEstimated) {
  if (!metrics.success) {
    return `Failed: ${metrics.error}`;
  }
  const totalGas = Number(metrics.totalGasCost);
  const gasInSui = totalGas / 1e9;
  const estimatedFlag = isEstimated ? " (estimated)" : "";
  return `Gas: ${totalGas.toString()} MIST (${gasInSui.toString()} SUI)${estimatedFlag}`;
}
function exportToJSON(comparison) {
  return JSON.stringify(comparison, null, 2);
}
function exportToCSV(comparison) {
  const headers = [
    "Version",
    "Provider",
    "Success",
    "AmountIn",
    "AmountOut",
    "TotalGasCost",
    "ComputationCost",
    "GasEfficiency",
    "PriceImpact",
    "OriginalPaths",
    "MergedPaths",
    "PathReduction%",
    "Timestamp"
  ];
  const rows = [headers.join(",")];
  comparison.v2.forEach((analysis) => {
    const pathReduction = analysis.originalPathCount && analysis.mergedPathCount ? ((analysis.originalPathCount - analysis.mergedPathCount) / analysis.originalPathCount * 100).toFixed(1) : "0";
    rows.push(
      [
        "V2",
        analysis.provider,
        analysis.gasMetrics.success,
        analysis.amountIn.toString(),
        analysis.amountOut.toString(),
        analysis.gasMetrics.totalGasCost,
        analysis.gasMetrics.computationCost,
        analysis.gasEfficiency.toString(),
        analysis.priceImpact.toString(),
        analysis.originalPathCount || 0,
        analysis.mergedPathCount || 0,
        pathReduction,
        analysis.timestamp.toString()
      ].join(",")
    );
  });
  comparison.v3.forEach((analysis) => {
    const pathReduction = analysis.originalPathCount && analysis.mergedPathCount ? ((analysis.originalPathCount - analysis.mergedPathCount) / analysis.originalPathCount * 100).toFixed(1) : "0";
    rows.push(
      [
        "V3",
        analysis.provider,
        analysis.gasMetrics.success,
        analysis.amountIn.toString(),
        analysis.amountOut.toString(),
        analysis.gasMetrics.totalGasCost,
        analysis.gasMetrics.computationCost,
        analysis.gasEfficiency.toString(),
        analysis.priceImpact.toString(),
        analysis.originalPathCount || 0,
        analysis.mergedPathCount || 0,
        pathReduction,
        analysis.timestamp.toString()
      ].join(",")
    );
  });
  return rows.join("\n");
}

// src/utils/msafe.ts
var import_bn5 = __toESM(require_bn());
var dealWithFastRouterSwapParamsForMsafe = (data) => {
  const result = {
    ...data,
    amountIn: data?.amountIn?.toString(),
    amountOut: data?.amountIn?.toString(),
    paths: data?.paths?.map((item) => {
      const info = {
        ...item,
        amountIn: item?.amountIn?.toString(),
        amountOut: item?.amountOut?.toString()
      };
      if (item?.initialPrice) {
        info["initialPrice"] = item?.initialPrice?.toString();
      }
      if (item?.extendedDetails?.after_sqrt_price) {
        info["extendedDetails"] = {
          after_sqrt_price: item?.extendedDetails?.afterSqrtPrice?.toString()
        };
      }
      return info;
    })
  };
  return result;
};
var restituteMsafeFastRouterSwapParams = (data) => {
  const result = {
    ...data,
    amountIn: new import_bn5.default(data?.amountIn),
    amountOut: new import_bn5.default(data?.amountIn),
    paths: data?.paths?.map((item) => {
      const info = {
        ...item
      };
      if (item?.initialPrice) {
        info["initialPrice"] = new decimal_default(item?.initialPrice?.toString());
      }
      if (item?.extendedDetails?.after_sqrt_price) {
        info["extendedDetails"] = {
          after_sqrt_price: new decimal_default(item?.extendedDetails?.after_sqrt_price?.toString())
        };
      }
      return info;
    })
  };
  return result;
};

// src/utils/transaction.ts
async function printTransaction(tx, isPrint = true) {
  console.log(`inputs`, tx.getData().inputs);
  tx.getData().commands.forEach((item, index) => {
    if (isPrint) {
      console.log(
        `transaction ${index}: `,
        JSON.stringify(item, bigIntReplacer, 2)
      );
    }
  });
}
function bigIntReplacer(key, value) {
  if (typeof value === "bigint") {
    return value.toString();
  }
  return value;
}
function checkInvalidSuiAddress(address) {
  if (!address.startsWith("0x") || address.length !== 66) {
    return false;
  }
  return true;
}
var HaedalHMMV2Router = class {
  constructor(env, pythPriceIDs) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Haedal HMM V2 only supported on mainnet");
    }
    this.pythPriceIDs = pythPriceIDs;
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const path = flattenedPath.path;
    if (!path.extendedDetails) {
      throw new Error("Extended details not found for Haedal HMM V2");
    }
    console.log("path.extendedDetails", path.extendedDetails);
    this.validateExtendedDetails(path.extendedDetails);
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  validateExtendedDetails(extendedDetails) {
    if (!extendedDetails.haedalhmmv2_base_price_seed) {
      throw new Error("Haedal HMM V2 base price seed not supported");
    }
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Haedal HMM V2 not set publishedAt");
    }
    const extendedDetails = path.extendedDetails;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    const basePriceSeed = extendedDetails.haedalhmmv2_base_price_seed;
    const basePriceId = this.pythPriceIDs.get(basePriceSeed);
    if (!basePriceId) {
      throw new Error("Haedal HMM V2 requires oracle price IDs for base coin");
    }
    return {
      coinAType,
      coinBType,
      basePriceId,
      a2b: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      // swap_ctx
      txb.object(swapData.poolId),
      // pool
      txb.object(swapData.basePriceId),
      // base_price_pair_obj
      txb.pure.u64(swapData.amountIn),
      // amount_in
      txb.pure.bool(swapData.a2b),
      // a2b
      txb.object(SUI_CLOCK_OBJECT_ID)
      // clock
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::haedal_hmm_v2::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var FullsailRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Fullsail only supported on mainnet");
    }
    this.globalConfig = "0xe93baa80cb570b3a494cbf0621b2ba96bc993926d34dc92508c9446f9a05d615";
    this.vault = "0xfb971d3a2fb98bde74e1c30ba15a3d8bef60a02789e59ae0b91660aeed3e64e1";
    this.stats = "0x6822a33d1d971e040c32f7cc74507010d1fe786f7d06ab89135083ddb07d2dc2";
    this.price_provider = "0x854b2d2c0381bb656ec962f8b443eb082654384cf97885359d1956c7d76e33c9";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    const path = flattenedPath.path;
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Fullsail not set publishedAt");
    }
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(this.vault),
      txb.object(this.stats),
      txb.object(this.price_provider),
      txb.object(swapData.poolId),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::fullsail::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var CetusDlmmRouter = class {
  constructor(env, partner) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("CetusRouter only supported on mainnet");
    }
    this.globalConfig = "0xf31b605d117f959b9730e8c07b08b856cb05143c5e81d5751c90d2979e82f599";
    this.partner = partner ?? "0x59ae16f6c42f578063c2da9b9c0173fe58120ceae08e40fd8212c8eceb80bb86";
    this.versioned = "0x05370b2d656612dd5759cbe80463de301e3b94a921dfc72dd9daa2ecdeb2d0a8";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Cetus not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(swapData.poolId),
      txb.object(this.partner),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(this.versioned),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::cetus_dlmm::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var FerraDlmmRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Ferra DLMM only supported on mainnet");
    }
    this.globalConfig = "0x5c9dacf5a678ea15b8569d65960330307e23d429289ca380e665b1aa175ebeca";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Ferra DLMM not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(swapData.poolId),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::ferra_dlmm::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};
var FerraClmmRouter = class {
  constructor(env) {
    if (env !== 0 /* Mainnet */) {
      throw new Error("Ferra CLMM only supported on mainnet");
    }
    this.globalConfig = "0x2cd8382c19e6994f16df204e9b8cddd04bdc486c251de75ac66ac4e48e3e7081";
  }
  swap(txb, flattenedPath, swapContext, _extends) {
    const swapData = this.prepareSwapData(flattenedPath);
    this.executeSwapContract(txb, swapData, swapContext);
  }
  prepareSwapData(flattenedPath) {
    if (flattenedPath.path.publishedAt == null) {
      throw new Error("Ferra CLMM not set publishedAt");
    }
    const path = flattenedPath.path;
    const [coinAType, coinBType] = path.direction ? [path.from, path.target] : [path.target, path.from];
    const amountIn = flattenedPath.isLastUseOfIntermediateToken ? AGGREGATOR_V3_CONFIG.MAX_AMOUNT_IN : path.amountIn;
    return {
      coinAType,
      coinBType,
      direction: path.direction,
      amountIn,
      publishedAt: path.publishedAt,
      poolId: path.id
    };
  }
  executeSwapContract(txb, swapData, swapContext) {
    const args = [
      swapContext,
      txb.object(this.globalConfig),
      txb.object(swapData.poolId),
      txb.pure.bool(swapData.direction),
      txb.pure.u64(swapData.amountIn),
      txb.object(SUI_CLOCK_OBJECT_ID)
    ];
    txb.moveCall({
      target: `${swapData.publishedAt}::ferra_clmm::swap`,
      typeArguments: [swapData.coinAType, swapData.coinBType],
      arguments: args
    });
  }
};

// src/client.ts
var CETUS = "CETUS";
var DEEPBOOKV2 = "DEEPBOOK";
var KRIYA = "KRIYA";
var FLOWXV2 = "FLOWX";
var FLOWXV3 = "FLOWXV3";
var KRIYAV3 = "KRIYAV3";
var TURBOS = "TURBOS";
var AFTERMATH = "AFTERMATH";
var HAEDAL = "HAEDAL";
var VOLO = "VOLO";
var AFSUI = "AFSUI";
var BLUEMOVE = "BLUEMOVE";
var DEEPBOOKV3 = "DEEPBOOKV3";
var SCALLOP = "SCALLOP";
var SUILEND = "SUILEND";
var BLUEFIN = "BLUEFIN";
var HAEDALPMM = "HAEDALPMM";
var ALPHAFI = "ALPHAFI";
var SPRINGSUI = "SPRINGSUI";
var STEAMM = "STEAMM";
var METASTABLE = "METASTABLE";
var OBRIC = "OBRIC";
var HAWAL = "HAWAL";
var STEAMM_OMM = "STEAMM_OMM";
var MOMENTUM = "MOMENTUM";
var STEAMM_OMM_V2 = "STEAMM_OMM_V2";
var MAGMA = "MAGMA";
var SEVENK = "SEVENK";
var HAEDALHMMV2 = "HAEDALHMMV2";
var FULLSAIL = "FULLSAIL";
var CETUSDLMM = "CETUSDLMM";
var FERRADLMM = "FERRADLMM";
var FERRACLMM = "FERRACLMM";
var DEFAULT_ENDPOINT = "https://api-sui.cetus.zone/router_v3";
var ALL_DEXES = [
  CETUS,
  KRIYA,
  FLOWXV2,
  FLOWXV3,
  KRIYAV3,
  TURBOS,
  AFTERMATH,
  HAEDAL,
  VOLO,
  AFSUI,
  BLUEMOVE,
  DEEPBOOKV3,
  SCALLOP,
  SUILEND,
  BLUEFIN,
  HAEDALPMM,
  ALPHAFI,
  SPRINGSUI,
  STEAMM,
  METASTABLE,
  OBRIC,
  HAWAL,
  MOMENTUM,
  STEAMM_OMM,
  STEAMM_OMM_V2,
  MAGMA,
  SEVENK,
  HAEDALHMMV2,
  FULLSAIL,
  CETUSDLMM,
  FERRADLMM,
  FERRACLMM
];
function getAllProviders() {
  return ALL_DEXES;
}
function getProvidersExcluding(excludeProviders) {
  return ALL_DEXES.filter((provider) => !excludeProviders.includes(provider));
}
function getProvidersIncluding(includeProviders) {
  return ALL_DEXES.filter((provider) => includeProviders.includes(provider));
}
function findPythPriceIDs(paths) {
  const priceIDs = /* @__PURE__ */ new Set();
  for (const path of paths) {
    if (path.provider === HAEDALPMM) {
      if (path.extendedDetails && path.extendedDetails.haedal_pmm_base_price_seed && path.extendedDetails.haedal_pmm_quote_price_seed) {
        priceIDs.add(path.extendedDetails.haedal_pmm_base_price_seed);
        priceIDs.add(path.extendedDetails.haedal_pmm_quote_price_seed);
      }
    }
    if (path.provider === METASTABLE) {
      if (path.extendedDetails && path.extendedDetails.metastable_price_seed) {
        priceIDs.add(path.extendedDetails.metastable_price_seed);
      }
      if (path.extendedDetails && path.extendedDetails.metastable_eth_price_seed) {
        priceIDs.add(path.extendedDetails.metastable_eth_price_seed);
      }
    }
    if (path.provider === OBRIC) {
      if (path.extendedDetails && path.extendedDetails.obric_coin_a_price_seed) {
        priceIDs.add(path.extendedDetails.obric_coin_a_price_seed);
      }
      if (path.extendedDetails && path.extendedDetails.obric_coin_b_price_seed) {
        priceIDs.add(path.extendedDetails.obric_coin_b_price_seed);
      }
    }
    if (path.provider === STEAMM_OMM || path.provider === STEAMM_OMM_V2) {
      if (path.extendedDetails && path.extendedDetails.steamm_oracle_pyth_price_seed_a) {
        priceIDs.add(path.extendedDetails.steamm_oracle_pyth_price_seed_a);
      }
      if (path.extendedDetails && path.extendedDetails.steamm_oracle_pyth_price_seed_b) {
        priceIDs.add(path.extendedDetails.steamm_oracle_pyth_price_seed_b);
      }
    }
    if (path.provider === SEVENK) {
      if (path.extendedDetails) {
        const extDetails = path.extendedDetails;
        if (extDetails.sevenk_coin_a_price_seed) {
          priceIDs.add(extDetails.sevenk_coin_a_price_seed);
        }
        if (extDetails.sevenk_coin_b_price_seed) {
          priceIDs.add(extDetails.sevenk_coin_b_price_seed);
        }
      }
    }
    if (path.provider === HAEDALHMMV2) {
      if (path.extendedDetails && path.extendedDetails.haedalhmmv2_base_price_seed) {
        priceIDs.add(path.extendedDetails.haedalhmmv2_base_price_seed);
      }
    }
  }
  return Array.from(priceIDs);
}
var _AggregatorClient = class _AggregatorClient {
  constructor(params) {
    this.endpoint = params.endpoint ? processEndpoint(params.endpoint) : DEFAULT_ENDPOINT;
    const network = params.env === 1 /* Testnet */ ? "testnet" : "mainnet";
    const grpcUrl = params.env === 1 /* Testnet */ ? "https://fullnode.testnet.sui.io:443" : "https://fullnode.mainnet.sui.io:443";
    this.client = params.client ?? new SuiGrpcClient({ network, baseUrl: grpcUrl });
    this.signer = params.signer || "";
    this.env = params.env || 0 /* Mainnet */;
    const config2 = _AggregatorClient.CONFIG[this.env];
    this.pythAdapter = new PythAdapter(
      this.client,
      config2.pythStateId,
      config2.wormholeStateId,
      params.pythUrls ?? []
    );
    this.apiKey = params.apiKey || "";
    this.partner = params.partner;
    this.cetusDlmmPartner = params.cetusDlmmPartner;
    if (params.overlayFeeRate) {
      if (params.overlayFeeRate > 0 && params.overlayFeeRate <= CLIENT_CONFIG.MAX_OVERLAY_FEE_RATE) {
        this.overlayFeeRate = params.overlayFeeRate * AGGREGATOR_V3_CONFIG.FEE_DENOMINATOR;
        if (this.overlayFeeRate > AGGREGATOR_V3_CONFIG.MAX_FEE_RATE) {
          throw new Error(
            CLIENT_CONFIG.ERRORS.INVALID_OVERLAY_FEE_RATE
          );
        }
      } else {
        throw new Error(CLIENT_CONFIG.ERRORS.INVALID_OVERLAY_FEE_RATE);
      }
    } else {
      this.overlayFeeRate = 0;
    }
    this.overlayFeeReceiver = params.overlayFeeReceiver ?? CLIENT_CONFIG.DEFAULT_OVERLAY_FEE_RECEIVER;
  }
  deepbookv3DeepFeeType() {
    if (this.env === 0 /* Mainnet */) {
      return DEEPBOOK_V3_DEEP_FEE_TYPES.Mainnet;
    } else {
      return DEEPBOOK_V3_DEEP_FEE_TYPES.Testnet;
    }
  }
  async getDeepbookV3Config() {
    return await getDeepbookV3Config(this.endpoint);
  }
  async getOneCoinUsedToMerge(coinType) {
    try {
      const gotCoin = await this.client.listCoins({
        owner: this.signer,
        coinType,
        limit: 1
      });
      if (gotCoin.objects.length === 1) {
        return gotCoin.objects[0].objectId;
      }
      return null;
    } catch (error) {
      return null;
    }
  }
  async findRouters(params) {
    return getRouterResult(
      this.endpoint,
      this.apiKey,
      params,
      this.overlayFeeRate,
      this.overlayFeeReceiver
    );
  }
  async findMergeSwapRouters(params) {
    return getMergeSwapResult(
      this.endpoint,
      this.apiKey,
      params,
      this.overlayFeeRate,
      this.overlayFeeReceiver
    );
  }
  async executeFlexibleInputSwap(txb, inputCoin, routerData, expectedAmountOut, amountLimit, pythPriceIDs, partner, deepbookv3DeepFee, packages) {
  }
  newDexRouterV3(provider, pythPriceIDs, partner, cetusDlmmPartner) {
    switch (provider) {
      case CETUS:
        return new CetusRouter(this.env, partner);
      case KRIYAV3:
        return new KriyaV3Router(this.env);
      case FLOWXV3:
        return new FlowxV3Router(this.env);
      case TURBOS:
        return new TurbosRouter(this.env);
      case BLUEFIN:
        return new BluefinRouter(this.env);
      case MOMENTUM:
        return new MomentumRouter(this.env);
      case MAGMA:
        return new MagmaRouter(this.env);
      case KRIYA:
        return new KriyaV2Router(this.env);
      case FLOWXV2:
        return new FlowxV2Router(this.env);
      case BLUEMOVE:
        return new BluemoveRouter(this.env);
      case DEEPBOOKV3:
        return new DeepbookV3Router(this.env);
      case AFTERMATH:
        return new AftermathRouter(this.env);
      case STEAMM:
        return new SteammCPMMRouter(this.env);
      case SCALLOP:
        return new ScallopRouter(this.env);
      case SUILEND:
        return new SpringsuiRouter(this.env);
      case SPRINGSUI:
        return new SpringsuiRouter(this.env);
      case HAEDALPMM:
        return new HaedalPmmRouter(this.env, pythPriceIDs);
      case OBRIC:
        return new ObricRouter(this.env, pythPriceIDs);
      case SEVENK:
        return new SevenkRouter(this.env, pythPriceIDs);
      case STEAMM_OMM:
        return new SteammOmmRouter(this.env, pythPriceIDs);
      case STEAMM_OMM_V2:
        return new SteammOmmV2Router(this.env, pythPriceIDs);
      case METASTABLE:
        return new MetastableRouter(this.env, pythPriceIDs);
      case ALPHAFI:
        return new AlphafiRouter(this.env);
      case VOLO:
        return new VoloRouter(this.env);
      case AFSUI:
        return new AfsuiRouter(this.env);
      case HAEDAL:
        return new HaedalRouter(this.env);
      case HAWAL:
        return new HawalRouter(this.env);
      case HAEDALHMMV2:
        return new HaedalHMMV2Router(this.env, pythPriceIDs);
      case FULLSAIL:
        return new FullsailRouter(this.env);
      case CETUSDLMM:
        return new CetusDlmmRouter(this.env, cetusDlmmPartner);
      case FERRADLMM:
        return new FerraDlmmRouter(this.env);
      case FERRACLMM:
        return new FerraClmmRouter(this.env);
      default:
        throw new Error(
          `${CLIENT_CONFIG.ERRORS.UNSUPPORTED_DEX} ${provider}`
        );
    }
  }
  expectInputSwapV3(txb, inputCoin, routerData, expectAmountOut, amountOutLimit, pythPriceIDs, partner, cetusDlmmPartner) {
    if (routerData.quoteID == null) {
      throw new Error(CLIENT_CONFIG.ERRORS.QUOTE_ID_REQUIRED);
    }
    const processedData = processFlattenRoutes(routerData);
    const swapCtx = newSwapContext(
      {
        quoteID: processedData.quoteID,
        fromCoinType: processedData.fromCoinType,
        targetCoinType: processedData.targetCoinType,
        expectAmountOut,
        amountOutLimit,
        inputCoin,
        feeRate: this.overlayFeeRate,
        feeRecipient: this.overlayFeeReceiver,
        packages: processedData.packages
      },
      txb
    );
    let dexRouters = /* @__PURE__ */ new Map();
    for (const flattenedPath of processedData.flattenedPaths) {
      const path = flattenedPath.path;
      if (!dexRouters.has(path.provider)) {
        dexRouters.set(
          path.provider,
          this.newDexRouterV3(
            path.provider,
            pythPriceIDs,
            partner,
            cetusDlmmPartner
          )
        );
      }
      const dex = dexRouters.get(path.provider);
      dex.swap(txb, flattenedPath, swapCtx, { pythPriceIDs });
    }
    const outputCoin = confirmSwap(
      {
        swapContext: swapCtx,
        targetCoinType: processedData.targetCoinType,
        packages: processedData.packages
      },
      txb
    );
    return outputCoin;
  }
  expectInputSwapV3WithMaxAmountIn(txb, inputCoin, routerData, maxAmountIn, expectAmountOut, amountOutLimit, pythPriceIDs, partner, cetusDlmmPartner) {
    if (routerData.quoteID == null) {
      throw new Error(CLIENT_CONFIG.ERRORS.QUOTE_ID_REQUIRED);
    }
    const processedData = processFlattenRoutes(routerData);
    const swapCtx = newSwapContextV2(
      {
        quoteID: processedData.quoteID,
        fromCoinType: processedData.fromCoinType,
        targetCoinType: processedData.targetCoinType,
        maxAmountIn,
        expectAmountOut,
        amountOutLimit,
        inputCoin,
        feeRate: this.overlayFeeRate,
        feeRecipient: this.overlayFeeReceiver,
        packages: processedData.packages
      },
      txb
    );
    let dexRouters = /* @__PURE__ */ new Map();
    for (const flattenedPath of processedData.flattenedPaths) {
      const path = flattenedPath.path;
      if (!dexRouters.has(path.provider)) {
        dexRouters.set(
          path.provider,
          this.newDexRouterV3(
            path.provider,
            pythPriceIDs,
            partner,
            cetusDlmmPartner
          )
        );
      }
      const dex = dexRouters.get(path.provider);
      dex.swap(txb, flattenedPath, swapCtx, { pythPriceIDs });
    }
    const outputCoin = confirmSwap(
      {
        swapContext: swapCtx,
        targetCoinType: processedData.targetCoinType,
        packages: processedData.packages
      },
      txb
    );
    return outputCoin;
  }
  expectOutputSwapV3(txb, inputCoin, routerData, amountOut, _amountLimit, partner) {
    const receipts = [];
    const dex = new CetusRouter(this.env, partner);
    const processedData = processFlattenRoutes(routerData);
    const swapCtx = newSwapContext(
      {
        quoteID: processedData.quoteID,
        fromCoinType: processedData.fromCoinType,
        targetCoinType: processedData.targetCoinType,
        expectAmountOut: amountOut,
        amountOutLimit: amountOut,
        // amountOutLimit equals expectAmountOut when fix amout out
        inputCoin,
        feeRate: this.overlayFeeRate,
        feeRecipient: this.overlayFeeReceiver,
        packages: processedData.packages
      },
      txb
    );
    const firstCoinRecord = recordFirstCoinIndex(routerData.paths);
    let needRepayRecord = /* @__PURE__ */ new Map();
    let payRecord = /* @__PURE__ */ new Map();
    for (let j = routerData.paths.length - 1; j >= 0; j--) {
      const path = routerData.paths[j];
      const firstFromTokenIndex = firstCoinRecord.get(path.from);
      let amountArg;
      if (j !== firstFromTokenIndex || path.target === processedData.targetCoinType) {
        if (path.target !== processedData.targetCoinType) {
          let payAmount = BigInt(path.amountOut);
          if (payRecord.has(path.target)) {
            const oldPayAmount = payRecord.get(path.target);
            payAmount = oldPayAmount + payAmount;
          }
          payRecord.set(path.target, payAmount);
        }
        amountArg = txb.pure.u64(
          path.amountOut.toString()
        );
      } else {
        if (!needRepayRecord.has(path.target)) {
          throw Error("no need repay record");
        }
        if (payRecord.has(path.target)) {
          const oldPayAmount = payRecord.get(path.target);
          const oldNeedRepay = needRepayRecord.get(path.target);
          amountArg = dex.sub(
            txb,
            oldNeedRepay,
            txb.pure.u64(oldPayAmount),
            path.publishedAt
          );
        } else {
          amountArg = needRepayRecord.get(path.target);
        }
      }
      const flashSwapResult = dex.flashSwapFixedOutput(
        txb,
        path,
        amountArg,
        swapCtx
      );
      receipts.unshift(flashSwapResult.flashReceipt);
      if (needRepayRecord.has(path.from)) {
        const oldNeedRepay = needRepayRecord.get(path.from);
        needRepayRecord.set(
          path.from,
          dex.add(
            txb,
            oldNeedRepay,
            flashSwapResult.repayAmount,
            path.publishedAt
          )
        );
      } else {
        needRepayRecord.set(path.from, flashSwapResult.repayAmount);
      }
    }
    for (let j = 0; j < routerData.paths.length; j++) {
      const path = routerData.paths[j];
      dex.repayFlashSwapFixedOutput(txb, path, swapCtx, receipts[j]);
    }
    const remainInputBalance = takeBalance(
      {
        coinType: processedData.fromCoinType,
        amount: U64_MAX,
        swapCtx,
        packages: processedData.packages
      },
      txb
    );
    transferBalance(
      {
        balance: remainInputBalance,
        coinType: processedData.fromCoinType,
        recipient: this.signer,
        packages: processedData.packages
      },
      txb
    );
    const outputCoin = confirmSwap(
      {
        swapContext: swapCtx,
        targetCoinType: processedData.targetCoinType,
        packages: processedData.packages
      },
      txb
    );
    return outputCoin;
  }
  expectOutputSwapV3WithMaxAmountIn(txb, inputCoin, routerData, maxAmountIn, amountOut, _amountLimit, partner) {
    const receipts = [];
    const dex = new CetusRouter(this.env, partner);
    const processedData = processFlattenRoutes(routerData);
    const swapCtx = newSwapContextV2(
      {
        quoteID: processedData.quoteID,
        fromCoinType: processedData.fromCoinType,
        targetCoinType: processedData.targetCoinType,
        maxAmountIn,
        expectAmountOut: amountOut,
        amountOutLimit: amountOut,
        // amountOutLimit equals expectAmountOut when fix amout out
        inputCoin,
        feeRate: this.overlayFeeRate,
        feeRecipient: this.overlayFeeReceiver,
        packages: processedData.packages
      },
      txb
    );
    const firstCoinRecord = recordFirstCoinIndex(routerData.paths);
    let needRepayRecord = /* @__PURE__ */ new Map();
    let payRecord = /* @__PURE__ */ new Map();
    for (let j = routerData.paths.length - 1; j >= 0; j--) {
      const path = routerData.paths[j];
      const firstFromTokenIndex = firstCoinRecord.get(path.from);
      let amountArg;
      if (j !== firstFromTokenIndex || path.target === processedData.targetCoinType) {
        if (path.target !== processedData.targetCoinType) {
          let payAmount = BigInt(path.amountOut);
          if (payRecord.has(path.target)) {
            const oldPayAmount = payRecord.get(path.target);
            payAmount = oldPayAmount + payAmount;
          }
          payRecord.set(path.target, payAmount);
        }
        amountArg = txb.pure.u64(
          path.amountOut.toString()
        );
      } else {
        if (!needRepayRecord.has(path.target)) {
          throw Error("no need repay record");
        }
        if (payRecord.has(path.target)) {
          const oldPayAmount = payRecord.get(path.target);
          const oldNeedRepay = needRepayRecord.get(path.target);
          amountArg = dex.sub(
            txb,
            oldNeedRepay,
            txb.pure.u64(oldPayAmount),
            path.publishedAt
          );
        } else {
          amountArg = needRepayRecord.get(path.target);
        }
      }
      const flashSwapResult = dex.flashSwapFixedOutput(
        txb,
        path,
        amountArg,
        swapCtx
      );
      receipts.unshift(flashSwapResult.flashReceipt);
      if (needRepayRecord.has(path.from)) {
        const oldNeedRepay = needRepayRecord.get(path.from);
        needRepayRecord.set(
          path.from,
          dex.add(
            txb,
            oldNeedRepay,
            flashSwapResult.repayAmount,
            path.publishedAt
          )
        );
      } else {
        needRepayRecord.set(path.from, flashSwapResult.repayAmount);
      }
    }
    for (let j = 0; j < routerData.paths.length; j++) {
      const path = routerData.paths[j];
      dex.repayFlashSwapFixedOutput(txb, path, swapCtx, receipts[j]);
    }
    const remainInputBalance = takeBalance(
      {
        coinType: processedData.fromCoinType,
        amount: U64_MAX,
        swapCtx,
        packages: processedData.packages
      },
      txb
    );
    transferBalance(
      {
        balance: remainInputBalance,
        coinType: processedData.fromCoinType,
        recipient: this.signer,
        packages: processedData.packages
      },
      txb
    );
    const outputCoin = confirmSwap(
      {
        swapContext: swapCtx,
        targetCoinType: processedData.targetCoinType,
        packages: processedData.packages
      },
      txb
    );
    return outputCoin;
  }
  async routerSwap(params) {
    const { router, inputCoin, slippage, txb, partner, cetusDlmmPartner } = params;
    if (slippage > 1 || slippage < 0) {
      throw new Error(CLIENT_CONFIG.ERRORS.INVALID_SLIPPAGE);
    }
    if (!params.router.packages || !params.router.packages.get(PACKAGE_NAMES.AGGREGATOR_V3)) {
      throw new Error(CLIENT_CONFIG.ERRORS.PACKAGES_REQUIRED);
    }
    const byAmountIn = params.router.byAmountIn;
    const amountIn = router.amountIn;
    const amountOut = router.amountOut;
    checkOverlayFeeConfig(this.overlayFeeRate, this.overlayFeeReceiver);
    let overlayFee = new import_bn6.default(0);
    if (byAmountIn) {
      overlayFee = amountOut.mul(new import_bn6.default(this.overlayFeeRate)).div(new import_bn6.default(1e6));
    } else {
      overlayFee = amountIn.mul(new import_bn6.default(this.overlayFeeRate)).div(new import_bn6.default(1e6));
    }
    const expectedAmountOut = byAmountIn ? amountOut.sub(overlayFee) : amountOut;
    const expectedAmountIn = byAmountIn ? amountIn : amountIn.add(overlayFee);
    const amountLimit = CalculateAmountLimitBN(
      byAmountIn ? expectedAmountOut : expectedAmountIn,
      byAmountIn,
      slippage
    );
    const priceIDs = findPythPriceIDs(router.paths);
    const priceInfoObjectIds = priceIDs.length > 0 ? await this.updatePythPriceIDs(priceIDs, txb) : /* @__PURE__ */ new Map();
    if (byAmountIn) {
      return this.expectInputSwapV3(
        txb,
        inputCoin,
        router,
        amountOut.toString(),
        amountLimit.toString(),
        priceInfoObjectIds,
        partner ?? this.partner,
        cetusDlmmPartner ?? this.cetusDlmmPartner
      );
    } else {
      return this.expectOutputSwapV3(
        txb,
        inputCoin,
        router,
        amountOut.toString(),
        amountLimit.toString(),
        partner ?? this.partner
      );
    }
  }
  /**
   * Router swap with max amount in validation.
   * This method validates that the input coin amount does not exceed maxAmountIn.
   * If the validation fails, the transaction will abort with an error.
   *
   * @param params - Router swap parameters with maxAmountIn
   * @returns TransactionObjectArgument - The output coin from the swap
   * @throws Error if input coin amount exceeds maxAmountIn
   */
  async routerSwapWithMaxAmountIn(params) {
    const { router, inputCoin, slippage, txb, partner, maxAmountIn } = params;
    if (slippage > 1 || slippage < 0) {
      throw new Error(CLIENT_CONFIG.ERRORS.INVALID_SLIPPAGE);
    }
    if (!params.router.packages || !params.router.packages.get(PACKAGE_NAMES.AGGREGATOR_V3)) {
      throw new Error(CLIENT_CONFIG.ERRORS.PACKAGES_REQUIRED);
    }
    const byAmountIn = params.router.byAmountIn;
    const amountIn = router.amountIn;
    const amountOut = router.amountOut;
    checkOverlayFeeConfig(this.overlayFeeRate, this.overlayFeeReceiver);
    let overlayFee = new import_bn6.default(0);
    if (byAmountIn) {
      overlayFee = amountOut.mul(new import_bn6.default(this.overlayFeeRate)).div(new import_bn6.default(1e6));
    } else {
      overlayFee = amountIn.mul(new import_bn6.default(this.overlayFeeRate)).div(new import_bn6.default(1e6));
    }
    const expectedAmountOut = byAmountIn ? amountOut.sub(overlayFee) : amountOut;
    const expectedAmountIn = byAmountIn ? amountIn : amountIn.add(overlayFee);
    const amountLimit = CalculateAmountLimitBN(
      byAmountIn ? expectedAmountOut : expectedAmountIn,
      byAmountIn,
      slippage
    );
    const priceIDs = findPythPriceIDs(router.paths);
    const priceInfoObjectIds = priceIDs.length > 0 ? await this.updatePythPriceIDs(priceIDs, txb) : /* @__PURE__ */ new Map();
    if (byAmountIn) {
      return this.expectInputSwapV3WithMaxAmountIn(
        txb,
        inputCoin,
        router,
        maxAmountIn,
        amountOut.toString(),
        amountLimit.toString(),
        priceInfoObjectIds,
        partner ?? this.partner
      );
    } else {
      return this.expectOutputSwapV3WithMaxAmountIn(
        txb,
        inputCoin,
        router,
        maxAmountIn,
        amountOut.toString(),
        amountLimit.toString(),
        partner ?? this.partner
      );
    }
  }
  // auto build input coin
  // auto merge, transfer or destory target coin.
  async fastRouterSwap(params) {
    const { router, slippage, txb, partner, cetusDlmmPartner, payDeepFeeAmount } = params;
    const fromCoinType = router.paths[0].from;
    const targetCoinType = router.paths[router.paths.length - 1].target;
    const byAmountIn = router.byAmountIn;
    checkOverlayFeeConfig(this.overlayFeeRate, this.overlayFeeReceiver);
    let overlayFee = 0;
    if (byAmountIn) {
      overlayFee = Number(
        router.amountOut.mul(new import_bn6.default(this.overlayFeeRate)).div(new import_bn6.default(1e6)).toString()
      );
    } else {
      overlayFee = Number(
        router.amountIn.mul(new import_bn6.default(this.overlayFeeRate)).div(new import_bn6.default(1e6)).toString()
      );
    }
    const expectedAmountOut = byAmountIn ? router.amountOut.sub(new import_bn6.default(overlayFee)) : router.amountOut;
    const expectedAmountIn = byAmountIn ? router.amountIn : router.amountIn.add(new import_bn6.default(overlayFee));
    const amountLimit = CalculateAmountLimit(
      byAmountIn ? expectedAmountOut : expectedAmountIn,
      byAmountIn,
      slippage
    );
    const amount = byAmountIn ? expectedAmountIn : amountLimit;
    let inputCoin = coinWithBalance({
      balance: BigInt(amount.toString()),
      useGasCoin: true,
      type: fromCoinType
    });
    let deepCoin;
    if (payDeepFeeAmount && payDeepFeeAmount > 0) {
      deepCoin = coinWithBalance({
        balance: BigInt(payDeepFeeAmount),
        type: this.deepbookv3DeepFeeType()
      });
    }
    const routerSwapParams = {
      router,
      inputCoin,
      slippage,
      txb,
      partner: partner ?? this.partner,
      cetusDlmmPartner: cetusDlmmPartner ?? this.cetusDlmmPartner,
      deepbookv3DeepFee: deepCoin
    };
    const targetCoin = await this.routerSwap(routerSwapParams);
    if (CoinUtils.isSuiCoin(targetCoinType)) {
      txb.mergeCoins(txb.gas, [targetCoin]);
    } else {
      const targetCoinObjID = await this.getOneCoinUsedToMerge(targetCoinType);
      if (targetCoinObjID != null) {
        txb.mergeCoins(txb.object(targetCoinObjID), [targetCoin]);
      } else {
        transferOrDestroyCoin(
          {
            coin: targetCoin,
            coinType: targetCoinType,
            packages: router.packages
          },
          txb
        );
      }
    }
  }
  async mergeSwap(params) {
    const { router, inputCoins, slippage, txb, partner } = params;
    if (slippage > 1 || slippage < 0) {
      throw new Error(CLIENT_CONFIG.ERRORS.INVALID_SLIPPAGE);
    }
    if (!router.packages || !router.packages.get(PACKAGE_NAMES.AGGREGATOR_V3)) {
      throw new Error(CLIENT_CONFIG.ERRORS.PACKAGES_REQUIRED);
    }
    if (!router.allRoutes || router.allRoutes.length === 0) {
      throw new Error("No routes found in merge swap response");
    }
    const outputCoins = [];
    for (let i = 0; i < router.allRoutes.length && i < inputCoins.length; i++) {
      const route = router.allRoutes[i];
      const inputCoin = inputCoins[i];
      const routeRouter = {
        quoteID: router.quoteID,
        amountIn: route.amountIn,
        amountOut: route.amountOut,
        deviationRatio: Number(route.deviationRatio),
        byAmountIn: true,
        // Merge swap is always by amount in
        paths: route.paths,
        insufficientLiquidity: false,
        packages: router.packages
      };
      const routerParams = {
        router: routeRouter,
        inputCoin: inputCoin.coin,
        slippage,
        txb,
        partner: partner ?? this.partner
      };
      const outputCoin = await this.routerSwap(routerParams);
      outputCoins.push(outputCoin);
    }
    if (outputCoins.length === 0) {
      throw new Error("No output coins generated from merge swap");
    }
    let finalOutputCoin = outputCoins[0];
    if (outputCoins.length > 1) {
      txb.mergeCoins(finalOutputCoin, outputCoins.slice(1));
    }
    return finalOutputCoin;
  }
  async fastMergeSwap(params) {
    const { router, slippage, txb, partner } = params;
    if (!router || !router.allRoutes || router.allRoutes.length === 0) {
      throw new Error("Invalid router: no routes found");
    }
    const firstRoute = router.allRoutes[0];
    const targetCoinType = firstRoute.paths[firstRoute.paths.length - 1].target;
    const inputCoins = [];
    const coinTypeSet = /* @__PURE__ */ new Set();
    for (const route of router.allRoutes) {
      const firstCoinType = route.paths[0].from;
      if (coinTypeSet.has(firstCoinType)) {
        continue;
      }
      coinTypeSet.add(firstCoinType);
      const coin = coinWithBalance({
        balance: BigInt(route.amountIn.toString()),
        useGasCoin: CoinUtils.isSuiCoin(firstCoinType),
        type: firstCoinType
      });
      inputCoins.push({ coinType: firstCoinType, coin });
    }
    const mergeSwapParams = {
      router,
      inputCoins,
      slippage,
      txb,
      partner: partner ?? this.partner
    };
    const targetCoin = await this.mergeSwap(mergeSwapParams);
    if (CoinUtils.isSuiCoin(targetCoinType)) {
      txb.mergeCoins(txb.gas, [targetCoin]);
    } else {
      const targetCoinObjID = await this.getOneCoinUsedToMerge(targetCoinType);
      if (targetCoinObjID != null) {
        txb.mergeCoins(txb.object(targetCoinObjID), [targetCoin]);
      } else {
        transferOrDestroyCoin(
          {
            coin: targetCoin,
            coinType: targetCoinType,
            packages: router.packages
          },
          txb
        );
      }
    }
  }
  async fixableRouterSwapV3(params) {
    const { router, inputCoin, slippage, txb, partner } = params;
    checkOverlayFeeConfig(this.overlayFeeRate, this.overlayFeeReceiver);
    let overlayFee = 0;
    if (router.byAmountIn) {
      overlayFee = Number(
        router.amountOut.mul(new import_bn6.default(this.overlayFeeRate)).div(new import_bn6.default(1e6)).toString()
      );
    } else {
      overlayFee = Number(
        router.amountIn.mul(new import_bn6.default(this.overlayFeeRate)).div(new import_bn6.default(1e6)).toString()
      );
    }
    const expectedAmountOut = router.byAmountIn ? router.amountOut.sub(new import_bn6.default(overlayFee)) : router.amountOut;
    const expectedAmountIn = router.byAmountIn ? router.amountIn : router.amountIn.add(new import_bn6.default(overlayFee));
    const amountLimit = CalculateAmountLimitBN(
      router.byAmountIn ? expectedAmountOut : expectedAmountIn,
      router.byAmountIn,
      slippage
    );
    const priceIDs = findPythPriceIDs(router.paths);
    const priceInfoObjectIds = priceIDs.length > 0 ? await this.updatePythPriceIDs(priceIDs, txb) : /* @__PURE__ */ new Map();
    if (router.byAmountIn) {
      return this.expectInputSwapV3(
        txb,
        inputCoin,
        router,
        expectedAmountOut.toString(),
        amountLimit.toString(),
        priceInfoObjectIds,
        partner ?? this.partner
      );
    } else {
      return this.expectOutputSwapV3(
        txb,
        inputCoin,
        router,
        expectedAmountOut.toString(),
        amountLimit.toString(),
        partner ?? this.partner
      );
    }
  }
  async swapInPools(params) {
    const { from, target, amount, byAmountIn, pools } = params;
    const fromCoin = completionCoin(from);
    const targetCoin = completionCoin(target);
    const tx = new Transaction();
    const direction = compareCoins(fromCoin, targetCoin);
    const coinA = direction ? fromCoin : targetCoin;
    const coinB = direction ? targetCoin : fromCoin;
    const typeArguments = [coinA, coinB];
    const integratePublishedAt = this.env === 0 /* Mainnet */ ? "0xfbb32ac0fa89a3cb0c56c745b688c6d2a53ac8e43447119ad822763997ffb9c3" : "0xab2d58dd28ff0dc19b18ab2c634397b785a38c342a8f5065ade5f53f9dbffa1c";
    for (let i = 0; i < pools.length; i++) {
      const args = [
        tx.object(pools[i]),
        tx.pure.bool(direction),
        tx.pure.bool(byAmountIn),
        tx.pure.u64(amount.toString())
      ];
      tx.moveCall({
        target: `${integratePublishedAt}::fetcher_script::calculate_swap_result`,
        arguments: args,
        typeArguments
      });
    }
    tx.setSenderIfNotSet(this.signer || "0x0");
    const simulateRes = await this.client.simulateTransaction({
      transaction: tx,
      include: { events: true, effects: true }
    });
    const txResult = simulateRes.Transaction ?? simulateRes.FailedTransaction;
    if (!txResult || simulateRes.$kind === "FailedTransaction") {
      const errorMsg = txResult?.status.success === false ? txResult.status.error.message : "Unknown error";
      throw new Error("Simulation error: " + errorMsg);
    }
    const events = txResult.events ?? [];
    const valueData = events.filter((item) => {
      return item.eventType.includes("CalculatedSwapResultEvent");
    });
    if (valueData.length === 0 || valueData.length !== pools.length) {
      throw new Error("Simulate event result error");
    }
    let tempMaxAmount = byAmountIn ? new import_bn6.default(0) : new import_bn6.default(U64_MAX);
    let tempIndex = 0;
    for (let i = 0; i < valueData.length; i += 1) {
      const eventJson2 = valueData[i].json;
      if (eventJson2?.data?.is_exceed) {
        continue;
      }
      if (params.byAmountIn) {
        const amount2 = new import_bn6.default(eventJson2?.data?.amount_out ?? 0);
        if (amount2.gt(tempMaxAmount)) {
          tempIndex = i;
          tempMaxAmount = amount2;
        }
      } else {
        const amount2 = new import_bn6.default(eventJson2?.data?.amount_out ?? 0);
        if (amount2.lt(tempMaxAmount)) {
          tempIndex = i;
          tempMaxAmount = amount2;
        }
      }
    }
    const eventJson = valueData[tempIndex].json;
    const eventData = eventJson?.data;
    const [decimalA, decimalB] = await Promise.all([
      this.client.getCoinMetadata({ coinType: coinA }).then((res) => res.coinMetadata?.decimals ?? null),
      this.client.getCoinMetadata({ coinType: coinB }).then((res) => res.coinMetadata?.decimals ?? null)
    ]);
    if (decimalA == null || decimalB == null) {
      throw new Error("Cannot get coin decimals");
    }
    const feeRate = Number(eventData?.fee_rate ?? 0) / 1e6;
    const pureAmountIn = new import_bn6.default(eventData?.amount_in ?? 0);
    const feeAmount = new import_bn6.default(eventData?.fee_amount ?? 0);
    const amountIn = pureAmountIn.add(feeAmount);
    const cetusRouterV3PublishedAt = this.env === 0 /* Mainnet */ ? MAINNET_CETUS_V3_PUBLISHED_AT : TESTNET_CETUS_V3_PUBLISHED_AT;
    const aggregatorV3PublishedAt = this.env === 0 /* Mainnet */ ? AGGREGATOR_V3_CONFIG.DEFAULT_PUBLISHED_AT.Mainnet : AGGREGATOR_V3_CONFIG.DEFAULT_PUBLISHED_AT.Testnet;
    const routeData = {
      amountIn,
      amountOut: new import_bn6.default(eventData?.amount_out ?? 0),
      deviationRatio: 0,
      paths: [
        {
          id: pools[tempIndex],
          direction,
          provider: CETUS,
          from: fromCoin,
          target: targetCoin,
          feeRate,
          amountIn: amountIn.toString(),
          amountOut: eventData?.amount_out ?? "0",
          publishedAt: cetusRouterV3PublishedAt,
          extendedDetails: {
            afterSqrtPrice: eventData?.after_sqrt_price
          }
        }
      ],
      insufficientLiquidity: false,
      byAmountIn: params.byAmountIn,
      quoteID: `degraded-${generateUUID()}`,
      packages: /* @__PURE__ */ new Map([
        [
          PACKAGE_NAMES.AGGREGATOR_V3,
          aggregatorV3PublishedAt
        ]
      ])
    };
    const result = {
      isExceed: eventData?.is_exceed ?? false,
      routeData
    };
    return result;
  }
  async updatePythPriceIDs(priceIDs, txb) {
    const priceUpdateData = await this.pythAdapter.getPriceFeedsUpdateData(priceIDs);
    let priceInfoObjectIds;
    try {
      priceInfoObjectIds = await this.pythAdapter.updatePriceFeeds(
        txb,
        priceUpdateData,
        priceIDs
      );
    } catch (e) {
      throw new Error(
        `Failed to update Pyth price feeds. Ensure pythUrls are configured correctly. Detailed error: ${e}`
      );
    }
    const priceInfoObjectIdsMap = /* @__PURE__ */ new Map();
    for (let i = 0; i < priceIDs.length; i++) {
      priceInfoObjectIdsMap.set(priceIDs[i], priceInfoObjectIds[i]);
    }
    return priceInfoObjectIdsMap;
  }
  async devInspectTransactionBlock(txb) {
    txb.setSenderIfNotSet(this.signer || "0x0");
    const res = await this.client.simulateTransaction({
      transaction: txb,
      include: { events: true, effects: true }
    });
    return res;
  }
  async sendTransaction(txb, signer) {
    const res = await this.client.signAndExecuteTransaction({
      transaction: txb,
      signer,
      include: { effects: true, events: true, balanceChanges: true }
    });
    return res;
  }
};
_AggregatorClient.CONFIG = {
  [1 /* Testnet */]: {
    wormholeStateId: "0x31358d198147da50db32eda2562951d53973a0c0ad5ed738e9b17d88b213d790",
    pythStateId: "0x243759059f4c3111179da5878c12f68d612c21a8d54d85edc86164bb18be1c7c"
  },
  [0 /* Mainnet */]: {
    wormholeStateId: "0xaeab97f96cf9877fee2883315d459552b2b921edc16d7ceac6eab944dd88919c",
    pythStateId: "0x1f9310238ee9298fb703c3419030b35b22bb1cc37113e3bb5007c99aec79e5b8"
  }
};
var AggregatorClient = _AggregatorClient;
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
function recordFirstCoinIndex(paths) {
  let newCoinRecord = /* @__PURE__ */ new Map();
  for (let i = 0; i < paths.length; i++) {
    if (!newCoinRecord.has(paths[i].from)) {
      newCoinRecord.set(paths[i].from, i);
    }
  }
  return newCoinRecord;
}
function checkOverlayFeeConfig(overlayFeeRate, overlayFeeReceiver) {
  if (overlayFeeRate > CLIENT_CONFIG.MAX_OVERLAY_FEE_RATE_NUMERATOR) {
    throw new Error(CLIENT_CONFIG.ERRORS.INVALID_OVERLAY_FEE_RATE);
  }
  if (overlayFeeReceiver === "0x0" && overlayFeeRate > 0) {
    throw new Error(
      CLIENT_CONFIG.ERRORS.OVERLAY_FEE_RECEIVER_REQUIRED
    );
  }
}

// src/types/sui.ts
var getDefaultSuiInputType = (value) => {
  if (typeof value === "string" && value.startsWith("0x")) {
    return "object";
  }
  if (typeof value === "number" || typeof value === "bigint") {
    return "u64";
  }
  if (typeof value === "boolean") {
    return "bool";
  }
  throw new AggregatorError(
    `Unknown type for value: ${value}`,
    "InvalidType" /* InvalidType */
  );
};
/*! Bundled license information:

decimal.js/decimal.mjs:
  (*!
   *  decimal.js v10.6.0
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   *)
*/

export { AFSUI, AFTERMATH, AFTERMATH_AMM, AFTERMATH_MODULE, AGGREGATOR, AGGREGATOR_V3_CONFIG, ALL_DEXES, ALPHAFI, AggregatorClient, AggregatorConfig, AggregatorError, AggregatorServerErrorCode, BLUEFIN, BLUEMOVE, CETUS, CETUSDLMM, CETUS_DEX, CETUS_MODULE, CETUS_PUBLISHED_AT, CHECK_COINS_THRESHOLD_FUNC, CLIENT_CONFIG, CLOCK_ADDRESS, CoinInfoAddress, CoinStoreAddress, CoinUtils, ConfigErrorCode, DEEPBOOKV2, DEEPBOOKV3, DEEPBOOK_CLOB_V2_MODULE, DEEPBOOK_CUSTODIAN_V2_MODULE, DEEPBOOK_DEX, DEEPBOOK_MODULE, DEEPBOOK_PACKAGE_ID, DEEPBOOK_PUBLISHED_AT, DEEPBOOK_V3_DEEP_FEE_TYPES, DEFAULT_AGG_V2_ENDPOINT, DEFAULT_AGG_V3_ENDPOINT, DEFAULT_ENDPOINT, DEFAULT_GAS_BUDGET_FOR_MERGE, DEFAULT_GAS_BUDGET_FOR_SPLIT, DEFAULT_GAS_BUDGET_FOR_STAKE, DEFAULT_GAS_BUDGET_FOR_TRANSFER, DEFAULT_GAS_BUDGET_FOR_TRANSFER_SUI, DEFAULT_NFT_TRANSFER_GAS_FEE, Env, FERRACLMM, FERRADLMM, FLOWXV2, FLOWXV3, FLOWX_AMM, FLOWX_AMM_MODULE, FULLSAIL, FlashSwapA2BFunc, FlashSwapB2AFunc, FlashSwapFunc, FlashSwapWithPartnerA2BFunc, FlashSwapWithPartnerB2AFunc, FlashSwapWithPartnerFunc, GAS_SYMBOL, GAS_TYPE_ARG, GAS_TYPE_ARG_LONG, HAEDAL, HAEDALHMMV2, HAEDALPMM, HAWAL, INTEGRATE, JOIN_FUNC, KRIYA, KRIYAV3, KRIYA_DEX, KRIYA_MODULE, MAGMA, MAINNET_AFTERMATH_INSURANCE_FUND_ID, MAINNET_AFTERMATH_PROTOCOL_FEE_VAULT_ID, MAINNET_AFTERMATH_REFERRAL_VAULT_ID, MAINNET_AFTERMATH_REGISTRY_ID, MAINNET_AFTERMATH_TREASURY_ID, MAINNET_CETUS_V3_PUBLISHED_AT, MAINNET_FLOWX_AMM_CONTAINER_ID, METASTABLE, MOMENTUM, OBRIC, ONE, PACKAGE_NAMES, PAY_MODULE, POOL_MODULT, PUBLISHED_ADDRESSES, PYTH_CONFIG, REPAY_FLASH_SWAP_A2B_FUNC, REPAY_FLASH_SWAP_B2A_FUNC, REPAY_FLASH_SWAP_WITH_PARTNER_A2B_FUNC, REPAY_FLASH_SWAP_WITH_PARTNER_B2A_FUNC, RepayFalshSwapFunc, RepayFlashSwapWithPartnerFunc, SCALLOP, SEVENK, SPRINGSUI, STEAMM, STEAMM_OMM, STEAMM_OMM_V2, SUILEND, SUI_SYSTEM_STATE_OBJECT_ID, SWAP_A2B_FUNC, SWAP_B2A_FUNC, SuiZeroCoinFn, TEN_POW_NINE, TESTNET_AFTERMATH_INSURANCE_FUND_ID, TESTNET_AFTERMATH_PROTOCOL_FEE_VAULT_ID, TESTNET_AFTERMATH_REFERRAL_VAULT_ID, TESTNET_AFTERMATH_REGISTRY_ID, TESTNET_AFTERMATH_TREASURY_ID, TESTNET_CETUS_V3_PUBLISHED_AT, TESTNET_FLOWX_AMM_CONTAINER_ID, TRANSFER_ACCOUNT_CAP, TRANSFER_OR_DESTORY_COIN_FUNC, TURBOS, TURBOS_DEX, TURBOS_MODULE, TURBOS_VERSIONED, TWO, TransactionErrorCode, TypesErrorCode, U128, U64_MAX, U64_MAX_BN, UTILS_MODULE, VOLO, ZERO, buildInputCoin, calculateGasEfficiency, calculatePriceImpact, checkInvalidSuiAddress, compareCoins, compareGasMetrics, completionCoin, composeType, createTarget, dealWithFastRouterSwapParamsForMsafe, exportToCSV, exportToJSON, extractAddressFromType, extractGasMetrics, extractStructTagFromType, extractTimestampFromDowngradeUuid6, fixSuiObjectId, formatGasMetrics, generateDowngradeUuid6, generateSimpleDowngradeUuid6, getAggregatorServerErrorMessage, getAggregatorV2Extend2PublishedAt, getAggregatorV2ExtendPublishedAt, getAggregatorV2PublishedAt, getAllProviders, getDeepbookV3Config, getDefaultSuiInputType, getMergeSwapResult, getOrCreateAccountCap, getProvidersExcluding, getProvidersIncluding, getRouterResult, isSortedSymbols, isValidDowngradeUuid6, mintZeroCoin, normalizeCoinType, parseAftermathFeeType, parseTurbosPoolFeeType, patchFixSuiObjectId, printTransaction, processEndpoint, processFlattenRoutes, restituteMsafeFastRouterSwapParams };
